<template>

 <div :style="{'height':this.$store.state.globeSceneFullScreen || this.$store.state.openSource === 'windows' ? '100vh' : 'calc(100vh - 50px)',
 'margin-top':this.$store.state.globeSceneFullScreen || this.$store.state.openSource === 'windows' ? '0' : '50px'}"
       style="width:100%;display:flex;">
    <div v-show="!$store.state.globeSceneFullScreen && this.$store.state.openSource !== 'windows'"
         style="position:relative;width:110px;height:100%;padding-bottom:13px;background:#2A2A2A;border-right:1px solid #4a4a4a;display:flex;flex-direction:column;z-index:5">

<!--      &lt;!&ndash;旧版侧边栏&ndash;&gt;-->
<!--      <v-tooltip open-delay="0" right nudge-left="5" max-width="300" color="rgba(0, 0, 0, 0.8)">-->
<!--        <template v-slot:activator="{ on, attrs }">-->
<!--          <p @click="clickLeftBar('imageLib')" v-bind="attrs" v-on="on" :style="{'background':mainArea === 'imageLib' ? '#383838' : 'transparent'}" class="leftBarTabItem iconfontFamily">&#xe61c;</p>-->
<!--        </template>-->
<!--        <span>影像库</span>-->
<!--      </v-tooltip>-->
<!--      <v-tooltip open-delay="0" right nudge-left="5" max-width="300" color="rgba(0, 0, 0, 0.8)">-->
<!--        <template v-slot:activator="{ on, attrs }">-->
<!--          <p @click="clickLeftBar('globeOperation')" v-bind="attrs" v-on="on" :style="{'background':mainArea === 'globeOperation' ? '#383838' : 'transparent'}" class="leftBarTabItem iconfontFamily">&#xe636;</p>-->
<!--        </template>-->
<!--        <span>地球创作台</span>-->
<!--      </v-tooltip>-->
<!--      <v-tooltip open-delay="0" right nudge-left="5" max-width="300" color="rgba(0, 0, 0, 0.8)">-->
<!--        <template v-slot:activator="{ on, attrs }">-->
<!--          <p @click="clickLeftBar('like')" v-bind="attrs" v-on="on" :style="{'background':mainArea === 'like' ? '#383838' : 'transparent'}" class="leftBarTabItem iconfontFamily">&#xe639;</p>-->
<!--        </template>-->
<!--        <span>我的收藏</span>-->
<!--      </v-tooltip>-->
<!--      <v-tooltip open-delay="0" right nudge-left="5" max-width="300" color="rgba(0, 0, 0, 0.8)">-->
<!--        <template v-slot:activator="{ on, attrs }">-->
<!--          <p @click="clickLeftBar('download')" v-bind="attrs" v-on="on" :style="{'background':mainArea === 'download' ? '#383838' : 'transparent'}" class="leftBarTabItem iconfontFamily">&#xe638;</p>-->
<!--        </template>-->
<!--        <span>我的下载</span>-->
<!--      </v-tooltip>-->

<!--      <v-tooltip open-delay="0" right nudge-left="5" max-width="300" color="rgba(0, 0, 0, 0.8)">-->
<!--        <template v-slot:activator="{ on, attrs }">-->
<!--          <p @click="playFirstGuideVideo" v-bind="attrs" v-on="on"-->
<!--             style="position:absolute;bottom:0;left:0;width: 100%;height: 60px;line-height:60px;text-align:center;font-size:22px;color:#ffffff;"-->
<!--             class="iconfontFamily">&#xe6a5;</p>-->
<!--        </template>-->
<!--        <span>帮助</span>-->
<!--      </v-tooltip>-->





      <!--创作-->
      <div v-show="mainAreaBottomType==='globeOperation'">
        <div @click="clickLeftBar('globeOperation')" style="position:relative;">
          <p :style="{'color':mainArea === 'globeOperation' ? '#4DA0FF' : '#ffffff'}" class="leftBarTabItem_new">标记创作</p>
          <div :style="{'display':mainArea === 'globeOperation' ? 'block' : 'none'}" style="position:absolute;bottom:4px;left:50%;transform:translate(-50%,0);width:16px;height:3px;background:#4DA0FF;"></div>
        </div>
        <div @click="clickLeftBar('globeScene')" style="position:relative;">
          <p :style="{'color':mainArea === 'globeScene' ? '#4DA0FF' : '#ffffff'}" class="leftBarTabItem_new">地球录制</p>
          <div :style="{'display':mainArea === 'globeScene' ? 'block' : 'none'}" style="position:absolute;bottom:4px;left:50%;transform:translate(-50%,0);width:16px;height:3px;background:#4DA0FF;"></div>
        </div>
        <div @click="clickLeftBar('AI')" style="position:relative;">
          <p :style="{'color':mainArea === 'AI' ? '#4DA0FF' : '#ffffff'}" class="leftBarTabItem_new">AI工具</p>
          <div :style="{'display':mainArea === 'AI' ? 'block' : 'none'}" style="position:absolute;bottom:4px;left:50%;transform:translate(-50%,0);width:16px;height:3px;background:#4DA0FF;"></div>
        </div>
      </div>
      <!--文件-->
      <div v-show="mainAreaBottomType==='folder'">
        <div @click="clickLeftBar('myFolder')" style="position:relative;">
          <p :style="{'color':mainArea === 'myFolder' ? '#4DA0FF' : '#ffffff'}" class="leftBarTabItem_new">我的文件</p>
          <div :style="{'display':mainArea === 'myFolder' ? 'block' : 'none'}" style="position:absolute;bottom:4px;left:50%;transform:translate(-50%,0);width:16px;height:3px;background:#4DA0FF;"></div>
        </div>
        <div @click="clickLeftBar('myFolderAITrip')" style="position:relative;">
          <p :style="{'color':mainArea === 'myFolderAITrip' ? '#4DA0FF' : '#ffffff'}" class="leftBarTabItem_new">星旅记录</p>
          <div :style="{'display':mainArea === 'myFolderAITrip' ? 'block' : 'none'}" style="position:absolute;bottom:4px;left:50%;transform:translate(-50%,0);width:16px;height:3px;background:#4DA0FF;"></div>
        </div>
        <!--我的收藏暂不可用 @click="clickLeftBar('myLikeFolder')"-->
        <div @click="clickLeftBar('myFolderLike')" style="position:relative;">
          <p :style="{'color':mainArea === 'myFolderLike' ? '#4DA0FF' : '#ffffff'}" class="leftBarTabItem_new">我的收藏</p>
          <div :style="{'display':mainArea === 'myFolderLike' ? 'block' : 'none'}" style="position:absolute;bottom:4px;left:50%;transform:translate(-50%,0);width:16px;height:3px;background:#4DA0FF;"></div>
        </div>
      </div>


      <v-spacer></v-spacer>

      <!--下方类型切换-->
      <div @click="clickLeftBarBottomType('globeOperation')" class="leftBarTabItem_bottomType"
           :style="{'background':mainAreaBottomType==='globeOperation' ? '#383838' : 'transparent',
           'border-left':mainAreaBottomType==='globeOperation' ? '7px solid #1F73B8' : '7px solid transparent',
           'color':mainAreaBottomType==='globeOperation' ? '#ffffff' : '#a6a6a6',}">
        <p style="font-size:18px;" class="iconfontFamily">&#xe636;</p>
        <p style="margin-left:12px;font-size:18px;">创作</p>
      </div>
      <div @click="clickLeftBarBottomType('folder')" class="leftBarTabItem_bottomType"
           :style="{'background':mainAreaBottomType==='folder' ? '#383838' : 'transparent',
           'border-left':mainAreaBottomType==='folder' ? '7px solid #1F73B8' : '7px solid transparent',
           'color':mainAreaBottomType==='folder' ? '#ffffff' : '#a6a6a6',}">
        <p style="font-size:22px;" class="iconfontFamily">&#xe78c;</p>
        <p style="margin-left:9px;font-size:18px;">文件</p>
      </div>



    </div>


<!--    <p @click="imageUrlToBase64">转图片</p>-->

    <div v-show="!$store.state.globeSceneFullScreen && !globeFullScreen" style="width:340px;height:100%;background:#383838;border-right:1px solid #4a4a4a;">
      <!--旧版-影像集-->
      <main-image-lib ref="mainImageLib" v-if="mainArea === 'imageLib'" @showFolderMarker="showFolderMarker" @showImageMarker="showImageMarker" @addImageMarker="addImageMarker"
                      @showImagePreview="showImagePreview" @quitPreviewLeftBar="quitPreviewLeftBar" @leftBarDestroy="leftBarDestroy"
                      :previewImageId="preview_imageId"></main-image-lib>
      <!--旧版-影像集收藏-->
      <main-like v-if="mainArea === 'like'" @showImageMarker="showImageMarker" @showImagePreview="showImagePreview" @showFolderStopDialog="showFolderStopDialog"
                 @quitPreviewLeftBar="quitPreviewLeftBar" @leftBarDestroy="leftBarDestroy" :previewImageId="preview_imageId"></main-like>
      <!--旧版-影像集下载-->
      <main-download v-if="mainArea === 'download'" @showImageMarker="showImageMarker" @showImagePreview="showImagePreview" @showFolderStopDialog="showFolderStopDialog"
                     @quitPreviewLeftBar="quitPreviewLeftBar" @leftBarDestroy="leftBarDestroy" :previewImageId="preview_imageId"></main-download>


      <!--标记创作 :smallGlobeMapInit="smallGlobeMapInit"-->
      <main-globe-operation ref="mainGlobeOperation" v-if="mainArea === 'globeOperation'" @flyToPosition="flyToPosition"
                            :mapboxInit="mapboxInit"
                            @leftBarDestroy="leftBarDestroy" @openGlobeSet="openGlobeSet" @openMarkerGuideVideo="openMarkerGuideVideo" @nodeMouseout="nodeMouseout"
                            @nodeMouseover="nodeMouseover" @initMapMarker="clearExistingData" @setLayerVisible="hideLayer('visible')" @openNotSavedDialog="notSavedDialog = true"
                            @isShowDataListEffect="isShowDataListEffect" @pushNoReadData="pushNoReadData" @refreshMessage="refreshMessage" @goToMyFolder="goToMyFolder"></main-globe-operation>
      <!--地球录制 v-if="mainArea === 'globeScene'"-->
<!--      <main-globe-scene ref="mainGlobeScene" v-if="mainArea === 'globeScene'" @leftBarDestroy="leftBarDestroy" @openSceneGuideVideo="openSceneGuideVideo"-->
<!--                        @previewSceneItem="previewSceneItem" @previewFlyAnimation="previewFlyAnimation" @openGlobeSet="openGlobeSet"></main-globe-scene>-->
      <!--地球录制 敬请期待-->
      <main-globe-scene-default v-if="mainArea === 'globeScene'"></main-globe-scene-default>


      <!--AI工具-->
      <main-a-i v-if="mainArea === 'AI'"></main-a-i>


      <!--我的文件-->
      <main-my-folder v-if="mainArea === 'myFolder'" @flyToFolderFirstMarker="flyToMyFolderFirstMarker" @showMyFolderEditIcon="showMyFolderEditIcon" @hideMyFolderEditIcon="hideMyFolderEditIcon"
                      @setOriginalPositionAndClearLayers="setOriginalPositionAndClearLayers" @leftBarDestroy="leftBarDestroy" @deleteOpenFile="deleteOpenFile"></main-my-folder>

      <!--我的收藏-->
      <main-like v-if="mainArea === 'myFolderLike'"></main-like>

      <!--AITrip行程-->
      <main-folder-a-i-trip v-if="mainArea === 'myFolderAITrip'" @flyToFolderFirstMarker="flyToMyFolderFirstMarker" @showMyFolderEditIcon="showMyFolderEditIcon" @hideMyFolderEditIcon="hideMyFolderEditIcon"
                            @setOriginalPositionAndClearLayers="setOriginalPositionAndClearLayers" @leftBarDestroy="leftBarDestroy" @deleteOpenFile="deleteOpenFile"></main-folder-a-i-trip>

    </div>





    <!--地图-->
    <div :style="{'width':$store.state.globeSceneFullScreen ? '100%'
    : globeFullScreen ? this.$store.state.openSource === 'windows' ? '100%' : 'calc(100% - 110px)'
    : this.$store.state.openSource === 'windows' ? 'calc(100% - 340px)' : 'calc(100% - 110px - 340px)',
    'animation-name':animationAllScreenMapMantleName,'animation-duration':animationAllScreenMapMantleDuration}"
         style="position:relative;height:100%;">
      <div ref="globeMap" id="globeMap" style="position:absolute;top:0;left:0;width:100%;height:100%;background:#000000;z-index:0">
        <!--地图信息-->
        <div v-show="!this.$store.state.globeSceneFullScreen" class="mapboxInfo px-5">
          <p style="line-height:25px;">吉林一号·共生地球  {{currLayerNumber}}</p>
          <v-spacer></v-spacer>
          <p style="line-height:25px;"><span v-show="mapInfoCameraElevation !== ''">Camera: {{mapInfoCameraElevation}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>{{mapInfoLng}}&nbsp;&nbsp;&nbsp;{{mapInfoLat}}</p>
        </div>
      </div>

      <draw-canvas v-if="$store.state.isDrawingCanvas" style="position:absolute;top:0;left:0;width:100%;height:100%;"></draw-canvas>


      <!--全屏按钮-->
      <div @click="changeFullScreenStatus" v-show="!this.$store.state.globeSceneFullScreen" class="globeFullScreenBtn">
        <p :style="{'color':globeFullScreen ? '#04BEFE' : '#ffffff'}" style="line-height:40px;font-size:16px;cursor:pointer;" class="iconfontFamily">&#xe604;</p>
      </div>

      <!--旧版小地球等操作栏-->
<!--      <div :style="{'visibility':!this.$store.state.globeSceneFullScreen ? 'visible' : 'hidden'}"-->
<!--           style="position:absolute;right:24px;bottom:43px;width:145px;">-->
<!--        &lt;!&ndash;小地球&ndash;&gt;-->
<!--        <div style="position:absolute;bottom:0;right:0;width:80px;height:80px;overflow:hidden;">-->
<!--          <div id="smallGlobeMap" style="width:160px;height:160px;margin-bottom:-80px;margin-right:-80px;"></div>-->
<!--        </div>-->
<!--        &lt;!&ndash;操作按钮&ndash;&gt;-->
<!--        <div @click="resetBearing" class="toolbar-item" style="bottom:0;left:0;">-->
<!--          <p :style="{'transform':'rotate(-' + getCompassRotate + 'deg)'}" style="line-height:40px;font-size:20px;color:#ffffff;cursor:pointer;" class="iconfontFamily">&#xe63e;</p>-->
<!--        </div>-->
<!--        <div @click="getLocation" class="toolbar-item" style="bottom:56px;left:8px;">-->
<!--          <p style="line-height:40px;font-size:21px;color:#ffffff;cursor:pointer;" class="iconfontFamily">&#xe622;</p>-->
<!--        </div>-->
<!--        <div @click="goHome" class="toolbar-item" style="bottom:97px;left:50px;">-->
<!--          <p style="line-height:40px;font-size:20px;color:#ffffff;cursor:pointer;" class="iconfontFamily">&#xe63d;</p>-->
<!--        </div>-->
<!--        <v-menu top left offset-x offset-y nudge-top="10" nudge-right="50">-->
<!--          <template v-slot:activator="{ on, attrs }">-->
<!--            <div v-bind="attrs" v-on="on" class="toolbar-item" style="bottom:105px;left:111px;">-->
<!--              <p style="line-height:40px;font-size:20px;color:#ffffff;cursor:pointer;" class="iconfontFamily">&#xe641;</p>-->
<!--            </div>-->
<!--          </template>-->
<!--          &lt;!&ndash;图层列表&ndash;&gt;-->
<!--          <div style="width:120px;padding:10px 10px 10px 10px;background:#383838;border-radius:4px;box-shadow:0px 2px 4px 0px rgba(0, 0, 0, 0.75);">-->
<!--            <div @click="changeLayer(item.layerName)" v-for="(item,index) in globeLayerList" :key="'layer'+index" class="changeLayerItem"-->
<!--                 :style="{'border':currLayerName===item.layerName ? '2px solid #315D8E' : 'none',-->
<!--               'background-image':'url(' + item.thumb + ')','margin-bottom':index === globeLayerList.length - 1 ? '0' : '10px'}">-->
<!--              <div :style="{'display':currLayerName===item.layerName?'block':'none'}" class="changeLayerItem-roadBtn">-->
<!--                <v-checkbox v-model="globeLayerListRoadShow" label="显示路网" dense hide-details dark color="#aaaaaa" style="margin-top:-2px;"></v-checkbox>-->
<!--              </div>-->
<!--              <div :style="{'background':currLayerName===item.layerName ? '#315D8E' : 'rgba(0, 0, 0, 0.6)'}" class="changeLayerItem-layerText">-->
<!--                <p>{{item.layerText}}</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </v-menu>-->

<!--      </div>-->

      <!--新版操作栏-->
      <div :style="{'visibility':!this.$store.state.globeSceneFullScreen ? 'visible' : 'hidden'}"
           style="position:absolute;right:24px;bottom:43px;width:40px;">

        <div @click="resetBearing" class="toolbar-item" style="bottom:0;left:0;">
          <p :style="{'transform':'rotate(-' + getCompassRotate + 'deg)'}" style="line-height:40px;font-size:20px;color:#ffffff;cursor:pointer;" class="iconfontFamily">&#xe63e;</p>
        </div>
        <div @click="getLocation" class="toolbar-item" style="bottom:56px;left:0px;">
          <p style="line-height:40px;font-size:21px;color:#ffffff;cursor:pointer;" class="iconfontFamily">&#xe622;</p>
        </div>
        <div @click="goHome" class="toolbar-item" style="bottom:112px;left:0px;">
          <p style="line-height:40px;font-size:20px;color:#ffffff;cursor:pointer;" class="iconfontFamily">&#xe63d;</p>
        </div>

        <v-menu :disabled="$store.state.isDrawingCanvas" top left offset-x offset-y nudge-top="10" nudge-right="50">
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="toolbar-item" style="bottom:168px;left:0px;">
              <p style="line-height:40px;font-size:20px;color:#ffffff;cursor:pointer;" class="iconfontFamily">&#xe641;</p>
            </div>
          </template>
          <!--图层列表-->
          <div style="width:120px;max-height:500px;padding:10px 10px 10px 10px;background:#383838;border-radius:4px;box-shadow:0px 2px 4px 0px rgba(0, 0, 0, 0.75);overflow:auto;" class="myScrollArea">
            <div @click="changeLayer(item.layer)" v-for="(item,index) in $utils.layerList" :key="'layer'+index" class="changeLayerItem"
                 :style="{'border':currLayerName===item.layer ? '2px solid #315D8E' : 'none',
               'background-image':'url(' + item.thumb + ')','margin-bottom':index === $utils.layerList.length - 1 ? '0' : '10px'}">
              <div :style="{'display':currLayerName===item.layer?'block':'none'}" class="changeLayerItem-roadBtn">
                <v-checkbox v-model="globeLayerListRoadShow" label="显示路网" dense hide-details dark color="#aaaaaa" style="margin-top:-2px;"></v-checkbox>
              </div>
              <div :style="{'background':currLayerName===item.layer ? '#315D8E' : 'rgba(0, 0, 0, 0.6)'}" class="changeLayerItem-layerText">
                <p>{{item.shortName}}</p>
              </div>
            </div>
          </div>
        </v-menu>

      </div>




      <!--地图上影像集图标-->
      <folder-marker-entry v-if="folderMarkerShow" :folderMarkerSize="folderMarkerSize" :folderMarkerList="folderMarkerList" @clickFolderMarker="clickFolderMarker"></folder-marker-entry>

      <!--地图上影像集图标-->
      <image-marker-entry v-if="imageMarkerShow" :imageMarkerList="imageMarkerList" @clickImageMarker="clickImageMarker"></image-marker-entry>

      <marker-name-entry :markerNameList="measureLengthJson_xzt.measurePoint.features"></marker-name-entry>

      <!--地球上预览边框+录制操作边框-->
      <div v-if="$store.state.imagePreviewShow || $store.state.scenePointEditing" style="position:relative;width: 100%;height: 100%;pointer-events: none;">
        <div style="position:absolute;top:0;left:0;width:8px;height:250px;background:#2A82E4;"></div>
        <div style="position:absolute;top:0;left:0;width:250px;height:8px;background:#2A82E4;"></div>
        <div style="position:absolute;top:0;right:0;width:8px;height:250px;background:#2A82E4;"></div>
        <div style="position:absolute;top:0;right:0;width:250px;height:8px;background:#2A82E4;"></div>
        <div style="position:absolute;bottom:25px;left:0px;width:8px;height:250px;background:#2A82E4;"></div>
        <div style="position:absolute;bottom:25px;left:0px;width:250px;height:8px;background:#2A82E4;"></div>
        <div style="position:absolute;bottom:25px;right:0;width:8px;height:250px;background:#2A82E4;"></div>
        <div style="position:absolute;bottom:25px;right:0;width:250px;height:8px;background:#2A82E4;"></div>
      </div>

      <!--地球上事件预览弹窗-->
      <div v-if="$store.state.imagePreviewShow" style="position:absolute;top:35px;left:35px;width:282px;background:#383838;border-radius:5px;">
        <div style="position:relative;width:100%;padding:22px 25px 30px 25px;">
          <div style="display:flex;">
            <p style="line-height:29px;font-size:18px;color:#ffffff;">{{preview_title}}</p>
            <v-spacer></v-spacer>
            <p @click="quitPreview" style="margin-top:4px;font-size:15px;color:#ffffff;cursor:pointer;z-index:1;" class="iconfontFamily">&#xe60d;</p>
          </div>
          <p style="margin-top:20px;line-height:21px;font-size:14px;color:#2190FF;">{{preview_type}}</p>
          <p style="height:82px;margin-top:15px;font-size:14px;color:#FFFFFF;
            display:-webkit-box;-webkit-line-clamp:4;-webkit-box-orient: vertical;overflow: hidden;">{{preview_introduce}}</p>
          <div style="margin-top:20px;display:flex;align-items:center;">
            <p style="line-height:21px;font-size:14px;color:#FFFFFF;">素材总计：{{preview_contentNum}}</p>
            <!--              &lt;!&ndash;价格&ndash;&gt;-->
            <!--              <v-spacer></v-spacer>-->
            <!--              <p style="font-size:23px;color:#2A82E4;" class="iconfontFamily">&#xe643;</p>-->
            <!--              <p style="margin-right:10px;line-height:21px;font-size:14px;color:#FFFFFF;">&nbsp;×&nbsp;{{preview_price}}</p>-->
          </div>
          <!--            &lt;!&ndash;已购买标识&ndash;&gt;-->
          <!--            <div :style="{'visibility':preview_buyStatus ? 'visible' : 'hidden'}" style="margin-right:5px;display:flex;align-items: center;">-->
          <!--              <v-spacer></v-spacer>-->
          <!--              <div style="width:13px;height:13px;background:#11AA66;border-radius:50%;margin-right:4px;text-align:center;">-->
          <!--                <p style="line-height: 15px;font-size:12px;color:#ffffff;" class="iconfontFamily">&#xe649;</p>-->
          <!--              </div>-->
          <!--              <p style="font-size:14px;color:#ffffff;">已购买</p>-->
          <!--            </div>-->


          <div style="width:100%;margin-top:25px;text-align: center;">
            <v-btn @click="intoImageDetailPage" width="120" height="40" dark depressed rounded color="#1867C0">查看详情</v-btn>
          </div>
        </div>


      </div>


      <!--地球上事件预览操作栏-->
      <div v-if="$store.state.imagePreviewShow" style="position:absolute;bottom:36px;left:50%;transform:translate(-50%,0);height:42px;background:rgba(42, 42, 42, 0.6);border-radius:21px;box-shadow: 0px 0px 4px  rgba(0, 0, 0, 0.5);
      padding-right:19px;display:flex;align-items:center;color:#ffffff;font-size:16px;">

        <div @click="downloadImage" style="width:160px;height:100%;background:#004491;border-radius:21px;box-shadow: 0px 0px 4px  rgba(0, 0, 0, 0.5);cursor:pointer;display:flex;justify-content:center;">
          <p style="line-height:45px;font-size:20px;" class="iconfontFamily">&#xe67e;</p>
          <p style="margin-left:10px;line-height:42px;">影像集下载</p>
        </div>

        <div @click="likeImage" style="width:75px;margin-left:10px;cursor:pointer;display:flex;justify-content:center;">
          <p :style="{'color':preview_likeStatus === 1 ? '#FFEE00' : '#ffffff'}" style="line-height:42px;" class="iconfontFamily">&#xe648;</p>
          <p :style="{'color':preview_likeStatus === 1 ? '#FFEE00' : '#ffffff'}" style="margin-left:6px;line-height:42px;">{{preview_likeStatus === 1 ? '已收藏' : '收藏'}}</p>
        </div>

        <div @click="shareImage" style="margin-left:6px;padding:0 7px;cursor:pointer;display:flex;">
          <p style="line-height:42px;font-size:20px;" class="iconfontFamily">&#xe67f;</p>
          <p style="margin-left:6px;line-height:42px;">转发</p>
        </div>


      </div>


      <!--地球效果设置-->
      <div v-if="(mainArea === 'globeOperation' || mainArea === 'globeScene')  && globeSetShow"
           style="position:absolute;top:13px;left:15px;width:300px;background:#2A2A2A;border:1px solid #808080;border-radius:2px;padding:15px 12px;color:#ffffff;display:flex;flex-direction: column;">

        <div style="display:flex;align-items: center;">
          <p style="margin-left:3px;font-weight:bold;">地球设置</p>
          <v-spacer></v-spacer>
          <p @click="globeSetShow = false" class="iconfontFamily" style="margin-right:4px;font-size: 14px;color:#A6A6A6;cursor: pointer">&#xe60d;</p>
        </div>

        <div style="margin-top:19px;" class="globeSetItem">
          <p>星空</p>
          <v-spacer></v-spacer>
          <v-switch v-model="globeSet_star" color="#2A82E4" dense inset style="width:38px;"></v-switch>
        </div>
        <div style="margin-top:13px;" class="globeSetItem">
          <p>大气</p>
          <v-spacer></v-spacer>
          <v-switch v-model="globeSet_fog" color="#2A82E4" dense inset style="width:38px;"></v-switch>
        </div>

        <div style="margin-top:13px;">
          <div style="border-radius:4px 4px 0 0;" class="globeSetItem">
            <p>地形</p>
            <v-spacer></v-spacer>
            <v-switch v-model="globeSet_dem" color="#2A82E4" dense inset style="width:38px;"></v-switch>
          </div>
          <div style="width:100%;height:91px;border-style:solid;border-width:1px;border-color:transparent #515152 #515152 #515152;
          background:#2A2A2A;border-radius:0 0 4px 4px;padding:12px 15px 17px 10px;">
            <div style="margin-left:5px;display:flex;">
              <p>夸张系数</p>
              <v-spacer></v-spacer>
              <p @click="globeSet_demNum = 1" style="color:#c4c4c4;cursor:pointer;"><span class="iconfontFamily" style="margin-right:3px;font-size: 15px;">&#xe65d;</span>默认</p>
            </div>
            <div style="margin-top:5px">
              <v-slider v-model="globeSet_demNum" :disabled="!globeSet_dem" class="globeSetItem-slider align-center" color="#2A82E4" track-color="#CCCCCC" thumb-color="#cccccc" :max="10" :min="1" step="0.1" hide-details>
                <template v-slot:append>
                  <v-text-field v-model="globeSet_demNum" :disabled="!globeSet_dem" class="globeSetItem-sliderInput mt-0 pt-0" hide-details outlined dense dark
                                style="width: 66px;height:31px;"></v-text-field>
                </template>
              </v-slider>
            </div>
          </div>
        </div>

        <div style="margin-top:13px;" class="globeSetItem">
          <p>视野辅助</p>
          <v-spacer></v-spacer>
          <v-switch v-model="globeSet_centerBorder" color="#2A82E4" dense inset style="width:38px;"></v-switch>
        </div>

      </div>

      <!--地球效果 视野辅助框-->
      <div v-show="globeSet_centerBorder" style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:154px;height:154px;display:flex;flex-direction: column;pointer-events: none;">
        <div style="display:flex;">
          <div style="width:50px;height:50px;border-left:2px solid #ffffff;border-top:2px solid #ffffff;border-top-left-radius:4px;"></div>
          <v-spacer></v-spacer>
          <div style="width:50px;height:50px;border-right:2px solid #ffffff;border-top:2px solid #ffffff;border-top-right-radius:4px;"></div>
        </div>
        <v-spacer></v-spacer>
        <div style="display:flex;">
          <div style="width:50px;height:50px;border-left:2px solid #ffffff;border-bottom:2px solid #ffffff;border-bottom-left-radius:4px;"></div>
          <v-spacer></v-spacer>
          <div style="width:50px;height:50px;border-right:2px solid #ffffff;border-bottom:2px solid #ffffff;border-bottom-right-radius:4px;"></div>
        </div>
      </div>


      <!--测试用-->
<!--      <div v-show="mainArea === 'globeOperation'"  style="position:absolute;bottom:110px;left:50%;transform:translate(-50%);-->
<!--           width:566px;height:46px;background:rgba(0, 0, 0, 0.4);border-radius: 13px;box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);padding-left:20px;backdrop-filter: blur(20px);-->
<!--           color:#ffffff;display:flex;align-items:center;">-->

<!--        <template v-for="item in testToolsList">-->
<!--          <div style="margin-right: 18px" :key="item.name">-->
<!--            <v-tooltip top color="rgba(0, 0, 0, 0.4)">-->
<!--              <template v-slot:activator="{ on, attrs }">-->
<!--                <div v-on="on" v-bind="attrs" style="width: 36px;height:36px;line-height: 36px;cursor:pointer;border-radius: 10px;">-->
<!--                  <v-hover v-slot="{ hover }">-->
<!--                    <div style="width: 36px;height:36px;line-height: 36px;cursor:pointer;border-radius: 10px;" :style="{'background': hover? 'rgba(99, 99, 99, 0.3)':''}" @click="selectTestTools(item.name,item.type,item.snackbarText)">-->
<!--                      <div style="font-size:26px;width: 26px;height: 26px;margin-left:5px;" :style="{'color':testToolsChoose ===item.name ? '#00B7FF' :'#ffffff'}" class="iconfontFamily" v-html="item.icon" ></div>-->
<!--                    </div>-->
<!--                  </v-hover>-->
<!--                </div>-->
<!--              </template>-->
<!--              <span style="color: white;font-size: 16px">{{item.text}}</span>-->
<!--            </v-tooltip>-->
<!--          </div>-->
<!--        </template>-->
<!--      </div>-->
      <div @click="editFileInfo" v-if='editFileIconShow && this.mainAreaBottomType === "folder" && mainArea === "myFolder"' style="position:absolute;left: 50%; transform: translateX(-50%);z-index: 100;bottom: 35px;cursor: pointer;height: 42px;width: 130px;color:white;font-size: 16px;border-radius: 21px;background-color: rgba(0,111,237,1);box-shadow: 0 0 4px rgba(0,0,0,0.5);backdrop-filter: blur(20px);display: flex;justify-content: center;align-items: center">
        <p class="iconfontFamily">&#xe636;</p>
        <p style="margin-left: 12px">编辑文件</p>
      </div>
      <div v-if='editFileIconShow && this.mainAreaBottomType === "folder" && mainArea === "myFolderAITrip"' style="position:absolute;left: 50%; transform: translateX(-50%);z-index: 100;bottom: 35px;display: flex;align-items: center">
        <div @click="editAiTripInfo" style="height: 42px;width: 130px;color:white;cursor: pointer;font-size: 16px;border-radius: 21px;background-color: rgba(0,111,237,1);box-shadow: 0 0 4px rgba(0,0,0,0.5);backdrop-filter: blur(20px);display: flex;justify-content: center;align-items: center">
          <p>编辑文件</p>
        </div>
        <div @click="openAiTripWebsite" style="height: 42px;width: 130px;margin-left: 45px;color:white;cursor: pointer;font-size: 16px;border-radius: 21px;background-color: rgba(0,111,237,1);box-shadow: 0 0 4px rgba(0,0,0,0.5);backdrop-filter: blur(20px);display: flex;justify-content: center;align-items: center">
          <p>星旅中访问</p>
        </div>
      </div>
      <!--地球操作 地球标记按钮-->
      <div v-show="mainArea === 'globeOperation'"
           style="position:absolute;bottom:55px;left:50%;transform:translate(-50%);
           width:590px;height:46px;background:rgba(0, 0, 0, 0.4);border-radius: 13px;box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);padding-left:20px;backdrop-filter: blur(20px);
           color:#ffffff;display:flex;align-items:center;">
        <template v-for="item in drawToolsList">
          <div style="margin-right: 12px" :key="item.name">
            <v-tooltip top color="rgba(0, 0, 0, 0.4)">
              <template v-slot:activator="{ on, attrs }">
                <div v-on="on" v-bind="attrs" style="width: 36px;height:36px;line-height: 36px;cursor:pointer;border-radius: 10px;">
                  <v-hover v-slot="{ hover }">
                    <div style="width: 36px;height:36px;line-height: 36px;cursor:pointer;border-radius: 10px;" :style="{'background': hover? 'rgba(99, 99, 99, 0.3)':''}" @click="selectDrawTools(item.name,item.snackbarText,item.eventTrackingText)">
                      <div style="font-size:26px;width: 26px;height: 26px;margin-left:5px;" :style="{'color':drawToolsChoose ===item.name ? '#00B7FF' :'#ffffff'}" class="iconfontFamily" v-html="item.icon" ></div>
                    </div>
                  </v-hover>
                </div>
              </template>
              <span style="color: white;font-size: 16px">{{item.text}}</span>
            </v-tooltip>
          </div>
        </template>
        <div style="margin-right: 12px;position: relative" >
          <v-tooltip top color="rgba(0, 0, 0, 0.4)">
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on" v-bind="attrs" style="width: 36px;height:36px;line-height: 36px;cursor:pointer;border-radius: 10px;">
                <v-hover v-slot="{ hover }">
                  <div style="width: 36px;height:36px;line-height: 36px;cursor:pointer;border-radius: 10px;" :style="{'background': hover? 'rgba(99, 99, 99, 0.3)':''}" @click="clickImportAnnexDataDialog">
                    <div style="font-size:26px;width: 26px;height: 26px;margin-left:5px;color: #ffffff" class="iconfontFamily" >&#xe610;</div>
                  </div>
                </v-hover>
              </div>
            </template>
            <span style="color: white;font-size: 16px">导入数据</span>
          </v-tooltip>
        </div>
        <div style="margin-right: 12px;position: relative" >
          <v-tooltip top color="rgba(0, 0, 0, 0.4)">
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on" v-bind="attrs" style="width: 36px;height:36px;line-height: 36px;cursor:pointer;border-radius: 10px;">
                <v-hover v-slot="{ hover }">
                  <div style="width: 36px;height:36px;line-height: 36px;cursor:pointer;border-radius: 10px;" :style="{'background': hover? 'rgba(99, 99, 99, 0.3)':''}" @click="beginDrawCanvas">
                    <div style="font-size:26px;width: 26px;height: 26px;margin-left:5px;color: #ffffff"
                         :style="{'color':drawToolsChoose === 'drawPen' ? '#00B7FF' :'#ffffff'}" class="iconfontFamily" >&#xe7c7;</div>
                  </div>
                </v-hover>
              </div>
            </template>
            <span style="color: white;font-size: 16px">画笔</span>
          </v-tooltip>
        </div>
        <div style="width: 1px;height: 20px;background: rgba(204, 204, 204, 1)"></div>
        <div style="position: relative">
          <v-hover v-slot="{ hover }">
            <div style="display:flex;align-items:center;width: 72px;height: 36px; line-height:36px; cursor: pointer;margin-left: 9px;border-radius: 10px;justify-content: center;" :style="{'background': hover? 'rgba(99, 99, 99, 0.3)':''}" @click="isMeasureShow">
              <div style="font-size:20px;color: #00B7FF" class="iconfontFamily">&#xe680;</div>
              <div style="font-size: 16px;color: white;margin-left: 5px">测量</div>
            </div>
          </v-hover>

        </div>
<!--        <v-hover v-slot="{ hover }">-->
<!--          <div style="display:flex;align-items:center;width: 72px;height: 36px; line-height:36px; cursor: pointer;border-radius: 10px;justify-content: center;" :style="{'background': hover? 'rgba(99, 99, 99, 0.3)':''}" @click="intoGlobeOperationScene">-->
<!--            <div style="font-size:20px;color: rgba(255, 0, 0, 1)" class="iconfontFamily">&#xe683;</div>-->
<!--            <div style="font-size: 16px;color: white;margin-left: 5px">录制</div>-->
<!--          </div>-->
<!--        </v-hover>-->
      </div>
      <div v-show="mainArea === 'globeOperation' && measureCardShow"
           style="width: 220px;height: 46px;border-radius: 12px;background: rgba(0, 0, 0, 0.4); box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);backdrop-filter: blur(20px);
           position: absolute;display:flex;align-items:center;bottom:105px;left:50%;transform:translate(35%)">
        <v-hover v-slot="{ hover }">
          <div style="display:flex;align-items:center;width: 100px;height: 36px;cursor: pointer;margin-left: 8px;border-radius: 10px;justify-content: center;" :style="{'background': hover? 'rgba(99, 99, 99, 0.3)':''}" @click="selectMeasureTool('len')">
            <div style="font-size:20px;" :style="{'color':measureToolChoose ==='len' ? '#00B7FF' : '#FFFFFF'}" class="iconfontFamily">&#xe682;</div>
            <div style="margin-left: 10px;font-size: 16px" :style="{'color':measureToolChoose ==='len' ? '#00B7FF' : '#FFFFFF'}">测长度</div>
          </div>
        </v-hover>
        <v-hover v-slot="{ hover }">
          <div style="display:flex;align-items:center;width: 100px;height:36px;cursor: pointer;margin-left: 4px;border-radius: 10px;justify-content: center;" :style="{'background':hover? 'rgba(99, 99, 99, 0.3)':''}" @click="selectMeasureTool('area')">
            <div style="font-size:20px;" :style="{'color':measureToolChoose ==='area' ? '#00B7FF' : '#FFFFFF'}" class="iconfontFamily">&#xe681;</div>
            <div style="margin-left: 10px;font-size: 16px" :style="{'color':measureToolChoose ==='area' ? '#00B7FF' : '#FFFFFF'}">测面积</div>
          </div>
        </v-hover>
      </div>



      <!--录屏播放中 动效蒙层 全屏-->
      <div v-if="mainArea === 'globeScene' && animationAllScreenMantleShow"
           :style="{'animation-name':animationAllScreenMantleName,'animation-duration':animationAllScreenMantleDuration,'background-image':'url('+animationAllScreenBackground+')'}"
           class="animationAllScreenMantle"></div>
      <!--录屏播放中 动效蒙层 居中全屏-->
      <div v-if="mainArea === 'globeScene' && animationAllScreenMantleCenterShow"
           :style="{'animation-name':animationAllScreenMantleCenterName,'animation-duration':animationAllScreenMantleCenterDuration,'background-image':'url('+animationAllScreenCenterBackground+')'}"
           class="animationAllScreenMantleCenter"></div>
      <!--录屏播放中 动效蒙层 百叶窗-->
      <div v-if="mainArea === 'globeScene' && animationWindowMantleShow"
           style="position:absolute;top:0;left:0;width:100%;height:100%;">
        <div v-for="(item,index) in 10" :key="index"
             :style="{'top':index*10 + '%','background-image':'url('+animationWindowBackground+')',
             'background-position':'center ' + (index+1)*10 + '%',
             'animation-duration':animationWindowMantleDuration,}"
             class="animationWindowMantle"></div>
      </div>


      <!--地球录制相关区域--------------------------------------------------------------------------------------------------------->

      <!--添加录制点按钮-->
      <div @click="beginAddScenePoint" v-if="mainArea === 'globeScene' && !this.$store.state.globeSceneFullScreen
      && $store.state.scenePointEditing === false"
           style="position:absolute;bottom:55px;left:50%;transform:translate(-50%);
           width:174px;height:42px;background:rgb(0, 111, 237);border-radius: 21px;box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.5);padding:0 23px 0 23px;
           color:#ffffff;font-size:16px;cursor:pointer;backdrop-filter: blur(20px);">
        <p style="line-height:42px;"><span style="margin-right:13px;" class="iconfontFamily">&#xe71d;</span>添加录制点位</p>
      </div>

      <!--添加视野点按钮-->
      <div @click="addViewPoint" v-if="mainArea === 'globeScene' && !this.$store.state.globeSceneFullScreen
      && $store.state.scenePointEditing === true"
           style="position:absolute;bottom:55px;left:50%;transform:translate(-50%);
           width:160px;height:42px;background:rgb(0, 111, 237);border-radius: 21px;box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.5);padding:0 23px 0 23px;
           color:#ffffff;font-size:16px;cursor:pointer;backdrop-filter: blur(20px);display:flex;align-items: center;">
        <img src="../../assets/globe/scene/addViewPoint.png" style="width:16px;margin-right:10px;margin-top:2px;" />
        <p style="line-height:42px;">添加视野点</p>
      </div>

      <!--左下角操作说明-->
      <div v-if="mainArea === 'globeScene' && !this.$store.state.globeSceneFullScreen
      && $store.state.sceneOperationState_addViewPointGuideState !== ''"
           style="position:absolute;left:20px;bottom:43px;width:400px;border-radius:7px;background:#ffffff;padding:10px 0;color:#000000;z-index:20;">

        <!--添加初始视野点-->
        <div v-show="$store.state.sceneOperationState_addViewPointGuideState === 'firstViewPoint'"
             style="position:relative;width:100%;height:100px;display:flex;padding:0 45px 0 22px;">
          <div style="flex:1;font-size:16px;padding-top:26px;margin-right:20px;">
            <p>调整地球视野，选择目标地点作为地球动画视野点位。</p>
          </div>
          <!--鼠标图示-->
          <div style="position:relative;width:32px;height:100%;">
            <img src="../../assets/globe/scene/recommendedAnimation/rightKeyMouse.png" style="width:100%;height:32px;margin-top:40px;" />

            <img src="../../assets/globe/scene/recommendedAnimation/mouseTopArrow.png" style="position:absolute;top:29px;left:7px;width:18px;height:9px;
          animation-name:sceneOperationGuide_top;animation-duration:1s;animation-iteration-count:infinite;" />
            <img src="../../assets/globe/scene/recommendedAnimation/mouseBottomArrow.png" style="position:absolute;bottom:17px;left:7px;width:18px;height:9px;
          animation-name:sceneOperationGuide_bottom;animation-duration:1s;animation-iteration-count:infinite;" />
          </div>
        </div>


        <!--视野点陆续添加中 1-->
        <div v-show="$store.state.sceneOperationState_addViewPointGuideState === 'viewPoint1'" style="position:relative;width:100%;height:100px;display:flex;padding:0 45px 0 22px;">
          <div style="flex:1;font-size:16px;padding-top:26px;margin-right:20px;">
            <p>点击 <span style="color:#3CBA40">完成</span> 完成单点动画编辑；点击 <span style="color:#006FED">添加视野点</span> 进行多点位动画编辑。</p>
          </div>
          <!--鼠标图示-->
          <div style="position:relative;width:32px;height:100%;">
            <img src="../../assets/globe/scene/recommendedAnimation/leftKeyMouse.png" style="width:100%;height:32px;margin-top:40px;" />
          </div>
        </div>


        <!--视野点陆续添加中 2-->
        <div v-show="$store.state.sceneOperationState_addViewPointGuideState === 'viewPoint2'" style="position:relative;width:100%;height:100px;display:flex;padding:0 45px 0 22px;">
          <div style="flex:1;font-size:16px;padding-top:26px;margin-right:20px;">
            <p>点击 <span style="color:#3CBA40">完成</span> 结束当前选择，完成多点动画编辑；点击 <span style="color:#006FED">添加视野点</span> 继续添加点位。</p>
          </div>
          <!--鼠标图示-->
          <div style="position:relative;width:32px;height:100%;">
            <img src="../../assets/globe/scene/recommendedAnimation/leftKeyMouse.png" style="width:100%;height:32px;margin-top:40px;" />
          </div>
        </div>


        <!--引导添加新视野点-->
        <div v-show="$store.state.sceneOperationState_addViewPointGuideState === 'newViewPoint'" style="position:relative;width:100%;height:100px;display:flex;padding:0 45px 0 22px;">
          <div style="flex:1;font-size:16px;padding-top:26px;margin-right:20px;">
            <p>点击 <span style="color:#006FED">添加视野点</span> 继续添加点位进行多点位动画编辑。</p>
          </div>
          <!--鼠标图示-->
          <div style="position:relative;width:32px;height:100%;">
            <img src="../../assets/globe/scene/recommendedAnimation/leftKeyMouse.png" style="width:100%;height:32px;margin-top:40px;" />
          </div>
        </div>


        <!--引导视野点添加完成-->
        <div v-show="$store.state.sceneOperationState_addViewPointGuideState === 'viewPointFinish'" style="position:relative;width:100%;height:100px;display:flex;padding:0 45px 0 22px;">
          <div style="flex:1;font-size:16px;padding-top:26px;margin-right:20px;">
            <p>点击 <span style="color:#3CBA40">完成</span> 结束当前编辑，完成地球动画点位选择。</p>
          </div>
          <!--鼠标图示-->
          <div style="position:relative;width:32px;height:100%;">
            <img src="../../assets/globe/scene/recommendedAnimation/leftKeyMouse.png" style="width:100%;height:32px;margin-top:40px;" />
          </div>
        </div>


        <!--动画效果推荐-->
        <div v-show="$store.state.sceneOperationState_addViewPointRecommendedAnimationShow" style="width:calc(100% - 44px);height:220px;border-top:1px solid #E5E5E5;margin:0 auto;padding-top:18px;">
          <p>效果推荐</p>
          <div style="height:113px;margin-top:18px;display:flex;">
            <div @click="addViewPointAndSetPointAnimation(item.name)" v-for="(item,index) in sceneRecommendedAnimationList" :key="'sceneRecommendedAnimation'+index"
                 style="position:relative;width:153px;height:113px;margin:0 12px;cursor:pointer;">
              <img :src="item.picture" style="width:100%;height:100%;border-radius:5px;">
              <p style="position:absolute;bottom:12px;width:100%;
              color:#ffffff;font-weight:bold;font-size:18px;text-shadow:0px 1px 1px rgba(0,0,0,0.8);text-align:center;">{{item.name}}</p>
            </div>
          </div>
          <p style="width:100%;margin-top:14px;color:#2A82E4;text-align:center;cursor:pointer;">更多效果</p>
        </div>


        <!--关闭按钮-->
        <p @click="$store.state.sceneOperationState_addViewPointGuideState = ''" style="position:absolute;top:19px;right:15px;font-size:14px;color:#A6A6A6;cursor:pointer;" class="iconfontFamily">&#xe60d;</p>

      </div>


      <!--视野点位列表-->
      <div v-if="mainArea === 'globeScene' && !this.$store.state.globeSceneFullScreen && $store.state.sceneViewPointAreaShow"
           style="position:absolute;top:15px;right:15px;width:300px;background:#383838;color:#ffffff;">

        <!--视野点位标题栏-->
        <div style="width:100%;height:52px;padding:0 16px;display:flex;align-items:center;">
          <img src="../../assets/globe/scene/viewPoint/viewPointIcon.png" style="width:18px;margin-right:10px;margin-top:2px;" />
          <p style="line-height:52px;">视野点位</p>

          <v-spacer></v-spacer>
          <p @click="changeViewPointerListOpenState" style="font-size:18px;cursor:pointer;"
             class="iconfontFamily">{{viewPointerListOpen ? '&#xeb47;' : '&#xe6a7;'}}</p>

<!--          <p @click="closeViewPointArea" style="font-size:12px;cursor:pointer;" class="iconfontFamily">&#xe60d;</p>-->
        </div>

        <!--视野点列表-->
        <div v-show="viewPointerListOpen" style="width:100%;height:450px;padding-top:4px;">

          <!--列表区域-->
          <div ref="viewPointerList" :style="{'height':$store.state.scenePointEditing && ($store.state.currChooseSceneItemIndex !== ''
          ? $store.state.sceneList[$store.state.currChooseSceneItemIndex].viewPointList.length !== 0
          : $store.state.tempViewPointList.length !== 0)  ? '370px' : ''}" style="width:100%;max-height:calc(100% - 70px);overflow:auto;" class="myScrollArea">
            <!--有视野点-->
            <div v-show="$store.state.scenePointEditing
          ? $store.state.tempViewPointList.length > 0
          : $store.state.currChooseSceneItemIndex !== ''
          ? $store.state.sceneList[$store.state.currChooseSceneItemIndex].viewPointList.length > 0
          : false"
                 :draggable="!cutScreening && !editViewItemNameShow" @dragstart="viewPointItemDragstart(index)" @dragover="viewPointItemDragover($event, index)"
                 @drop="viewPointItemDragend($event,index)" @dragleave="viewPointItemDragleave($event,index)"
                 v-for="(item,index) in $store.state.scenePointEditing
               ? $store.state.tempViewPointList
               :  $store.state.currChooseSceneItemIndex !== ''
               ? $store.state.sceneList[$store.state.currChooseSceneItemIndex].viewPointList
               : []" :key="'viewPoint'+index"
                 style="position:relative;width:100%;height:46px;margin:2px 0;display:flex;align-items:center;">

              <div :style="{'visibility':item.isZoomBasis ? 'visible' : 'hidden'}" style="width:3px;height:20px;background:#00B3FF;"></div>

              <div @click="chooseViewItem(item)" :style="{'background':$store.state.currChooseViewItemId === item.viewId ? '#262626' : '',
            'border':$store.state.currChooseViewItemId === item.viewId ? '1px solid #00B3FF' : '1px solid transparent'}"
                   class="viewItem">

                <v-tooltip bottom nudge-bottom="-5" nudge-right="50" max-width="120" color="#808080">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-show="$store.state.currChooseViewItemId === item.viewId && !item.isZoomBasis" v-bind="attrs" v-on="on">
                      <p @click="setZoomBasis(item)"
                         style="width:20px;text-align:center;font-size:16px;color:#ffffff;cursor:pointer;" class="iconfontFamily">
                        &#xe683;</p>
                    </div>
                  </template>
                  <span>设为参考视野</span>
                </v-tooltip>
                <p v-show="$store.state.currChooseViewItemId !== item.viewId || item.isZoomBasis"  :style="{'color':item.isZoomBasis ? '#00B3FF' : '#ffffff'}" style="width:20px;text-align:center;font-size:16px;cursor:pointer;" class="iconfontFamily">
                  {{item.isZoomBasis || $store.state.currChooseViewItemId === item.viewId ? '&#xe683;' : index+1}}
                </p>

                <div style="margin-left:9px;flex:1;overflow:hidden;">
                  <p @dblclick="intoEditViewItemName($event,item)" v-show="!editViewItemNameShow" style="line-height:22px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{item.name}}</p>
                  <v-text-field @blur="editViewItemNameShow = false" v-show="editViewItemNameShow" v-model="item.name"
                                dark height="22" hide-details class="editViewItemNameTextField"></v-text-field>
                </div>

                <p @click.stop="deleteViewPoint(item,index)" :style="{'display':$store.state.currChooseViewItemId === item.viewId ? 'block' : ''}" class="viewItem-btn iconfontFamily">&#xe720;</p>
              </div>

              <!--拖拽效果-->
              <!--被拖拽项要插入本项上方-->
              <div v-show="viewPointItemEndIndex === index && viewPointItemEndDirection === 'top'" style="position:absolute;top:-2px;left:0;width:100%;height:1px;background:#00B3FF;"></div>
              <!--被拖拽项要插入本项下方-->
              <div v-show="viewPointItemEndIndex === index && viewPointItemEndDirection === 'bottom'" style="position:absolute;bottom:-2px;left:0;width:100%;height:1px;background:#00B3FF;"></div>

            </div>

          </div>


          <!--按钮 新增点位-->
          <div v-if="!$store.state.scenePointEditing" style="width:100%;height:46px;margin-top:10px;">

            <div @click="clickAddViewPointBtn" class="addViewPointBtn">
              <p style="line-height:42px;">+ 新增点位</p>
            </div>

          </div>

          <!--无视野点-->
          <div v-show="$store.state.scenePointEditing
          ? $store.state.tempViewPointList.length === 0
          : $store.state.currChooseSceneItemIndex !== ''
          ? $store.state.sceneList[$store.state.currChooseSceneItemIndex].viewPointList.length === 0
          : false" style="margin:180px 0 181px 0;">
            <p style="width:100%;text-align:center;">暂无视野点</p>
          </div>

          <!--按钮 正在编辑视野点-->
          <div v-if="$store.state.scenePointEditing" style="width:100%;height:42px;margin-top:15px;display:flex;align-items:center;">

            <div @click="viewPointerListCancel" style="width:80px;height:100%;margin-left:62px;background:rgba(166, 166, 166, 0.6);border-radius:21px;box-shadow:0px 0px 4px rgba(0, 0, 0, 0.5);text-align:center;cursor:pointer;">
              <p style="line-height:42px;">取消</p>
            </div>
            <div @click="viewPointerListFinish" ref="viewFinishBtn" style="width:80px;height:100%;margin-left:16px;background:#006FED;border-radius:21px;box-shadow:0px 0px 4px rgba(0, 0, 0, 0.5);text-align:center;cursor:pointer;">
              <p style="line-height:42px;">完成</p>
            </div>

          </div>

        </div>



        <!--分割线-->
        <div style="width:100%;height:4px;border-top:1px solid rgba(128, 128, 128, 1);border-bottom:1px solid rgba(128, 128, 128, 1);"></div>

        <!--素材窗口标题栏-->
        <div style="width:100%;height:52px;padding:0 16px;display:flex;align-items:center;">
          <img src="../../assets/globe/scene/viewPoint/materialIcon.png" style="width:18px;margin-right:10px;margin-top:2px;" />
          <p style="line-height:52px;">素材窗口</p>
          <v-spacer></v-spacer>
          <p @click="changeMaterialOpenState" style="font-size:18px;cursor:pointer;"
             class="iconfontFamily">{{materialListOpen ? '&#xeb47;' : '&#xe6a7;'}}</p>
        </div>
        <!--素材列表-->
        <div v-show="materialListOpen" style="width:100%;height:450px;padding-top:4px;">
          <!--列表区域-->
          <div ref="materialList" style="width:100%;max-height:calc(100% - 76px);overflow:auto;" class="myScrollArea">
            <!--有素材-->
            <div v-show="$store.state.currChooseSceneItemIndex !== ''
            ? $store.state.sceneList[$store.state.currChooseSceneItemIndex].materialInfo.materialList.length > 0
            : $store.state.tempMaterialInfo.materialList.length > 0"
                 v-for="(item,index) in $store.state.currChooseSceneItemIndex !== ''
                 ? $store.state.sceneList[$store.state.currChooseSceneItemIndex].materialInfo.materialList
                 : $store.state.tempMaterialInfo.materialList"
                 :key="'material'+index"
                 style="position:relative;width:100%;height:35px;display:flex;align-items:center;font-size:14px;">
              <div @click="chooseMaterialItem(item)"
                   :style="{'background':$store.state.currChooseMaterialItemId === item.id ? '#20518a' : '',}"
                   class="materialItem">
                <p v-html="getMaterialIcon(item.type)" style="width:20px;line-height:35px;text-align:center;font-size:16px;cursor:pointer;" class="iconfontFamily"></p>
                <div style="margin-left:9px;flex:1;overflow:hidden;">
                  <p @dblclick="intoEditMaterialItemName($event,item)" v-show="!editMaterialItemNameShow" style="line-height:35px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{item.name}}</p>
                  <v-text-field @blur="editMaterialItemNameShow = false" v-show="editMaterialItemNameShow" v-model="item.name"
                                dark height="35" hide-details class="editMaterialItemNameTextField"></v-text-field>
                </div>

                <!--按钮-->
                <!--重新定位-->
                <v-tooltip bottom nudge-bottom="-5" max-width="300" color="rgba(128, 128, 128, 1)">
                  <template v-slot:activator="{ on, attrs }">
                    <p @click.stop="resetMaterialItemPosition(item)" v-bind="attrs" v-on="on"
                       v-if="item.type === 'point'"
                       :style="{'display':$store.state.currChooseMaterialItemId === item.id ? 'block' : ''}" class="materialItem-btn iconfontFamily">&#xe622;</p>
                  </template>
                  <span>重新定位</span>
                </v-tooltip>
                <!--添加到地图-->
                <v-tooltip bottom nudge-bottom="-5" max-width="300" color="rgba(128, 128, 128, 1)">
                  <template v-slot:activator="{ on, attrs }">
                    <p @click.stop="resetMaterialItemPosition_image(item)" v-bind="attrs" v-on="on"
                       v-if="item.type === 'image'"
                       :style="{'display':$store.state.currChooseMaterialItemId === item.id ? 'block' : ''}" class="materialItem-btn iconfontFamily">&#xe622;</p>
                  </template>
                  <span>重新定位</span>
                </v-tooltip>
                <!--添加视野点-->
                <v-tooltip bottom nudge-bottom="-5" max-width="300" color="rgba(128, 128, 128, 1)">
                  <template v-slot:activator="{ on, attrs }">
                    <p @click.stop="addMaterialItemToViewPoint(item)" v-bind="attrs" v-on="on"
                       v-if="item.type === 'point' || item.type === 'lineString' || item.type === 'roadString'"
                       :style="{'display':$store.state.currChooseMaterialItemId === item.id ? 'block' : ''}" class="materialItem-btn iconfontFamily">&#xe6ac;</p>
                  </template>
                  <span>添加视野点</span>
                </v-tooltip>
                <!--删除-->
                <p @click.stop="deleteMaterialItem(item,index)"
                   :style="{'display':$store.state.currChooseMaterialItemId === item.id ? 'block' : ''}" class="materialItem-btn iconfontFamily">&#xe720;</p>


              </div>

            </div>

          </div>

          <!--按钮 新增素材-->
          <div style="width:100%;height:46px;margin-top:10px;color:#A6A6A6;display:flex;align-items:center;">
            <div @click="isPreviewing(()=>{addSceneMaterialShow = true;})" class="addMaterialBtn">
              <p style="line-height:42px;">+ 添加素材</p>
            </div>
          </div>

          <!--无素材-->
          <div v-show="$store.state.currChooseSceneItemIndex !== ''
            ? $store.state.sceneList[$store.state.currChooseSceneItemIndex].materialInfo.materialList.length === 0
            : $store.state.tempMaterialInfo.materialList.length === 0">
            <p style="width:100%;margin-top:170px;text-align:center;">暂无素材内容</p>
          </div>

        </div>


      </div>



      <!--素材显示设置-->
      <div v-if="mainArea === 'globeScene' && !this.$store.state.globeSceneFullScreen && $store.state.setMaterialAreaShow"
           style="position:absolute;top:15px;left:15px;width:390px;padding-bottom:20px;background:#383838;color:#ffffff;">
        <div style="width:100%;height:52px;padding:0 20px 0 18px;border-bottom:1px solid #808080;">
          <p style="line-height:52px;float:left;">素材显示设置</p>
          <p @click="$store.state.setMaterialAreaShow = false"
             style="line-height:52px;float:right;font-size:12px;cursor:pointer;" class="iconfontFamily">&#xe60d;</p>
        </div>
        <!--素材标题-->
        <div style="width:100%;height:22px;margin-top:20px;padding:0 20px 0 18px;">
          <p style="width:calc(100% - 70px);color:#A6A6A6;line-height:22px;float:left;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
            素材：{{$store.state.currChooseMaterialItem.name}}
          </p>
          <p @click="previewSceneItemFromSetMaterialArea"
             :style="{'color':$store.state.currChooseSceneItemIndex !== '' ? '#ffffff' : '#a6a6a6'}"
             style="cursor:pointer;line-height:22px;float:right;">
            <span style="margin-right:9px;" class="iconfontFamily">&#xe65e;</span>
            预览
          </p>
        </div>

        <!--显示时间栏-->
        <div style="width:100%;height:22px;margin-top:20px;padding:0 16px 0 9px;display:flex;align-items:center;">
          <div style="width:6px;height:16px;background:#2A82E4;"></div>
          <p style="margin-left:7px;">显示时间</p>
          <v-spacer></v-spacer>
          <p>项目中常显</p>
          <v-checkbox v-model="$store.state.currChooseMaterialItem.showSet.allShowInScenePoint"
                      @click="changeMaterialShowSet_allShowInScenePoint"
                      dark color="#2A82E4" hide-details style="width:24px;height:24px;margin-top:-8px;margin-left:10px;"
                      class="setMaterialCheckbox">
          </v-checkbox>
        </div>

        <!--刻度尺-->
        <div style="width:100%;margin-top:13px;padding:0 20px;">
          <!--点位 justify-content:space-between;-->
          <div style="position:relative;width:calc(100% - 10px);height:40px;margin:0 auto;padding-right:2px;display:flex;font-size:14px;">
            <div v-for="(item,index) in $store.state.scenePointEditing
               ? $store.state.tempViewPointList
               : $store.state.currChooseSceneItemIndex !== ''
               ? $store.state.sceneList[$store.state.currChooseSceneItemIndex].viewPointList
               : []" :key="'rangeSlider'+index"
                 style="position:absolute;top:0;"
                 :style="{'display':materialAreaRangeSliderPointShow(index) ? 'block' : 'none','left':materialAreaRangeSliderPointLeft(index)}">
              <div :style="{'visibility':item.isZoomBasis ? 'visible' : 'hidden'
              ,'background':$store.state.currChooseMaterialItem.showSet.allShowInScenePoint ? 'rgba(0, 179, 255, 0.5)' : '#00B3FF'}"
                   style="width:10px;height:10px;margin-left:10px;border-radius:50%;background:#00B3FF;"></div>
              <v-tooltip right nudge-left="48" nudge-bottom="32" max-width="400" color="rgba(128, 128, 128, 1)">
                <template v-slot:activator="{ on, attrs }">
                  <p v-bind="attrs" v-on="on" :ref="'tooltip'+index"
                     :style="{'color':$store.state.currChooseMaterialItem.showSet.allShowInScenePoint ? 'rgba(255,255,255,0.5)' : '#ffffff'}"
                     style="width:30px;margin-top:6px;text-align:center;">{{index+1}}</p>
                </template>
                <span>{{item.name}}</span>
              </v-tooltip>
            </div>
            <div style="position:absolute;top:0;right:-10px;">
              <div style="width:10px;height:10px;margin-left:10px;visibility:hidden;"></div>
              <p :style="{'color':$store.state.currChooseMaterialItem.showSet.allShowInScenePoint ? 'rgba(255,255,255,0.5)' : '#ffffff'}"
                 style="width:30px;margin-top:6px;text-align:center;">结束</p>
            </div>
          </div>
          <!--刻度尺-->
          <div style="position:relative;width:100%;height:35px;margin:0 auto;border-bottom:2px solid rgba(255, 255, 255, 0.15)">
            <div style="position:absolute;top:0;left:20px;width:calc(100% - 40px);height:100%;"></div>
            <v-range-slider v-model="$store.state.currChooseMaterialItem.showSet.timeRange"
                            ref="setMaterialRangeSlider" @change="rangeSliderChangeFun" class="setMaterialRangeSlider"
                            :disabled="$store.state.currChooseMaterialItem.showSet.allShowInScenePoint"
                            ticks="always" dark height="35" hide-details min="0"
                            :max="$store.state.scenePointEditing
                            ? $store.state.tempViewPointList.length
                            : $store.state.currChooseSceneItemIndex !== ''
                            ? $store.state.sceneList[$store.state.currChooseSceneItemIndex].viewPointList.length
                            : 0">
            </v-range-slider>
          </div>

          <div :style="{'color':$store.state.currChooseMaterialItem.showSet.allShowInScenePoint ? 'rgba(255,255,255,0.5)' : '#ffffff'}"
               style="position:relative;width:calc(100% - 40px);height:20px;margin-top:22px;margin-left:20px;font-size:14px;display:flex;align-items:center;">
            <p :style="{'left':setMaterialRangeSliderBeginLeft}" style="position:absolute;width:60px;">素材出现</p>
            <v-spacer></v-spacer>
            <p v-show="$store.state.currChooseMaterialItem.showSet.timeRange[0] !== $store.state.currChooseMaterialItem.showSet.timeRange[1]"
               :style="{'left':setMaterialRangeSliderEndLeft}" style="position:absolute;width:60px;">素材消失</p>
          </div>

        </div>

        <!--出现效果-->
        <div style="width:100%;margin-top:16px;padding:0 20px 0 16px;font-size:14px;">
          <p style="color:#A6A6A6;">出现效果</p>
          <div style="width:346px;height:85px;border:1px solid #404040;border-radius:2px;margin-top:10px;margin-left:7px;padding:10px;">
            <div @click="!$store.state.currChooseMaterialItem.showSet.allShowInScenePoint
            ? $store.state.currChooseMaterialItem.showSet.materialShowAnimation = materialShowAnimationItem.name
            : ''"
                 v-for="(materialShowAnimationItem,materialShowAnimationIndex) in
                 $store.state.currChooseMaterialItem.type==='point' || $store.state.currChooseMaterialItem.type==='image'
                 ? materialShowAnimationList_point
                 : $store.state.currChooseMaterialItem.type==='lineString' || $store.state.currChooseMaterialItem.type==='roadString'
                 ? materialShowAnimationList_line
                 : $store.state.currChooseMaterialItem.type==='circle' || $store.state.currChooseMaterialItem.type==='rectangle' || $store.state.currChooseMaterialItem.type==='polygon'
                 ? materialShowAnimationList_polygon : []"
                 :key="'materialShowAnimation'+materialShowAnimationIndex"
                 :style="{'border':$store.state.currChooseMaterialItem.showSet.materialShowAnimation === materialShowAnimationItem.name ? '1px solid #2A82E4' : '1px solid transparent',
                         'margin-right':(materialShowAnimationIndex+1)%5===0 ? '0px' : '7px'}"
                 style="width:59px;height:65px;padding-top:9px;float:left;cursor:pointer;
                         display:flex;flex-direction:column;align-items:center;">
              <p :style="{'color':$store.state.currChooseMaterialItem.showSet.allShowInScenePoint ? 'rgba(255,255,255,0.5)' : '#ffffff'}"
                 style="line-height:19px;">{{materialShowAnimationItem.name}}</p>
              <v-img :style="{'opacity':$store.state.currChooseMaterialItem.showSet.allShowInScenePoint ? '0.5' : ''}"
                     :src="materialShowAnimationItem.thumb" contain style="width:25px;margin-top:-8px;"></v-img>
            </div>
          </div>
        </div>

        <!--消失效果-->
        <div v-show="$store.state.currChooseMaterialItem.type==='point' || $store.state.currChooseMaterialItem.type==='image'"
             style="width:100%;margin-top:16px;padding:0 20px 0 16px;font-size:14px;">
          <p style="color:#A6A6A6;">消失效果</p>
          <div style="width:346px;height:85px;border:1px solid #404040;border-radius:2px;margin-top:10px;margin-left:7px;padding:10px;">
            <div @click="!$store.state.currChooseMaterialItem.showSet.allShowInScenePoint
            ? $store.state.currChooseMaterialItem.showSet.materialHideAnimation = materialShowAnimationItem.name
            : ''"
                 v-for="(materialShowAnimationItem,materialShowAnimationIndex) in materialHideAnimationList" :key="'materialHideAnimation'+materialShowAnimationIndex"
                 :style="{'border':$store.state.currChooseMaterialItem.showSet.materialHideAnimation === materialShowAnimationItem.name ? '1px solid #2A82E4' : '1px solid transparent',
                         'margin-right':(materialShowAnimationIndex+1)%5===0 ? '0px' : '7px'}"
                 style="width:59px;height:65px;padding-top:9px;float:left;cursor:pointer;
                         display:flex;flex-direction:column;align-items:center;">
              <p :style="{'color':$store.state.currChooseMaterialItem.showSet.allShowInScenePoint ? 'rgba(255,255,255,0.5)' : '#ffffff'}"
                 style="line-height:19px;">{{materialShowAnimationItem.name}}</p>
              <v-img :style="{'opacity':$store.state.currChooseMaterialItem.showSet.allShowInScenePoint ? '0.5' : ''}"
                     :src="materialShowAnimationItem.thumb" contain style="width:25px;margin-top:-8px;"></v-img>
            </div>
          </div>
        </div>

        <!--显示样式栏-->
        <div v-show="$store.state.currChooseMaterialItem.type!=='image'"
             style="width:100%;height:22px;margin-top:20px;padding:0 16px 0 9px;display:flex;align-items:center;">
          <div style="width:6px;height:16px;background:#2A82E4;"></div>
          <p style="margin-left:7px;">显示样式</p>
        </div>

        <!--显示样式设置-->
        <div style="width:100%;margin-top:20px;padding:0 16px 0 20px;">
          <div v-show="$store.state.currChooseMaterialItem.type!=='image'" style="width:100%;display:flex;align-items:center;">
            <p>默认素材样式</p>
            <v-checkbox v-model="$store.state.currChooseMaterialItem.showSet.defaultStyle"
                        @click="changeMaterialShowSet_defaultStyle"
                        dark color="#2A82E4" hide-details style="width:24px;height:24px;margin-top:-8px;margin-left:7px;"
                        class="setMaterialCheckbox">
            </v-checkbox>
            <v-spacer></v-spacer>
            <div v-show="$store.state.currChooseMaterialItem.type==='point'" style="display:flex;align-items:center;">
              <p :style="{'color':$store.state.currChooseMaterialItem.showSet.defaultStyle || !isMaterialHasImage($store.state.currChooseMaterialItem.geoJson.geo.properties.imageList) ? '#CCCCCC' : '#ffffff'}">显示为标记图片</p>
              <v-checkbox v-model="$store.state.currChooseMaterialItem.showSet.showMarkerImage"
                          :disabled="$store.state.currChooseMaterialItem.showSet.defaultStyle
                          || !isMaterialHasImage($store.state.currChooseMaterialItem.geoJson.geo.properties.imageList)"
                          @click="changeMaterialShowSet_showMarkerImage"
                          dark color="#2A82E4" hide-details style="width:24px;height:24px;margin-top:-8px;margin-left:7px;"
                          class="setMaterialCheckbox">
              </v-checkbox>
            </div>
            <div v-show="$store.state.currChooseMaterialItem.type==='lineString' || $store.state.currChooseMaterialItem.type==='roadString'
            || $store.state.currChooseMaterialItem.type==='circle' || $store.state.currChooseMaterialItem.type==='rectangle' || $store.state.currChooseMaterialItem.type==='polygon'"
                 style="display:flex;align-items:center;">
              <p>显示素材标题</p>
              <v-checkbox v-model="$store.state.currChooseMaterialItem.showSet.showName"
                          @click="changeMaterialShowSet_showName"
                          dark color="#2A82E4" hide-details style="width:24px;height:24px;margin-top:-8px;margin-left:7px;"
                          class="setMaterialCheckbox">
              </v-checkbox>
            </div>
          </div>
          <div v-show="$store.state.currChooseMaterialItem.type==='point'" style="width:100%;margin-top:16px;display:flex;align-items:center;">
            <p>显示素材标题</p>
            <v-checkbox v-model="$store.state.currChooseMaterialItem.showSet.showName"
                        @click="changeMaterialShowSet_showName"
                        dark color="#2A82E4" hide-details style="width:24px;height:24px;margin-top:-8px;margin-left:7px;"
                        class="setMaterialCheckbox">
            </v-checkbox>
          </div>
          <div v-show="$store.state.currChooseMaterialItem.type==='lineString' || $store.state.currChooseMaterialItem.type==='roadString'
            || $store.state.currChooseMaterialItem.type==='circle' || $store.state.currChooseMaterialItem.type==='rectangle' || $store.state.currChooseMaterialItem.type==='polygon'" style="width:100%;margin-top:16px;display:flex;align-items:center;">
            <p>显示节点信息</p>
            <v-checkbox v-model="$store.state.currChooseMaterialItem.showSet.showPoint"
                        @click="changeMaterialShowSet_showPoint"
                        dark color="#2A82E4" hide-details style="width:24px;height:24px;margin-top:-8px;margin-left:7px;"
                        class="setMaterialCheckbox">
            </v-checkbox>
          </div>

        </div>

      </div>



      <!--视野点图标-->
      <scene-view-marker-entry @clickMarker="clickSceneViewMarker" v-if="$store.state.sceneViewMarkerShow"
                               :markerList="$store.state.scenePointEditing
                               ? $store.state.tempViewPointList
                               : $store.state.currChooseSceneItemIndex !== ''
                               ? $store.state.sceneList[$store.state.currChooseSceneItemIndex].viewPointList
                               : []"
      ></scene-view-marker-entry>
      <!--添加视野点中 视野点图标-->
      <scene-view-marker-entry-selecting v-if="$store.state.sceneViewMarkerSelectingShow"
                                         :markerList="sceneViewMarkerSelectingList"></scene-view-marker-entry-selecting>

      <!--素材图标 点-->
      <scene-material-point-entry @clickMarker="clickMaterialItem" v-if="$store.state.sceneMaterialShow"
                                  :pointList="(sceneItemPlaying || playing)
                                  ? playMaterialInfo.materialMarkerData.pointList
                                  : $store.state.currChooseSceneItemIndex !== ''
                                  ? $store.state.sceneList[$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.pointList
                                  : $store.state.tempMaterialInfo.materialMarkerData.pointList">
      </scene-material-point-entry>


      <!--素材图标 图片 添加图片中-->
      <scene-material-image-entry-adding v-if="$store.state.sceneMaterialImageAdding" :imageList="$store.state.sceneMaterialImageAddingDataList"
                                         @addMaterialImageFinish="addMaterialImageOK"></scene-material-image-entry-adding>

      <scene-material-image-entry @clickMarker="clickMaterialItem" v-if="$store.state.sceneMaterialShow"
                                  :imageList="sceneItemPlaying
                                  ? playMaterialInfo.materialMarkerData.imageList
                                  : $store.state.currChooseSceneItemIndex !== ''
                                  ? $store.state.sceneList[$store.state.currChooseSceneItemIndex].materialInfo.materialMarkerData.imageList
                                  : $store.state.tempMaterialInfo.materialMarkerData.imageList">
      </scene-material-image-entry>



      <!--播放时常显素材图标 点-->
      <scene-material-point-entry v-if="$store.state.sceneMaterialShow_allShow"
                                  :pointList="$store.state.allShowMaterialMarkerData.pointList">
      </scene-material-point-entry>
      <!--图片-->
      <scene-material-image-entry v-if="$store.state.sceneMaterialShow_allShow"
                                  :imageList="$store.state.allShowMaterialMarkerData.imageList">
      </scene-material-image-entry>


      <!-------------------------------------------------------------------------------------------------------------------------------->

      <!--属性操作-->
      <div v-if="propertiesEditCardShow && mainArea === 'globeOperation'" style="position: absolute;top: 13px;right: 13px;width: 320px;height: 500px;border-radius: 10px;background: rgba(56, 56, 56, 1);overflow: hidden">
        <div style="width: 100%;height: 100%;overflow: hidden;position: relative">
          <!--头部标题-->
          <div style="height: 50px;display: flex;align-items: center;border-bottom: 1px solid rgba(84, 84, 84, 1);">
            <div style="width: 86px;height: 50px;margin-left: 20px;">
              <v-layout class="ma-0" fill-height align-center>
                <div style=" color: white;line-height: 50px;">属性编辑</div>
                <v-tooltip top color="rgba(166, 166, 166, 0.5)">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-show="$store.state.currFolderType === 1 && isEditMarker" style="font-size:12px;cursor:pointer;color: white;margin-left: 10px;line-height: 50px" class="iconfontFamily" v-bind="attrs" v-on="on">&#xe6af;</div>
                  </template>
                  <span style="color: white;font-size: 14px">该标记已被锁定，保存或取消后解锁，最长锁定时间12小时</span>
                </v-tooltip>
              </v-layout>
            </div>
            <v-spacer></v-spacer>
            <div style="width: 30px;height: 30px;border-radius: 50%;cursor: pointer;margin-right: 13px" @click="clickCloseEditCard">
              <v-layout class="ma-0" align-center justify-center fill-height>
                <span class="iconfontFamily" style="font-size: 14px;color: rgba(196, 196, 196, 1);">&#xe659;</span>
              </v-layout>
            </div>
          </div>
          <!--内容区-->
<!--          :style="{'height':$store.state.currFolderRole === 1 || ($store.state.userId === selectItems.geo.properties.userId) ? '380px':'450px'}"-->
          <div style="overflow-y: auto;overflow-x: hidden;padding-left:20px;height: 450px;padding-bottom: 70px" class="propertiesEditCard">
            <!--团队文件标记创建者名字-->
            <div v-if="$store.state.currFolderType === 1" style="margin-top: 15px;font-size: 14px;height: 21px">
              <v-layout row class="ma-0">
                <div style="color: rgba(166, 166, 166, 1);width: 60px;line-height: 21px">创建人</div>
                <v-tooltip bottom max-width="200">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-on="on" v-bind="attrs" style="margin-left: 17px;color: white;width: 203px;line-height: 21px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis">
                      {{selectItems.geo.properties.nickName}}
                    </div>
                  </template>
                  <span style="font-size: 14px;color: white;word-break: break-all;">{{selectItems.geo.properties.nickName}}</span>
                </v-tooltip>
              </v-layout>
            </div>
            <!--名称-->
            <div style="margin-top: 15px;font-size: 14px;height: 21px">
              <v-layout row class="ma-0">
                <div style="color: rgba(166, 166, 166, 1);width: 60px;line-height: 21px">名称</div>
                <div v-if="!isEditMarker">
                  <v-tooltip bottom max-width="200">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-on="on" v-bind="attrs" style="margin-left: 17px;color: white;width: 203px;line-height: 21px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis">
                        {{selectItems.geo.properties.name}}
                      </div>
                    </template>
                    <span style="font-size: 14px;color: white;word-break: break-all;">{{selectItems.geo.properties.name}}</span>
                  </v-tooltip>
                </div>
                <div v-else style="margin-left: 17px;width: 203px;height: 20px">
                  <v-text-field
                          class="jumpTextField"
                          v-model="editNameText"
                          background-color="rgba(56, 56, 56, 1)"
                          style="font-size: 14px;color: white;width: 203px"
                          :rules="rules"
                          dark
                          dense
                          height="20"
                  >
                    <template v-slot:append>
                      <div style="font-size: 12px;margin-top: 4px" :style="{'color':editNameText.length > 20 ? '#ff5252':'rgba(128, 128, 128, 1)'}">{{editNameText.length}}/20</div>
                    </template>
                  </v-text-field>
                  <!--                @blur="blurEditNameText()"-->
                </div>
                <!--              <div v-if="!isEditName" style="color: white;margin-right: 20px;cursor: pointer" @click="editName(selectItems.geo.properties.name)" class="iconfontFamily">&#xe606;</div>-->
                <!--              <div v-else style="margin-right: 20px;width: 14px"></div>-->
              </v-layout>
            </div>
            <!--线段长度-->
            <div v-if="selectItems.geo.properties.type ==='lineString'|| selectItems.geo.properties.type ==='roadString'" style="margin-top: 15px;font-size: 14px;height: 21px">
              <v-layout row class="ma-0">
                <div style="color: rgba(166, 166, 166, 1);width: 60px;line-height: 21px">路线长度</div>
                <div style="color: white;width: 203px;line-height: 21px;margin-left: 17px">
                  {{lengthUomConversion(selectItems.geo.properties.len)}}
                </div>
              </v-layout>
            </div>
            <!--经纬度-->
            <div v-if="selectItems.geo.properties.type ==='point'" style="margin-top: 15px;font-size: 14px;height: 21px">
              <v-layout row class="ma-0">
                <div style="color: rgba(166, 166, 166, 1);width: 60px;line-height: 21px">经纬度</div>
                <div style="color: white;width: 203px;line-height: 21px;margin-left: 17px">
                  {{selectItems.geo.geometry.coordinates[0].toFixed(4)}},{{selectItems.geo.geometry.coordinates[1].toFixed(4)}}
                </div>
              </v-layout>
            </div>
            <!--中心点-->
            <div v-if="selectItems.geo.properties.type ==='circle'" style="margin-top: 15px;font-size: 14px;height: 21px">
              <v-layout row class="ma-0">
                <div style="color: rgba(166, 166, 166, 1);width: 60px;line-height: 21px">中心位置</div>
                <div style="color: white;width: 203px;line-height: 21px;margin-left: 17px">
                  {{selectItems.geo.properties.center[0].toFixed(4)}}&nbsp;,&nbsp;{{selectItems.geo.properties.center[1].toFixed(4)}}
                </div>
              </v-layout>
            </div>
            <!--圆形半径-->
            <div v-if="selectItems.geo.properties.type ==='circle'" style="margin-top: 15px;font-size: 14px;height: 21px">
              <v-layout row class="ma-0">
                <div style="color: rgba(166, 166, 166, 1);width: 60px;line-height: 21px">圆形半径</div>
                <div style="color: white;width: 203px;line-height: 21px;margin-left: 17px">
                  {{lengthUomConversion(selectItems.geo.properties.len)}}
                </div>
              </v-layout>
            </div>
            <!--周长-->
            <div v-if="selectItems.geo.properties.type ==='rectangle'|| selectItems.geo.properties.type ==='polygon'" style="margin-top: 15px;font-size: 14px;height: 21px" >
              <v-layout row class="ma-0">
                <div style="color: rgba(166, 166, 166, 1);width: 60px;line-height: 21px">图形周长</div>
                <div style="color: white;width: 203px;line-height: 21px;margin-left: 17px">
                  {{lengthUomConversion(selectItems.geo.properties.len)}}
                </div>
              </v-layout>
            </div>
            <!--面积-->
            <div v-if="selectItems.geo.properties.type ==='rectangle'|| selectItems.geo.properties.type ==='polygon'||selectItems.geo.properties.type ==='circle'" style="margin-top: 15px;font-size: 14px;height: 21px" >
              <v-layout row class="ma-0">
                <div style="color: rgba(166, 166, 166, 1);width: 60px;line-height: 21px">图形面积</div>
                <div style="color: white;width: 203px;line-height: 21px;margin-left: 17px">
                  {{areaUomConversion(selectItems.geo.properties.area)}}
                </div>
              </v-layout>
            </div>
            <!--当前位置-->
            <div v-if="selectItems.geo.properties.type ==='point'" style="margin-top: 15px;font-size: 14px;height: 21px">
              <v-layout row class="ma-0">
                <div style="color: rgba(166, 166, 166, 1);width: 60px;line-height: 21px">当前位置</div>
                <div v-if="!isEditMarker">
                  <v-tooltip bottom max-width="200">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-on="on" v-bind="attrs" style="margin-left:17px;color: white;width: 203px;line-height: 21px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis">
                        {{selectItems.geo.properties.addrName}}
                      </div>
                    </template>
                    <span style="font-size: 14px;color: white;word-break: break-all;">{{selectItems.geo.properties.addrName}}</span>
                  </v-tooltip>
                </div>
                <div v-else style="width: 203px;height: 20px;margin-left:17px">
                  <v-text-field
                          v-model="editAddrText"
                          class="jumpTextField"
                          background-color="rgba(56, 56, 56, 1)"
                          style="font-size: 14px;color: white;width: 203px"
                          dark
                          dense
                          height="20"
                          :rules="rules1"
                  >
                    <template v-slot:append>
                      <div style="font-size: 12px;margin-top: 4px" :style="{'color':editAddrText.length > 30 ? '#ff5252':'rgba(128, 128, 128, 1)'}">{{editAddrText.length}}/30</div>
                    </template>
                  </v-text-field>
                  <!--                @blur="blurEditAddrText()"-->
                  <!--                @focus="selectValue($event)"-->
                </div>
                <!--              <div v-if="!isEditAddr" style="color: white;margin-right: 20px;cursor: pointer" @click="editAddr(selectItems.geo.properties.addrName)" class="iconfontFamily">&#xe606;</div>-->
                <!--              <div v-else style="margin-right: 20px;width: 14px"></div>-->
              </v-layout>
            </div>
            <!--当前国家-->
            <div v-if="selectItems.geo.properties.type ==='point'" style="margin-top: 4px;font-size: 12px;height: 21px">
              <v-layout row class="ma-0">
                <div style="color: rgba(166, 166, 166, 1);width: 60px;line-height: 21px"></div>
                <div style="color: white;width: 203px;line-height: 21px;color: rgba(166, 166, 166, 1);margin-left: 17px">
                  {{selectItems.geo.properties.country}}
                </div>
              </v-layout>
            </div>
            <!--图形区域-->
            <div v-if="selectItems.geo.properties.type ==='administrativeArea'" style="margin-top: 15px;font-size: 14px">
              <div style="width: 100%" v-if="!isEditMarker">
                <v-layout row class="ma-0">
                  <div style="color: rgba(166, 166, 166, 1);;width: 60px;line-height: 21px">图形区域</div>
                  <div style="margin-left:17px;color: white;width: 203px;line-height: 21px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis">
                    {{selectItems.geo.properties.graphArea}}
                  </div>
                  <!--                <div style="color: white;margin-right: 20px;cursor: pointer;font-size: 16px" @click="isEditArea = true" class="iconfontFamily">&#xe8ad;</div>-->
                </v-layout>
              </div>
              <div style="width: 100%"  v-else>
                <div style="margin-top: 15px;margin-right: 20px">
                  <v-layout row class="ma-0" fill-height justify-space-between>
                    <div style="width: 86px;height: 30px" class="select_btn">
                      <el-select v-model="provinceNow" placeholder="省" :popper-append-to-body="false" size="small" @change="changeProvince">
                        <el-option
                                v-for="item in provinceItems"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                    <div style="width: 86px;height: 30px" class="select_btn">
                      <el-select v-model="cityNow" placeholder="市" :popper-append-to-body="false" size="small" :disabled="!provinceNow" @change="changeCity">
                        <el-option
                                v-for="item in cityItems"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                    <div style="width: 86px;height: 30px" class="select_btn">
                      <el-select v-model="countyNow" placeholder="县" :popper-append-to-body="false" size="small" :disabled="!cityNow" @change="changeCounty">
                        <el-option
                                v-for="item in countyItems"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </v-layout>
                </div>
              </div>
            </div>
            <!--分割线-->
            <div v-if="selectItems.geo.properties.type ==='point'||selectItems.geo.properties.type ==='circle'||selectItems.geo.properties.type ==='administrativeArea'" style="width: 280px;height: 1px;background: rgba(84, 84, 84, 1);margin-top: 15px"></div>
            <!--上传图片视频 -->
            <div v-if="selectItems.geo.properties.type ==='point'||selectItems.geo.properties.type ==='circle'||selectItems.geo.properties.type ==='administrativeArea'" style="width: 100%;" :style="{'height':isEditMarker ? '86px' : selectItems.geo.properties.imageList.length !==0 ? '86px':'0px','margin-top':isEditMarker ? '15px': selectItems.geo.properties.imageList.length !==0 ?'15px':'0px'}">
              <v-layout row class="ma-0" v-if="isEditMarker">
                <label for="file">
                  <div style="width: 86px;height: 86px;border-radius: 2px;border: 1px dashed rgba(128, 128, 128, 1);position: relative;cursor: pointer;">
                    <v-layout column class="ma-0" align-center fill-height justify-center>
                      <div style="font-size: 16px;color: rgba(25, 118, 210, 1)" class="iconfontFamily">&#xe655;</div>
                      <div style="font-size: 14px;color: rgba(128, 128, 128, 1)">图片/视频</div>
                    </v-layout>
                  </div>
                  <input ref="uploadPictureAndVideo" type="file" accept="image/jpg,image/png,image/jpeg,video/mp4, video/wmv, video/avi"  id="file" style="display: none;" @change="getFile">
                </label>
                <div v-if="editSelectItems.geo.properties.imageList.length>0" style="width: 86px;height: 86px;position: relative;margin-left: 11px;cursor: pointer;border-radius:3px;" @click="goToView(1)">
                  <v-img :src="editSelectItems.geo.properties.imageList[0].thumb" width="100%" height="100%" style="border-radius:3px;"></v-img>
                  <div v-if="editSelectItems.geo.properties.imageList[0].type ==='video'" style="position: absolute;top: 0;left: 0;width: 86px;height: 86px;background: rgba(0, 0, 0, 0.5);border-radius:3px;">
                    <v-layout row justify-center fill-height align-center class="ma-0">
                      <div style="font-size: 16px;color: white" class="iconfontFamily">&#xe65e;</div>
                    </v-layout>
                  </div>
                </div>
                <div v-if="editSelectItems.geo.properties.imageList.length > 1" style="width: 86px;height: 86px;position: relative;margin-left: 11px;cursor: pointer;border-radius:3px;" @click="goToView(1)">
                  <v-img :src="editSelectItems.geo.properties.imageList[1].thumb" width="100%" height="100%" style="border-radius:3px;"></v-img>
                  <div v-if="editSelectItems.geo.properties.imageList[1].type ==='video' && editSelectItems.geo.properties.imageList.length === 2" style="position: absolute;top: 0;left: 0;width: 86px;height: 86px;background: rgba(0, 0, 0, 0.5);border-radius:3px;">
                    <v-layout row justify-center fill-height align-center class="ma-0">
                      <div style="font-size: 16px;color: white" class="iconfontFamily">&#xe65e;</div>
                    </v-layout>
                  </div>
                  <div v-if="editSelectItems.geo.properties.imageList.length > 2" style="position: absolute;top: 0;left: 0;width: 86px;height: 86px;background: rgba(0, 0, 0, 0.5);border-radius:3px;">
                    <v-layout row justify-center fill-height align-center class="ma-0">
                      <div style="font-size: 20px;color: white;line-height: 30px">+{{editSelectItems.geo.properties.imageList.length-2}}</div>
                    </v-layout>
                  </div>
                </div>
              </v-layout>
              <v-layout row class="ma-0" v-else>
                <div v-if="selectItems.geo.properties.imageList.length>0" style="width: 86px;height: 86px;position: relative;cursor: pointer;border-radius:3px;" @click="goToView(0)">
                  <v-img :src="selectItems.geo.properties.imageList[0].thumb" width="100%" height="100%" style="border-radius:3px;"></v-img>
                  <div v-if="selectItems.geo.properties.imageList[0].type ==='video'" style="position: absolute;top: 0;left: 0;width: 86px;height: 86px;background: rgba(0, 0, 0, 0.5);border-radius:3px;">
                    <v-layout row justify-center fill-height align-center class="ma-0">
                      <div style="font-size: 16px;color: white" class="iconfontFamily">&#xe65e;</div>
                    </v-layout>
                  </div>
                </div>
                <div v-if="selectItems.geo.properties.imageList.length>1" style="width: 86px;height: 86px;position: relative;margin-left: 11px;cursor: pointer;border-radius:3px;" @click="goToView(0)">
                  <v-img :src="selectItems.geo.properties.imageList[1].thumb" width="100%" height="100%" style="border-radius:3px;"></v-img>
                  <div v-if="selectItems.geo.properties.imageList[1].type ==='video'" style="position: absolute;top: 0;left: 0;width: 86px;height: 86px;background: rgba(0, 0, 0, 0.5);border-radius:3px;">
                    <v-layout row justify-center fill-height align-center class="ma-0">
                      <div style="font-size: 16px;color: white" class="iconfontFamily">&#xe65e;</div>
                    </v-layout>
                  </div>
                </div>
                <div v-if="selectItems.geo.properties.imageList.length > 2" style="width: 86px;height: 86px;position: relative;margin-left: 11px;cursor: pointer;border-radius:3px;" @click="goToView(0)">
                  <v-img :src="selectItems.geo.properties.imageList[2].thumb" width="100%" height="100%" style="border-radius:3px;"></v-img>
                  <div v-if="selectItems.geo.properties.imageList[2].type ==='video' && selectItems.geo.properties.imageList.length === 3" style="position: absolute;top: 0;left: 0;width: 86px;height: 86px;background: rgba(0, 0, 0, 0.5);border-radius:3px;">
                    <v-layout row justify-center fill-height align-center class="ma-0">
                      <div style="font-size: 16px;color: white" class="iconfontFamily">&#xe65e;</div>
                    </v-layout>
                  </div>
                  <div v-if="selectItems.geo.properties.imageList.length > 3" style="position: absolute;top: 0;left: 0;width: 86px;height: 86px;background: rgba(0, 0, 0, 0.5);border-radius:3px;">
                    <v-layout row justify-center fill-height align-center class="ma-0">
                      <div style="font-size: 20px;color: white;line-height: 30px">+{{selectItems.geo.properties.imageList.length-3}}</div>
                    </v-layout>
                  </div>
                </div>
              </v-layout>
            </div>
            <!--备注-->
            <div style="margin-top: 15px;width: 100%">
              <div v-if="!isEditMarker" style="width:100%;height: 20px;display: flex;align-items: center">
                <div style="width: 4px;height: 14px;background: rgba(166, 166, 166, 1)"></div>
                <div style="font-size: 14px;color: white;margin-left: 4px">点位备注</div>
                <!--              @click="editRemark(selectItems.geo.properties.remark)"-->
              </div>
              <div v-if="!isEditMarker" style="width: 280px;margin-top: 10px;color: rgba(166, 166, 166, 1);font-size: 14px;line-height: 16px">{{selectItems.geo.properties.remark.length === 0 ? '暂无备注' : selectItems.geo.properties.remark}}</div>
              <div v-else style="width: 280px">
                <v-textarea
                        v-model="editRemarkText"
                        height="80"
                        no-resize
                        background-color="rgba(56, 56, 56, 1)"
                        style="font-size: 14px;line-height: 20px"
                        dark
                        dense
                        outlined
                        counter="100"
                        :rules="rules2"
                >
                </v-textarea>
              </div>
            </div>
            <div v-if="selectItems.geo.properties.type ==='administrativeArea'" style="width: 280px;height: 1px;background: rgba(84, 84, 84, 1);margin-top: 15px"></div>
            <!--点位信息,展示-->
            <div v-if="selectItems.points.length >0 &&!isEditMarker" style="margin-top: 15px;width: 100%">
              <div style="cursor: pointer;width: 84px" @click="pointInfoShow = !pointInfoShow">
                <v-layout row class="ma-0">
                  <div style="font-size: 14px;color: white;line-height: 20px">点位信息</div>
                  <div style="font-size: 14px;height: 16px;width: 16px;color: rgba(166, 166, 166, 1);margin-left: 7px" ><span class="iconfontFamily">{{pointInfoShow ? '&#xe650;':'&#xe65c;' }}</span></div>
                </v-layout>
              </div>
              <div v-if="pointInfoShow">
                <div style="width: 280px;margin-top: 16px;height: 1px;background: rgba(204, 204, 204, 1)"></div>
                <div style="width: 280px;margin-top: 16px;;font-size: 14px">
                  <v-expansion-panels accordion dark flat focusable multiple class="expansionPanels">
                    <v-expansion-panel v-for="(item,index) in selectItems.points" :key="index" style="background: rgba(56, 56, 56, 1);" disable-icon-rotate>
                      <v-expansion-panel-header style="font-size: 14px">
                        <div style="width: calc(100% - 30px);white-space: nowrap;overflow: hidden;text-overflow: ellipsis">{{item.properties.name}}</div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div style="width: 100%;padding: 0 10px;margin-top: 10px">
                          <v-layout row class="ma-0">
                            <div style="color: rgba(166, 166, 166, 1);width: 60px;line-height: 21px">名称</div>
                            <div style="color: white;width: 170px;line-height: 21px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;margin-left: 17px">
                              {{item.properties.name}}
                            </div>
                          </v-layout>
                        </div>
                        <div style="width: 100%;padding: 0 10px;margin-top: 10px;display: flex;font-size: 14px">
                          <v-layout row class="ma-0">
                            <div style="color: rgba(166, 166, 166, 1);width: 60px;line-height: 21px">经纬度</div>
                            <div style="color: white;line-height: 21px;width: 170px;margin-left: 17px">
                              {{item.geometry.coordinates[0].toFixed(4)}},{{item.geometry.coordinates[1].toFixed(4)}}
                            </div>
                          </v-layout>
                          <!--                        <lng-lat-info :lng="item.geometry.coordinates[0]" :lat="item.geometry.coordinates[1]"></lng-lat-info>-->
                        </div>
                        <div style="width: 100%;padding: 0 10px;margin-top: 10px">
                          <v-layout row class="ma-0">
                            <div style="color: rgba(166, 166, 166, 1);width: 60px;line-height: 21px">位置</div>
                            <v-tooltip bottom max-width="200">
                              <template v-slot:activator="{ on, attrs }">
                                <div v-on="on" v-bind="attrs" style="color: white;width: 170px;line-height: 21px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;margin-left: 17px">
                                  {{item.properties.addrName}}
                                </div>
                              </template>
                              <span style="font-size: 14px;color: white;word-break: break-all">{{item.properties.addrName}}</span>
                            </v-tooltip>
                          </v-layout>
                        </div>
                        <div style="width: 100%;padding: 0 10px;margin: 10px 0;">
                          <upload-picture-and-video :value="item.properties.imageList" :isEdit="false" :uploadIndex="index" @addItem="addItem" @errorUploadValue="errorUploadValue" :key="index" @setLoading="setLoading"></upload-picture-and-video>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
                <div style="width: 280px;margin-top: 16px;height: 1px;background: rgba(204, 204, 204, 1)"></div>
              </div>
            </div>
            <!--点位信息,修改-->
            <div v-if="selectItems.points.length >0 &&isEditMarker" style="margin-top: 15px;width: 100%">
              <div style="cursor: pointer;width: 84px" @click="pointInfoShow = !pointInfoShow">
                <v-layout row class="ma-0">
                  <div style="font-size: 14px;color: white;line-height: 20px">点位信息</div>
                  <div style="font-size: 14px;height: 16px;width: 16px;color: rgba(166, 166, 166, 1);margin-left: 7px" ><span class="iconfontFamily">{{pointInfoShow ? '&#xe650;':'&#xe65c;' }}</span></div>
                </v-layout>
              </div>
              <div v-if="pointInfoShow">
                <div style="width: 280px;margin-top: 16px;height: 1px;background: rgba(204, 204, 204, 1)"></div>
                <div style="width: 280px;margin-top: 16px;">
                  <v-expansion-panels accordion dark flat focusable multiple class="expansionPanels">
                    <v-expansion-panel v-for="(item,index) in editSelectItems.points" :key="index" style="background: rgba(56, 56, 56, 1);" disable-icon-rotate>
                      <v-expansion-panel-header style="font-size: 14px">
                        <div style="width: calc(100% - 30px);white-space: nowrap;overflow: hidden;text-overflow: ellipsis">{{item.properties.name}}</div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div style="width: 100%;padding: 0 10px;margin-top: 10px">
                          <name-editor :curr-name="item.properties.name" :nameIndex="index" @changeName="changeName" @errorValue="errorUploadValue"></name-editor>
                        </div>
                        <div style="width: 100%;padding: 0 10px;margin-top: 10px;display: flex;font-size: 14px">
                          <lng-lat-info :lng="item.geometry.coordinates[0]" :lat="item.geometry.coordinates[1]"></lng-lat-info>
                        </div>
                        <div style="width: 100%;padding: 0 10px;margin-top: 10px">
                          <location-editor :currAddrName="item.properties.addrName" :country="item.properties.country" :addrIndex="index" @changeAddrName="changeAddrName"></location-editor>
                        </div>
                        <div style="width: 100%;padding: 0 10px;margin: 10px 0;">
                          <upload-picture-and-video :value="item.properties.imageList" :isEdit="true" :uploadIndex="index" @addItem="addItem" @errorUploadValue="errorUploadValue" :key="index" @setLoading="setLoading"></upload-picture-and-video>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
                <div style="width: 280px;margin-top: 16px;height: 1px;background: rgba(204, 204, 204, 1)"></div>
              </div>

            </div>
            <!--显示设置 -->
            <div style="margin-top: 15px;width: 100%;margin-bottom: 15px">
              <div style="cursor: pointer;width: 84px" @click="settingShow = !settingShow">
                <v-layout row class="ma-0">
                  <div style="font-size: 14px;color: white;line-height: 20px">显示设置</div>
                  <div style="font-size: 14px;height: 16px;width: 16px;color: rgba(166, 166, 166, 1);margin-left: 7px" ><span class="iconfontFamily">{{settingShow ? '&#xe650;':'&#xe65c;' }}</span></div>
                </v-layout>
              </div>

              <div v-if="!isEditMarker && settingShow">
                <div v-if="selectItems.geo.properties.type ==='point'" >
                  <div style="margin-top: 20px;margin-bottom: 20px;margin-left: 5px">
                    <v-layout class="ma-0">
                      <div style="line-height: 30px;color: rgba(166, 166, 166, 1);width: 56px;font-size: 14px">图标大小</div>
                      <div style="color: white;font-size: 14px;line-height: 30px;margin-left: 75px;">{{selectItems.geo.properties.size === 0.6 ? '小' : selectItems.geo.properties.size === 0.8 ? '中':'大' }}</div>
                    </v-layout>
                  </div>
                  <div style="margin-left: 5px;margin-top: 10px">
                    <v-layout row class="ma-0">
                      <div style="line-height: 40px;color: rgba(166, 166, 166, 1);width: 56px;font-size: 14px">图标</div>
                      <div style="height: 40px;width: 40px;border-radius: 2px;border: 1px solid rgba(128, 128, 128, 1);margin-left: 75px">
                        <v-layout row align-center fill-height justify-center class="ma-0">
                          <div style="font-size: 24px;color: rgba(42, 130, 228, 1)" class="iconfontFamily" v-html="selectItems.geo.properties.code"></div>
                        </v-layout>
                      </div>
                    </v-layout>
                  </div>
                  <div style="margin-top: 20px;margin-left: 5px;margin-bottom: 20px">
                    <v-layout row class="ma-0">
                      <div style="line-height: 30px;color: rgba(166, 166, 166, 1);width: 56px;font-size: 14px">图标颜色</div>
                      <div style="height: 30px;width: 40px;border-radius: 2px;border: 1px solid rgba(166, 166, 166, 1);margin-left: 75px;" :style="{'background-color': selectItems.geo.properties.color}">
                      </div>
                    </v-layout>
                  </div>
                </div>
                <div v-if="selectItems.geo.properties.type ==='lineString'|| selectItems.geo.properties.type ==='roadString'" style="margin-left: 5px;margin-top: 18px">
                  <div style="margin-top: 20px">
                    <v-layout row class="ma-0">
                      <div style="line-height: 30px;color: rgba(166, 166, 166, 1);width: 56px;font-size: 14px">线条颜色</div>
                      <div style="height: 30px;width: 40px;border-radius: 2px;border: 1px solid rgba(166, 166, 166, 1);margin-left: 75px;" :style="{'background-color': selectItems.geo.properties.color}"></div>
                    </v-layout>
                  </div>
                  <div style="margin-top: 20px;margin-bottom: 20px">
                    <v-layout row class="ma-0">
                      <div style="line-height: 30px;color: rgba(166, 166, 166, 1);width: 56px;font-size: 14px">线条宽度</div>
                      <div style="color: white;font-size: 14px;line-height: 30px;margin-left: 75px;">{{selectItems.geo.properties.width }}</div>
                    </v-layout>
                  </div>
                </div>
                <div v-if="selectItems.geo.properties.type ==='rectangle'||selectItems.geo.properties.type ==='polygon'|| selectItems.geo.properties.type ==='circle'||selectItems.geo.properties.type ==='administrativeArea'" style="margin-left: 5px;margin-top: 18px">
                  <div style="margin-top: 20px">
                    <v-layout row class="ma-0">
                      <div style="line-height: 30px;color: rgba(166, 166, 166, 1);width: 56px;font-size: 14px">线条宽度</div>
                      <div style="color: white;font-size: 14px;line-height: 30px;margin-left: 75px;">{{selectItems.geo.properties.width }}</div>
                    </v-layout>
                  </div>
                  <div style="margin-top: 20px">
                    <v-layout row class="ma-0">
                      <div style="line-height: 30px;color: rgba(166, 166, 166, 1);width: 56px;font-size: 14px">线条颜色</div>
                      <div style="height: 30px;width: 40px;border-radius: 2px;border: 1px solid rgba(166, 166, 166, 1);margin-left: 75px;" :style="{'background-color': selectItems.geo.properties.lineColor}"></div>
                    </v-layout>
                  </div>
                  <div style="margin-top: 20px;margin-bottom: 20px">
                    <v-layout row class="ma-0">
                      <div style="line-height: 30px;color: rgba(166, 166, 166, 1);width: 56px;font-size: 14px">填充颜色</div>
                      <div style="height: 30px;width: 40px;border-radius: 2px;border: 1px solid rgba(166, 166, 166, 1);margin-left: 75px;" :style="{'background-color': selectItems.geo.properties.color}"></div>
                    </v-layout>
                  </div>
                </div>
              </div>
              <div v-if="isEditMarker&& settingShow">
                <div v-if="selectItems.geo.properties.type ==='point'" >
                  <div style="margin-top: 20px;margin-bottom: 20px;margin-left: 25px">
                    <size-picker :currSize="editSelectItems.geo.properties.size" @changeSize="changeSize"></size-picker>
                  </div>
                  <div style="margin-left: 25px;margin-top: 10px">
                    <icon-picker :iconCode="editSelectItems.geo.properties.code" @changeIcon="changeIcon"></icon-picker>
                  </div>
                  <div style="margin-top: 20px;margin-left: 25px;margin-bottom: 20px">
                    <symbol-color-picker :title="'图标颜色'" :type="'color'" :currColor="editSelectItems.geo.properties.color" @changeColor="changeColor"></symbol-color-picker>
                  </div>
                </div>
                <div v-if="selectItems.geo.properties.type ==='lineString'|| selectItems.geo.properties.type ==='roadString'" style="margin-left: 25px;margin-top: 18px">
                  <div style="margin-top: 20px">
                    <color-picker :title="'线条颜色'" :type="'color'" :currColor="editSelectItems.geo.properties.color" :isShow="false" @changeColor="changeColor"></color-picker>
                  </div>
                  <div style="margin-top: 20px;margin-bottom: 20px">
                    <v-layout row class="ma-0">
                      <div style="line-height: 30px;color: rgba(166, 166, 166, 1);width: 56px;font-size: 14px">线条宽度</div>
                      <input-number v-model="editSelectItems.geo.properties.width" width="100" height="30" maxValue="10" minValue="1" unit="像素"
                                    @errorValue="errorUploadValue('超过限制')"
                                    @changeValue="changeValue"
                                    style="margin-left:75px;"></input-number>
                    </v-layout>
                  </div>
                </div>
                <div v-if="selectItems.geo.properties.type ==='rectangle'||selectItems.geo.properties.type ==='polygon'|| selectItems.geo.properties.type ==='circle'||selectItems.geo.properties.type ==='administrativeArea'" style="margin-left: 25px;margin-top: 18px">
                  <div style="margin-top: 20px">
                    <v-layout row class="ma-0">
                      <div style="line-height: 30px;color: rgba(166, 166, 166, 1);width: 56px;font-size: 14px">线条宽度</div>
                      <input-number v-model="editSelectItems.geo.properties.width" width="100" height="30" maxValue="10" minValue="0" unit="像素"
                                    @errorValue="errorUploadValue('超过限制')"
                                    @changeValue="changeValue"
                                    style="margin-left:75px;"></input-number>
                    </v-layout>
                  </div>
                  <div style="margin-top: 20px">
                    <color-picker :title="'线条颜色'"  :type="'lineColor'" :currColor="editSelectItems.geo.properties.lineColor" :isShow="false" @changeColor="changeColor"></color-picker>
                  </div>
                  <div style="margin-top: 20px;margin-bottom: 20px">
                    <color-picker :title="'填充颜色'" :type="'color'" :currColor="editSelectItems.geo.properties.color" :isShow="false" @changeColor="changeColor"></color-picker>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--按钮区-->
          <div v-if="$store.state.currFolderRole === 1 || ($store.state.userId === selectItems.geo.properties.userId)" style="height: 70px;display: flex;flex-direction: column;width: 316px;position: absolute;left: 0;bottom: 0;z-index: 1">
            <div style="height: 16px;width: 100%;background: linear-gradient(180deg, rgba(56, 56, 56, 0.1) 0%, rgba(56, 56, 56, 0.3) 14.81%, rgba(56, 56, 56, 0.7) 70.37%, rgba(56, 56, 56, 1) 100%);"></div>
            <div style="height: 54px;width: 312px;background: rgba(56, 56, 56, 1);margin-left: 4px">
              <v-layout class="ma-0" fill-height justify-center align-center v-if="!isEditMarker">
                <div style="height: 30px;width: 100px;border-radius: 6px;background: rgba(25, 110, 207, 1);cursor: pointer" @click="isEditCardContext()">
                  <v-layout class="ma-0" fill-height justify-center align-center>
                    <div class="iconfontFamily" style="font-size: 16px;color: white">&#xe693;</div>
                    <div style="font-size: 14px;color: white;margin-left: 10px">编辑</div>
                  </v-layout>
                </div>
              </v-layout>
              <v-layout class="ma-0" fill-height justify-center align-center v-else>
                <div style="height: 30px;width: 100px;border-radius: 6px;background: rgba(25, 110, 207, 1);cursor: pointer" @click="cancelSave()">
                  <v-layout class="ma-0" fill-height justify-center align-center>
                    <div class="iconfontFamily" style="font-size: 16px;color: white">&#xe68b;</div>
                    <div style="font-size: 14px;color: white;margin-left: 10px">取消</div>
                  </v-layout>
                </div>
                <div v-if="selectItems.geo.properties.type ==='point'" style="height: 30px;width: 100px;border-radius: 6px;cursor: pointer;margin-left: 30px" :style="{'background':(editRemarkText.length <=100 && editAddrText.length <=30 &&editNameText.length <=20 && editNameText.length !== 0  && editAddrText.length !==0) ? 'rgba(25, 110, 207, 1)':'rgba(25, 110, 207, 0.5)'}" @click="(editRemarkText.length <=100 &&editAddrText.length <=30 &&editNameText.length <=20 && editNameText.length !== 0 && editAddrText.length !==0) ? editCardSave():''">
                  <v-layout class="ma-0" fill-height justify-center align-center>
                    <div class="iconfontFamily" style="font-size: 16px;color: white">&#xe68d;</div>
                    <div style="font-size: 14px;color: white;margin-left: 10px">保存</div>
                  </v-layout>
                </div>
                  <div v-else style="height: 30px;width: 100px;border-radius: 6px;cursor: pointer;margin-left: 30px" :style="{'background':(editRemarkText.length <=100 && editAddrText.length <=30 &&editNameText.length <=20 && editNameText.length !== 0) ? 'rgba(25, 110, 207, 1)':'rgba(25, 110, 207, 0.5)'}" @click="(editRemarkText.length <=100 &&editAddrText.length <=30 &&editNameText.length <=20 && editNameText.length !== 0) ? editCardSave():''">
                      <v-layout class="ma-0" fill-height justify-center align-center>
                          <div class="iconfontFamily" style="font-size: 16px;color: white">&#xe68d;</div>
                          <div style="font-size: 14px;color: white;margin-left: 10px">保存</div>
                      </v-layout>
                  </div>
              </v-layout>
            </div>
          </div>
        </div>
      </div>
      <!--画圆半径弹窗，第二次鼠标点击-->
      <div v-if="circleRadiusCardShow && mainArea === 'globeOperation'" :style="{'top':circleRadiusCardTop,'left':circleRadiusCardLeft}"
           style="position:absolute;background:white;border:1px solid rgba(255, 255, 255, 0.5);border-radius:4px;width: 158px;height: 74px;padding: 16px 14px 0 10px">
        <div style="font-size: 12px;height: 20px">
          <v-layout row align-center fill-height class="ma-0">
            <div style="line-height: 20px;color: rgba(128, 128, 128, 1);">半径</div>
            <div style="height: 20px;width: 80px;margin-left: 8px">
              <v-text-field
                      v-model="circleRadiusText"
                      class="circleRadiusText"
                      outlined
                      style="font-size: 12px"
                      solo
                      type="number"
                      hide-spin-buttons
                      flat
                      dense
                      height="12"
                      @keyup.enter="sureCircleRadius"
              ></v-text-field>
            </div>
            <div style="line-height: 20px;color:black;margin-left: 8px">米</div>
          </v-layout>
        </div>
        <div style="font-size: 12px;margin-top: 14px;color: rgba(128, 128, 128, 1);">
          <v-layout row align-center fill-height justify-end class="ma-0">
            <div style="cursor: pointer;width: 24px;height: 20px;line-height: 20px;text-align: center" @click="cancelCircleRadius">取消</div>
            <div style="cursor: pointer;margin-left: 14px;width: 24px;height: 20px;" @click="sureCircleRadius">确定</div>
          </v-layout>
        </div>
      </div>

      <!--行政区域中间态  -->
      <div v-if="areaCardShow && mainArea === 'globeOperation'" style="position: absolute;top: 13px;right: 13px;width: 320px;height: 220px;border-radius: 10px;background: rgba(56, 56, 56, 1)">
        <div style="height: 50px;display: flex;align-items: center;border-bottom: 1px solid rgba(84, 84, 84, 1); ">
          <div style="color: white;line-height: 50px;margin-left: 20px;">区域图形添加</div>
          <v-spacer></v-spacer>
          <div style="width: 30px;height: 30px;border-radius: 50%;cursor: pointer;margin-right: 13px" @click="closeAreaCard()">
            <v-layout class="ma-0" align-center justify-center fill-height>
              <span class="iconfontFamily" style="font-size: 14px;color: rgba(196, 196, 196, 1);">&#xe659;</span>
            </v-layout>
          </div>
        </div>
        <div style="font-size: 14px">
          <div style="margin: 15px 20px;color:white">点击左侧地图，完成选择后点击下方添加图形即可添加当前所选的行政区域图形</div>
          <div>
            <v-layout row class="ma-0">
              <div style="color: rgba(166, 166, 166, 1);margin-left: 20px;width: 60px;line-height: 21px">名称</div>
              <div style="color: white;width: 240px;line-height: 21px;">{{areaName}}</div>
            </v-layout>
          </div>
        </div>
        <div style="font-size: 14px;margin-top: 10px;display: flex;align-items: center">
          <v-btn height="30" width="90" color="#1976D2" style="color:white; margin: 0 auto" depressed @click="sureAreaFigure">添加图形</v-btn>
        </div>
      </div>

      <!--图层列表卡片展示-->
      <div v-if="layerCardShow && mainArea === 'globeOperation'" style="position: absolute;top: 10px;right: 12px;width: 290px;height: 320px;background: rgba(56, 56, 56, 1);border-radius: 10px">
        <div style="height: 50px;display: flex;align-items: center;border-bottom: 1px solid rgba(84, 84, 84, 1);">
          <div style=" color: white;line-height: 50px;margin-left: 20px">图层样式</div>
          <v-spacer></v-spacer>
          <div style="font-size: 16px;color: rgba(196, 196, 196, 1);line-height: 50px;margin-right: 20px;cursor: pointer" class="iconfontFamily" @click="closeLayerCardShow">&#xe659;</div>
        </div>
        <div style="margin: 20px 16px;width: 258px;height: 30px;border-radius: 2px;background: rgba(128, 128, 128, 1);box-shadow: 0 2px 4px rgba(0,0,0,0.25);display: flex">
          <div v-if="$store.state.selectLayerTreeNode.data.userId ===$store.state.userId">
            <div v-if="$store.state.selectLayerTreeNode.data.annexStatus === 1" style="cursor: pointer;width: 88px;margin-left: 8px;display: flex" @click="viewAnnexData">
              <div class="iconfontFamily" style="font-size: 16px;color: white;line-height: 30px">&#xe69a;</div>
              <div style="font-size: 16px;color: white;line-height: 30px;margin-left: 8px">查看数据</div>
            </div>
            <div v-else style="cursor: pointer;width: 88px;margin-left: 21px;display: flex;height: 21px"></div>
          </div>
          <div v-else>
            <div v-if="$store.state.selectLayerTreeNode.data.annexStatus === 1" style="cursor: pointer;width: 135px;margin-left: 8px;display: flex" @click="saveAsMyData">
              <div class="iconfontFamily" style="font-size: 16px;color: white;line-height: 30px">&#xe698;</div>
              <div style="font-size: 16px;color: white;line-height: 30px;margin-left: 8px">另存为我的数据</div>
            </div>
            <div v-else style="cursor: pointer;width: 105px;margin-left: 21px;display: flex;height: 21px"></div>
          </div>
          <v-spacer></v-spacer>
          <div style="cursor: pointer;width: 88px;margin-right: 8px;display: flex">
            <div class="iconfontFamily" style="font-size: 16px;color: rgba(166, 166, 166, 1);line-height: 30px">&#xe699;</div>
            <div style="font-size: 16px;color: rgba(166, 166, 166, 1);line-height: 30px;margin-left: 8px">代码编辑</div>
          </div>
        </div>
        <div style="width: 100%;padding: 0 30px;" v-if="$store.state.selectLayerTreeNode.data.type === 'point'" >
          <div style="width: 100%">
            <v-layout class="ma-0" justify-space-between>
              <img @click="selectLayerTypeShow('square')" :src="$store.state.selectLayerTreeNode.data.style === 'square' ? require('../../assets/globe/import_annex/square_selected.png') : require('../../assets/globe/import_annex/square.png')" style="width: 100px;height: 65px;border-radius: 6px;cursor: pointer;" :style="{'border': $store.state.selectLayerTreeNode.data.style === 'square' ? '2px solid rgba(25,118,210,1)':''}" />
              <img @click="selectLayerTypeShow('heatMap')" :src="$store.state.selectLayerTreeNode.data.style === 'heatMap' ? require('../../assets/globe/import_annex/heatMap_selected.png') : require('../../assets/globe/import_annex/heatMap.png')" style="width: 100px;height: 65px;border-radius: 6px;cursor: pointer;" :style="{'border': $store.state.selectLayerTreeNode.data.style === 'heatMap' ? '2px solid rgba(25,118,210,1)':''}" />
            </v-layout>
          </div>
          <img @click="selectLayerTypeShow('histogram')" :src="$store.state.selectLayerTreeNode.data.style === 'histogram' ? require('../../assets/globe/import_annex/histogram_selected.png') : require('../../assets/globe/import_annex/histogram.png')" style="width: 100px;height: 65px;border-radius: 6px;cursor: pointer;margin-top: 20px" :style="{'border': $store.state.selectLayerTreeNode.data.style === 'histogram' ? '2px solid rgba(25,118,210,1)':''}" />
        </div>
        <div style="width: 100%;padding: 0 30px;" v-else>
          <div style="width: 100%">
            <v-layout class="ma-0" justify-space-between>
              <img @click="selectLayerTypeShow('2Dline')" :src="$store.state.selectLayerTreeNode.data.style === '2Dline' ? require('../../assets/globe/import_annex/2Dline_selected.png') : require('../../assets/globe/import_annex/2Dline.png')" style="width: 100px;height: 65px;border-radius: 6px;cursor: pointer;" :style="{'border': $store.state.selectLayerTreeNode.data.style === '2Dline' ? '2px solid rgba(25,118,210,1)':''}" />
              <img @click="selectLayerTypeShow('3Dline')" :src="$store.state.selectLayerTreeNode.data.style === '3Dline' ? require('../../assets/globe/import_annex/3Dline_selected.png') : require('../../assets/globe/import_annex/3Dline.png')" style="width: 100px;height: 65px;border-radius: 6px;cursor: pointer;" :style="{'border': $store.state.selectLayerTreeNode.data.style === '3Dline' ? '2px solid rgba(25,118,210,1)':''}" />
            </v-layout>
          </div>
        </div>
      </div>
      <curve3d v-for="(item, index) in store_curve3dList" :key="item.layerId"
               :map="map" :tb="tb"
               :lineColor="'#FF0000'" :lineWidth="2" :lineOpacity="0.5" :maxAltitude="50000"
               :featureCollection="item.geojson"/>
      <data-grid v-for="(item, index) in store_dataGridList" :key="item.layerId" :map="map" :dataPropertyName="'pValue'"
                 :pointData="item.geojson"></data-grid>
      <heat-map v-for="(item, index) in store_heatMapList" :key="item.layerId" :map="map" :layer-id="item.layerId" :dataPropertyName="'pValue'"
                :pointData="item.geojson"></heat-map>
      <curve2d v-for="(item, index) in store_2DlineList" :key="item.layerId" :color="'#FF0000'" :map="map" :layer-id="item.layerId" :width="2" :opacity="1"
               :lineData="item.geojson"></curve2d>
      <histogram-map v-for="(item, index) in store_histogramList" :key="item.layerId" :map="map" :layer-id="item.layerId"
                     :featureCollection="item.geojson" :dataPropertyName="'pValue'"></histogram-map>
      <satellite-layer v-for="(item, index) in store_satelliteLayerList" :key="item.mainId" :layer-id="item.mainId" :layer-url="item.layer" :map="map"></satellite-layer>
      <div v-if="mainArea === 'globeOperation'" style="position: absolute;left: 30px;top: 0;width: 243px;height: 154px;overflow: hidden">
        <template v-for="(item,index) in messageShowQueue">
          <div :key="index" style="height: 46px;width: 243px;border-radius: 6px;border: 1px solid rgba(255,255,255,0.3);display: flex;position: absolute;bottom: 0; left: 0;opacity: 1;
        align-items: center;background: rgba(56, 56, 56, 0.85);font-size: 12px;color:rgba(166, 166, 166, 1);margin-top: 13px;animation: messageQueue_center 1s 2s,messageQueue_top 1s 4s;animation-fill-mode: forwards">
            <v-avatar size="32" style="margin-left: 9px">
              <v-img :src="item.avatar" style="width:100%;height:100%;"></v-img>
            </v-avatar>
            <div style="width: 63px;height: 22px;line-height: 22px;margin-left: 8px;white-space: nowrap;text-overflow: ellipsis;overflow:hidden">{{item.nickName}}</div>
            <div style="width: 120px;height: 22px;line-height: 22px;margin-left: 4px;white-space: nowrap;text-overflow: ellipsis;overflow:hidden">{{item.operation}}</div>
          </div>
<!--          <div style="width: 100%;height: 100%;overflow: hidden;position: relative">-->
<!--           -->
<!--          </div>-->
        </template>

      </div>
    </div>

    <!--全屏尺寸地球，和主地球样式相同，录屏用于截屏-->
    <div ref="sceneFullMap" id="sceneFullMap" style="position:absolute;top:0;left:0;width:100%;height:100%;background:#000000;z-index:-1;"></div>




    <v-dialog width="600" v-model="notSavedDialog" persistent>
      <v-card>
        <!--标题-->
        <div style="height: 70px;width: 100%;border-bottom:1px solid #a6a6a6;">
          <v-layout class="ma-0" fill-height justify-space-between align-center>
            <div style="font-size: 20px;line-height: 28px;color: black;margin-left: 22px">温馨提示</div>
            <div @click="notSavedDialog = false" style="font-size: 15px;color: #a6a6a6;margin-right: 27px;cursor: pointer" class="iconfontFamily"> &#xe60d;</div>
          </v-layout>
        </div>
        <div style="height: 230px;width: 100%;padding-top: 70px;padding-bottom: 16px">
          <div style="height: 24px;line-height: 24px;width: 100%;text-align: center">当前标记尚未保存，未防止失去未保存内容，您要保存此标记吗？</div>
          <div style="height: 35px;width: 100%;margin-top: 85px">
            <v-layout class="ma-0" justify-end>
              <div style="height: 35px;width: 100px;background: rgba(30, 58, 138, 1);text-align: center;line-height: 35px;color: white;cursor: pointer" @click="editCardSave">保存</div>
              <div style="height: 35px;width: 100px;background:rgba(245, 245, 245, 1);text-align: center;line-height: 35px;cursor: pointer;margin-left: 24px;margin-right: 27px" @click="notSavedDialog = false">返回</div>
            </v-layout>
          </div>
        </div>
      </v-card>
    </v-dialog>



    <!--全页面透明蒙层，配合搜索等功能-->
    <div v-if="transparentMantle" style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:10;"></div>

    <!--影像集停用弹窗 带蒙层-->
    <v-dialog v-model="folderStopDialogShow" persistent width="540">
      <v-card>
        <v-card-title class="tipsDialog-title">
          温馨提示
          <v-spacer></v-spacer>
          <p @click="folderStopDialogShow = false" class="tipsDialog-close iconfontFamily">&#xe60d;</p>
        </v-card-title>
        <v-card-text class="tipsDialog-mainAreaNoIcon">
          <p class="tipsDialog-mainAreaNoIcon-text">该影像集已停用，主界面将不再展示</p>
          <p class="tipsDialog-mainAreaNoIcon-text">若您已购买下载，可点击下方按钮进行重复下载</p>
          <div class="tipsDialog-mainArea-btnLine">
            <v-btn @click="intoStopImageDetailPage" width="100" height="35" dark color="#1867C0">查看详情</v-btn>
            <v-btn @click="downloadStopImage" width="100" height="35" dark color="#1E3A8A" style="margin-left:50px;">重新下载</v-btn>
          </div>
        </v-card-text>
        <!--影像集未购买toast-->
        <div v-if="folderNotBuyToastShow" style="position:absolute;left:50%;top:2px;transform:translate(-50%,0);height:32px;background:#FFC300;padding:0 30px;">
          <p style="line-height:32px;color:#ffffff;font-size:16px;">影像未购买</p>
        </div>

      </v-card>
    </v-dialog>

    <download-products v-if="downloadMainId !== '' && $store.state.showDownloadProductsDialog" :main-id="downloadMainId"></download-products>


    <!--场景样例弹窗-->
    <scene-example v-if="sceneExampleDialogShow" :dialogShow="sceneExampleDialogShow" :exampleList="$store.state.sceneExampleList"
                   @closeDialog="sceneExampleDialogShow = false" @addExampleToSceneList="addExampleToSceneList"></scene-example>



<!--    &lt;!&ndash;录屏 跟随鼠标操作提示&ndash;&gt;-->
<!--    <div v-if="globeOperationSceneTip" :style="{'top':globeOperationSceneTipTop,'left':globeOperationSceneTipLeft}"-->
<!--         style="position:absolute;background:rgba(0, 0, 0, 0.2);border:1px solid rgba(255, 255, 255, 0.5);border-radius:2px;padding:7px 10px;">-->
<!--      <p style="line-height:22px;color:#ffffff;">{{globeOperationSceneTipContent}}</p>-->
<!--    </div>-->


    <!--录屏 全屏播放即将开始-->
    <div v-if="fullScreenPlayBeginMantle" style="position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(33,33,33,0.46);z-index:25;">
      <div style="position:relative;top:50%;left:50%;transform:translate(-50%,-50%);text-align:center;font-size:36px;color:#ffffff;">
        <p>全屏跳转即将开始，请打开录屏工具进行录制</p>
        <p style="margin-top:30px;">按ESC键退出全屏模式</p>
        <p style="margin-top:30px;">{{fullScreenPlayBeginMantleSecond}}</p>
      </div>
    </div>


    <!--全屏视频蒙层-->
    <full-screen-video v-if="fullScreenVideoVIf" :dialogShow="fullScreenVideoShow" :dialogOrigin="fullScreenVideoOrigin"
                       :videoSrc="fullScreenVideoSrc" @closeDialog="closeFullScreenVideo"></full-screen-video>


    <!--退出录屏页面 提示弹窗-->
    <quit-scene-page :dialogShow="quitScenePageDialogShow" @quitScenePageOK="quitScenePageOK" @hideQuitScenePageDialog="hideQuitScenePageDialog"></quit-scene-page>




    <!--loading弹窗-->
    <dialog-loading v-if="showLoadingDialog" :dialog-show="showLoadingDialog" :dialogText="loadingDialogText"></dialog-loading>

    <picture-video-previewer ref="previewer" :info-list="!showDelete ? selectItems.geo.properties.imageList:editSelectItems.geo.properties.imageList" :showDelete="showDelete" @removeMedia="removeMedia"></picture-video-previewer>



    <!--新手引导弹窗-->
    <first-guide-dialog :dialogShow="firstGuideDialogShow" @playFirstGuideVideo="playFirstGuideVideo" @hideFirstGuideDialog="firstGuideDialogShow=false"></first-guide-dialog>



    <!--切换录制点时有未保存的编辑内容-->
    <v-dialog v-model="chooseNextSceneItem_notSaveDialogShow" persistent max-width="540">
      <v-card>
        <v-card-title class="tipsDialog-title">
          温馨提示
          <v-spacer></v-spacer>
          <p @click="chooseNextSceneItem_notSaveDialogShow = false" class="tipsDialog-close iconfontFamily">&#xe60d;</p>
        </v-card-title>
        <v-card-text style="padding:80px 80px 44px 90px">
          <div style="display:flex;align-items:center">
            <p class="tipsDialog-mainArea-icon iconfontFamily">&#xe627;</p>
            <p class="tipsDialog-mainArea-text">当前编辑内容未点击完成进行保存<br/>切换录制点会丢失未保存信息<br/>确定切换？</p>
          </div>
          <div class="tipsDialog-mainArea-btnLine">
            <v-btn @click="chooseNextSceneItem_notSaveDialogShow = false" width="100" height="35" color="#F5F5F5">取消</v-btn>
            <v-btn @click="viewEditNotSaveDialogOK" width="100" height="35" dark color="#1E3A8A" style="margin-left:50px;">确定</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--添加样例数据有未保存的编辑内容-->
    <v-dialog v-model="chooseExampleItem_notSaveDialogShow" persistent max-width="540">
      <v-card>
        <v-card-title class="tipsDialog-title">
          温馨提示
          <v-spacer></v-spacer>
          <p @click="chooseExampleItem_notSaveDialogShow = false" class="tipsDialog-close iconfontFamily">&#xe60d;</p>
        </v-card-title>
        <v-card-text style="padding:80px 80px 44px 90px">
          <div style="display:flex;align-items:center">
            <p class="tipsDialog-mainArea-icon iconfontFamily">&#xe627;</p>
            <p class="tipsDialog-mainArea-text">添加样例数据会退出录制点添加<br/>确定添加？</p>
          </div>
          <div class="tipsDialog-mainArea-btnLine">
            <v-btn @click="chooseExampleItem_notSaveDialogShow = false" width="100" height="35" color="#F5F5F5">取消</v-btn>
            <v-btn @click="chooseExampleItemNotSaveDialogOK" width="100" height="35" dark color="#1E3A8A" style="margin-left:50px;">确定</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>




    <!--录制+素材--------------------------------------------------------------------------------->
    <!--引导蒙层 仅地图区域亮起-->
    <div v-if="sceneGuideMantle_mapAvailable" style="position:fixed;top:0;left:0;right:0;width:100%;height:50px;background:rgba(0,0,0,0.5);z-index:10;"></div>
    <div v-if="sceneGuideMantle_mapAvailable" style="position:fixed;top:50px;bottom:0;left:0;width:450px;height:100%;background:rgba(0,0,0,0.5);z-index:10;"></div>

    <!--引导蒙层 仅视野点完成按钮可用-->
    <div v-if="sceneGuideMantle_viewFinishBtnAvailable" :style="{'clip-path':sceneGuideMantle_viewFinishBtnAvailable_clipPathStyle}"
         style="position:fixed;top:0;bottom:0;left:0;right:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:10;">
    </div>
    <div v-if="sceneGuideMantle_arrowShow"
         :style="{'top':sceneGuideMantle_arrowPositionTop,'left':sceneGuideMantle_arrowPositionLeft}"
         style="position:fixed;width:60px;height:60px;z-index:12;">
      <img src="../../assets/globe/scene/viewPoint/mantleArrow1.png" style="width:100%;height:100%;">
    </div>

    <!--添加素材弹窗-->
    <add-scene-material v-if="addSceneMaterialShow" :dialogShow="addSceneMaterialShow" @closeDialog="addSceneMaterialShow = false"
                        @addMaterialOK="addMaterialOK"></add-scene-material>

    <!--导入数据弹窗-->
    <import-annex-data v-if="importAnnexDataDialogShow" :dialogShow="importAnnexDataDialogShow" :isView="isViewAnnexData"
                       @closeDialog="importAnnexDataDialogShow = false" @setLoading="showLoadingDialog = true" @closeLoading="showLoadingDialog = false" @createLayerOk="createLayerOk"></import-annex-data>


   <!--录制 3d模型-->
   <object3d v-if="sceneRoute3DModelShow" :map="map" :tb="tb" :currentPosition="sceneRoute3DModelCurrentPosition" :objectConfig="{
     origin: [0, 0, 0],
     originShifting: [0, 0, 0],
     type: 'mtl',
     model: '3D迈凯伦调整3',
     rotation: { x: 90, y: 0, z: 0 },
     scale: 1,
     startRotation: { x: 0, y: 0, z: 0 }}" />




  </div>


</template>


<script>
import mapboxgl from 'mapbox-gl'
import * as turf from '@turf/turf'
import {Threebox} from "threebox-plugin";

import MainLike from '@/views/globe/main/MainLike';
import MainDownload from '@/views/globe/main/MainDownload';
import MainImageLib from "@/views/globe/main/MainImageLib";
import MainGlobeOperation from "@/views/globe/main/MainGlobeOperation";
import MainGlobeScene from "@/views/globe/main/MainGlobeScene";
import MainGlobeSceneDefault from "@/views/globe/main/MainGlobeSceneDefault";
import MainMyFolder from "@/views/globe/main/MainMyFolder";
import MainAI from "@/views/globe/main/MainAI";
import MainFolderAITrip from "@/views/globe/main/MainFolderAITrip";

import FolderMarkerEntry from "@/views/globe/globe_marker/FolderMarkerEntry";
import ImageMarkerEntry from "@/views/globe/globe_marker/ImageMarkerEntry";
import SceneViewMarkerEntry from "@/views/globe/globe_marker/SceneViewMarkerEntry";
import SceneViewMarkerEntrySelecting from "@/views/globe/globe_marker/SceneViewMarkerEntry_selecting";
import SceneMaterialPointEntry from "@/views/globe/globe_marker/SceneMaterialPointEntry";

import positionIcon from "@/assets/mapbox/icon.png";
import DownloadProducts from "@/components/download_products/DownloadProducts";

import getCurrentCityName from "@/plugins/baiduMapApi";

import MixinMarker from "@/mixin/main_globe_operation_mixin/GlobeMarker";
import MixinScene from "@/mixin/main_globe_operation_mixin/GlobeScene";
import MixinMyFolder from "@/mixin/main_globe_operation_mixin/GlobeMyFolder";

import SceneExample from "@/views/globe/dialog/SceneExample";
import InputNumber from "@/components/input_number/InputNumber";
import ColorPicker from "@/components/globe_marker/ColorPicker"
import SizePicker from "@/components/globe_marker/SizePicker"
import IconPicker from "@/components/globe_marker/IconPicker";
import NameEditor from "@/components/globe_marker/NameEditor";
import LocationEditor from "@/components/globe_marker/LocationEditor";
import LngLatInfo from "../../components/globe_marker/LngLatInfo";
import UploadPictureAndVideo from "../../components/globe_marker/UploadPictureAndVideo";
import FullScreenVideo from "@/components/full_screen_video/FullScreenVideo";
import QuitScenePage from "@/views/globe/dialog/QuitScenePage";
import FirstGuideDialog from "@/views/globe/dialog/FirstGuideDialog";

import DialogLoading from '/src/components/loading/DialogLoading'
import PictureVideoPreviewer from '@/components/picture_video_previewer/PictureVideoPreviewer'
import MarkerNameEntry from "@/views/globe/globe_marker/MarkerNameEntry"
import SymbolColorPicker from "@/components/globe_marker/SymbolColorPicker"

import AddSceneMaterial from "@/views/globe/dialog/AddSceneMaterial";
import SceneMaterialImageEntryAdding from "@/views/globe/globe_marker/SceneMaterialImageEntry_adding";
import SceneMaterialImageEntry from "@/views/globe/globe_marker/SceneMaterialImageEntry";
import ImportAnnexData from '@/views/globe/dialog/ImportAnnexData'
import Curve3d from "../../components/line_3d/Curve3d";
import DataGrid from "../../components/data_grid/DataGrid";
import HeatMap from "../../components/globe_marker/LayerFolder/HeatMap";
import Curve2d from "../../components/globe_marker/LayerFolder/Curve2d";
import HistogramMap from "../../components/globe_marker/LayerFolder/HistogramMap";
import {nextTick} from "vue";
import {setWindowTb} from "../../utils/tbUtils";

import Object3d from "../../components/object_3d/Object3d";

// import MixinMarkerTest from "@/mixin/main_globe_operation_mixin/GlobeMarkerForTest";
import zoom0Tile from '@/assets/zoom0Tile.png';
import SatelliteLayer from "@/components/globe_marker/satellite_layer/SatelliteLayer.vue";
import DrawCanvas from "@/views/globe/draw_canvas/DrawCanvas.vue";

export default {
  name: "Globe",
  mixins: [MixinMarker,MixinScene,MixinMyFolder,FirstGuideDialog],
  components:{
    DrawCanvas,
    SatelliteLayer,
    MainFolderAITrip,
    MainAI,
    SceneMaterialImageEntryAdding,
    SceneMaterialPointEntry,
    FirstGuideDialog,
    QuitScenePage,
    FullScreenVideo,
    InputNumber,
    SceneExample,
    MainGlobeOperation,
    MainImageLib,
    MainLike,
    MainDownload,
    MainGlobeScene,
    MainGlobeSceneDefault,
    MainMyFolder,
    FolderMarkerEntry,
    ImageMarkerEntry,
    DownloadProducts,
    ColorPicker,
    SizePicker,
    IconPicker,NameEditor,LocationEditor,
    LngLatInfo,UploadPictureAndVideo,
    DialogLoading,
    PictureVideoPreviewer,
    MarkerNameEntry,
    SymbolColorPicker,
    SceneViewMarkerEntry,
    SceneViewMarkerEntrySelecting,
    AddSceneMaterial,
    SceneMaterialImageEntry,
    ImportAnnexData,
    Curve3d,
    DataGrid,
    HeatMap,
    Curve2d,
    HistogramMap,
    Object3d
  },
  data(){
    return{
      //主要区域
      mainArea:"globeOperation",   //上方类型
      // mainArea:"myFolderAITrip",   //上方类型
      nextMainArea:"",   //切换时弹出保存提示弹窗，记录要进入的侧边栏
      mainAreaBottomType:"globeOperation",   //下方类型
      // mainAreaBottomType:"folder",   //下方类型

      globeFullScreen:false,

      mapboxInit:false,
      // smallGlobeMapInit:false,
      sceneFullMapboxInit:false,

      //地图
      map:"",
      tb:"",
      initCenter:[90.94487491007658, 39.86471240059555],
      initZoom:3,
      //当前图层名
      currLayerName:"",
      currLayerNumber:"",
      //地图信息
      mapInfoLng:"",
      mapInfoLat:"",
      mapInfoCameraElevation:"",
      //0级瓦片展示延时
      zoom0LayerTemp:"",
      //全屏地球，用于录制截屏
      sceneFullMap:"",

      //地球效果设置
      globeSetShow:false,
      globeSet_star:"",
      globeSet_fog:"",
      globeSet_dem:"",
      globeSet_demNum:"",
      globeSet_centerBorder:"",



      //百度定位api
      baiduApiMap:"",

      // //右下角小地球
      // smallGlobeMap:"",

      //当前操作的地图名称
      operationMapName:"",
      //公用地球视角信息
      mapCameraInfo:{
        center:"",
        zoom:"",
        pitch:"",
        bearing:""
      },

      globeLayerListRoadShow:true,   //路网

      //地图上蒙层
      transparentMantle:false,


      //地图上图标
      folderMarkerShow:false,   //影像集
      folderMarkerSize:150,
      folderMarkerList:[],

      imageMarkerShow:false,   //事件
      imageMarkerList:[],


      //地图上影像集预览
      // imagePreviewShow:this.$store.state.imagePreviewShow,
      preview_imageId:"",
      preview_title:"",
      preview_type:"",
      preview_introduce:"",
      preview_contentNum:"",
      preview_price:"",
      preview_likeStatus:"",
      preview_buyStatus:"",
      preview_globeOldStatus:{},


      //影像集停用弹窗显隐
      folderStopDialogShow:false,
      stopFolderId:"",
      stopFolderBuyStatus:0,
      folderNotBuyToastShow:false,


      //下载影像集
      downloadMainId:"",


      //全屏视频蒙层
      fullScreenVideoShow:false,
      fullScreenVideoVIf:false,  //弹窗的v-if，使每次进入重新加载播放（不和model使用同一元素是为了隐藏动画完成）
      fullScreenVideoSrc:"",
      fullScreenVideoFrom:"",
      fullScreenVideoOrigin:"center",


      //全屏loading
      showLoadingDialog:false,
      loadingDialogText:"加载中……",


      //新手引导弹窗
      firstGuideDialogShow:false,



      editFileIconShow: false,
      editCurrFileInfo: '',
    }

  },
  computed:{
    //计算指南针旋转角度
    getCompassRotate(){
      if(this.map === ""){
        return 0
      }
      else{
        let rotate=0;
        if(this.mapCameraInfo.bearing >= 0 && this.mapCameraInfo.bearing <=180){
          rotate= this.mapCameraInfo.bearing
        }
        else if(this.mapCameraInfo.bearing < 0){
          rotate= 360 + this.mapCameraInfo.bearing
        }
        else if(this.mapCameraInfo.bearing > 180){
          rotate= this.mapCameraInfo.bearing - 360
        }
        return rotate
      }

    },

    //监听store中的数据
    store_globeQuitShowDialog(){
      return this.$store.state.globeQuitShowDialog;
    },

    //监听store中的数据
    store_imagePreviewShow(){
      return this.$store.state.imagePreviewShow;
    },

    // 从可视化图层里筛选curve-3d data-grid heat-map curve2d histogram-map
    store_curve3dList() {
      return this.$store.state.showVizLayerList.filter(item => item.style === 'curve3d')
    },
    store_dataGridList() {
      return this.$store.state.showVizLayerList.filter(item => item.style === 'square')
    },
    store_heatMapList() {
      return this.$store.state.showVizLayerList.filter(item => item.style === 'heatMap')
    },
    store_2DlineList() {
      return this.$store.state.showVizLayerList.filter(item => item.style === '2Dline')
    },
    store_histogramList() {
      return this.$store.state.showVizLayerList.filter(item => item.style === 'histogram')
    },
    store_satelliteLayerList() {
      return this.$store.state.showSatelliteLayerList
    },
    store_currLayerGeo() {
      return this.$store.state.currLayerGeo
    },

  },
  watch:{
    // //大小地图联动
    // mapCameraInfo(){
    //   if(this.operationMapName === "map"){
    //     this.smallGlobeMap.jumpTo({center:this.mapCameraInfo.center, bearing:this.mapCameraInfo.bearing,})
    //     this.operationMapName = "";
    //   }
    //   else if(this.operationMapName === "smallGlobeMap"){
    //     this.map.jumpTo({center:this.mapCameraInfo.center, bearing:this.mapCameraInfo.bearing, pitch:this.mapCameraInfo.pitch})
    //     this.operationMapName = "";
    //   }
    // },
    store_currLayerGeo() {
      if (this.store_currLayerGeo === '') {
        return
      }
      const bbox = turf.bbox(this.store_currLayerGeo)
      this.map.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]],{
        linear: false,
        animate: true,
        padding: {top: 120, bottom:130, left: 190, right: 500},
      })
    },

    //路网图层显隐
    globeLayerListRoadShow(){
      if(this.globeLayerListRoadShow){
        this.map.setLayoutProperty('roadInfo','visibility','visible')
        this.sceneFullMap.setLayoutProperty('roadInfo','visibility','visible')
        // this.map.addLayer({
        //   id: 'roadInfo',
        //   type: 'raster',
        //   source: 'roadInfo'
        // });
        //埋点
        this.$utils.eventTracking("工作台_地球工具_路网")
      }
      else{
        this.map.setLayoutProperty('roadInfo','visibility','none')
        this.sceneFullMap.setLayoutProperty('roadInfo','visibility','none')
        // this.map.removeLayer('roadInfo')
      }
    },


    //地球设置保存
    globeSet_star(){
      if(this.globeSet_star){
        this.map.setFog({
          "horizon-blend": this.globeSet_fog ? 0.1 : 0,
          "space-color": 'rgba(0, 0, 0, 1)',
          "star-intensity": 0.15
        });
        this.sceneFullMap.setFog({
          "horizon-blend": this.globeSet_fog ? 0.1 : 0,
          "space-color": 'rgba(0, 0, 0, 1)',
          "star-intensity": 0.15
        });
      }
      else{
        this.map.setFog({
          "horizon-blend": this.globeSet_fog ? 0.1 : 0,
          "space-color": 'rgba(0, 0, 0, 1)',
          "star-intensity": 0
        });
        this.sceneFullMap.setFog({
          "horizon-blend": this.globeSet_fog ? 0.1 : 0,
          "space-color": 'rgba(0, 0, 0, 1)',
          "star-intensity": 0
        });
      }
      this.globeSetSave()
    },
    globeSet_fog(){
      if(this.globeSet_fog){
        this.map.setFog({
          "horizon-blend": 0.1,
          "space-color": 'rgba(0, 0, 0, 1)',
          "star-intensity": this.globeSet_star ? 0.15 : 0
        });
        this.sceneFullMap.setFog({
          "horizon-blend": 0.1,
          "space-color": 'rgba(0, 0, 0, 1)',
          "star-intensity": this.globeSet_star ? 0.15 : 0
        });
      }
      else{
        this.map.setFog({
          "horizon-blend": 0,
          "space-color": 'rgba(0, 0, 0, 1)',
          "star-intensity": this.globeSet_star ? 0.15 : 0
        });
        this.sceneFullMap.setFog({
          "horizon-blend": 0,
          "space-color": 'rgba(0, 0, 0, 1)',
          "star-intensity": this.globeSet_star ? 0.15 : 0
        });
      }
      this.globeSetSave()
    },
    globeSet_dem(){
      if(this.globeSet_dem){

        let temp1 = setInterval(()=>{
          if(this.mapboxInit){
            clearInterval(temp1);
            this.map.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': this.globeSet_demNum });
          }
        },100)

        let temp = setInterval(()=>{
          if(this.sceneFullMapboxInit){
            clearInterval(temp);
            this.sceneFullMap.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': this.globeSet_demNum });
          }
        },100)
      }
      else{
        let temp1 = setInterval(()=>{
          if(this.mapboxInit){
            clearInterval(temp1);
            this.map.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': 0 });
          }
        },100)

        let temp = setInterval(()=>{
          if(this.sceneFullMapboxInit){
            clearInterval(temp);
            this.sceneFullMap.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': 0 });
          }
        },100)
      }

      this.globeSetSave()
    },
    globeSet_demNum(){
      if(this.globeSet_dem){
        let temp1 = setInterval(()=>{
          if(this.mapboxInit){
            clearInterval(temp1);
            this.map.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': this.globeSet_demNum });
          }
        },100)

        let temp = setInterval(()=>{
          if(this.sceneFullMapboxInit){
            clearInterval(temp);
            this.sceneFullMap.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': this.globeSet_demNum });
          }
        },100)

        this.globeSetSave()

        //埋点
        this.$utils.eventTracking("工作台_地球工具_夸张系数")
      }

    },

    globeSet_centerBorder(){
      this.globeSetSave()
    },


    //页面退出是否显示弹窗
    store_globeQuitShowDialog(){
      if(this.$store.state.globeQuitShowDialog){
        //监听页面关闭
        window.onbeforeunload = function (e) {
          var message = '您是否确认离开此页面-您输入的数据可能不会被保存';
          e = e || window.event;
          if (e) {
            e.returnValue = message;
          }
          return "您是否确认离开此页面-您输入的数据可能不会被保存";
        }
      }
      else{
        window.onbeforeunload = null
      }
    },


    //切换全屏地球
    globeFullScreen(){
      setTimeout(()=>{
        this.map.resize()
      },0)
    },


    //影像集退出预览状态
    store_imagePreviewShow(){
      if(!this.$store.state.imagePreviewShow){
        //隐藏预览区域，清除图层，清除最大视野范围
        if(this.map.getLayer("imagePreviewLayer") !== undefined){
          this.map.removeLayer("imagePreviewLayer");
          this.map.removeSource("imagePreviewLayer");
        }
        this.map.setMaxBounds(null);

        this.preview_imageId = "";

        this.preview_globeOldStatus = {}

      }
    },

    //当前选中的侧边栏值，传给store，在topbar中使用
    mainArea(){
      this.$store.state.currGlobeMainArea = this.mainArea;
    }


  },
  methods:{
    changeFullScreenStatus() {
      if (this.$store.state.isDrawingCanvas) {
        this.$store.state.snackbarShow = true
        this.$store.state.snackbarText = "请先退出画笔绘制"
        this.$store.state.snackbarType = 'error'
        return
      }
      this.globeFullScreen = !this.globeFullScreen
      if(this.globeFullScreen){
        //埋点
        this.$utils.eventTracking("工作台_标记_全屏")
      }
    },
    beginDrawCanvas() {
      if (this.$store.state.isDrawingCanvas) {
        this.$store.state.isDrawingCanvas = false
        this.drawToolsChoose = ''
      } else {
        // 停止其他绘制动作
        // 清除测量的数据
        this.clearAllMeasure()
        this.closeEditCard()
        this.cleanMapOnEvent()
        this.drawToolsChoose = 'drawPen'
        this.$store.state.isDrawingCanvas = true

        //埋点
        this.$utils.eventTracking("工作台_标记_画笔")
      }
    },
    clickLeftBar(val){
      if (this.$store.state.isDrawingCanvas) {
        this.$store.state.snackbarShow = true
        this.$store.state.snackbarText = "请先退出画笔绘制"
        this.$store.state.snackbarType = 'error'
        return
      }
      switch(this.mainArea){
        case "globeScene":{
          //录制
          if(this.$store.state.globeQuitShowDialog){
            this.nextMainArea = val;
            this.quitScenePageDialogShow = true;
          }
          else{
            this.mainArea = val
            setTimeout(()=>{
              this.map.getCanvas().style.cursor = 'grab'
              document.getElementById("labelCanvas").style.cursor = 'grab';
            },100)
          }

          break;
        }
        case "globeOperation":{
          //标记

          this.mainArea = val
          this.map.getCanvas().style.cursor='default'
          document.getElementById("labelCanvas").style.cursor = 'default';

          break;
        }
        case "myFolder": {
          this.mainArea = val
          this.map.getCanvas().style.cursor = 'grab'
          this.editFileIconShow = false
          break
        }
        case "myFolderAITrip": {
          this.mainArea = val
          this.map.getCanvas().style.cursor = 'grab'
          this.editFileIconShow = false
          break
        }
        case "myFolderLike": {
          this.mainArea = val
          this.map.getCanvas().style.cursor = 'grab'
          this.editFileIconShow = false
          break
        }
        default:{
          this.mainArea = val
        }


      }







      // this.mainArea = val
      // if(val ==='globeOperation'){
      //   this.map.getCanvas().style.cursor='default'
      // }else{
      //   setTimeout(()=>{
      //     this.map.getCanvas().style.cursor = 'grab'
      //   },100)
      // }
    },

    clickLeftBarBottomType(val){
      if (this.$store.state.isDrawingCanvas) {
        this.$store.state.snackbarShow = true
        this.$store.state.snackbarText = "请先退出画笔绘制"
        this.$store.state.snackbarType = 'error'
        return
      }
      this.mainAreaBottomType = val
      switch(val){
        case 'globeOperation':{
          this.mainArea = 'globeOperation';
          break;
        }
        case 'folder':{
          this.mainArea = 'myFolder';
          this.editFileIconShow = false;

          //埋点
          this.$utils.eventTracking("工作台_我的文件")

          break;
        }
      }
    },


    //初始化mapbox
    initMapbox() {
      mapboxgl.accessToken = this.$utils.mapboxToken;
      this.map = new mapboxgl.Map({
        container: 'globeMap',
        zoom: this.initZoom,
        center:this.initCenter,
        style: this.$utils.mapboxStyle,
        // //临时njh 使用没有water的样式 配合本地缓存瓦片exe
        // style:{
        //   "version": 8,
        //   "name": "blank",
        //   "metadata": {"maputnik:renderer": "mbgljs"},
        //   "center": [120.679882, 24.143171],
        //   "zoom": 4,
        //   "sources":{},
        //   "glyphs": "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
        //   "layers": [
        //     {
        //       "id": "background",
        //       "type": "background",
        //       "layout": {"visibility": "visible"},
        //       "paint": {"background-color": "#000000"}
        //     }
        //   ],
        //   "id": "blank_style"
        // },
        maxZoom: 17,
        minZoom: 1,
        preserveDrawingBuffer:true,
        localIdeographFontFamily: '',
        projection: {name:'globe'},
        transformRequest: (url) => {
          if (url.indexOf('https://api.mapbox.com') > -1) { //resourceType != 'Tile' &&
            return {
              url: url.replace('https://api.mapbox.com','https://earth.jl1.cn/mapbox'),
            };
          }
        },
      });
      this.map.on('load', ()=>{
        // this.map.setFog({
        //   "horizon-blend": 0.1,
        //   "space-color": 'rgba(0, 0, 0, 1)',
        //   "star-intensity": 0.15
        // })
        this.map.addSource('mapbox-dem', {
          type: 'raster-dem',
          url: 'mapbox://mapbox.mapbox-terrain-dem-v1',
          tileSize: 512,
          maxZoom: 14,
        });
        // this.map.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': 1 });

        //获取用户的地球设置，改变设置值后自动加载效果
        this.getGlobeSet();

        //图层列表
        for(let i=0;i<this.$utils.layerList.length;i++){
          this.map.addSource(this.$utils.layerList[i].layer, {
            type: 'raster',
            tiles: [
              this.$utils.layerList[i].tileUrl
            ],
            tileSize: 256,
            scheme: this.$utils.layerList[i].isTms ? 'tms' : 'xyz'
          });
        }
        this.map.addLayer({
          id: 'layer',
          type: 'raster',
          source: this.$utils.layerList[0].layer
        });
        this.currLayerName = this.$utils.layerList[0].layer
        this.currLayerNumber = this.$utils.layerList[0].code


        //0级瓦片 在地图最底层
        this.map.addSource('zoom0Layer', {
          type: 'image',
          url: zoom0Tile,
          coordinates: [
            // 图片覆盖地图的四至点
            [-180, 85], // 右上
            [180, 85], // 左上
            [180, -85], // 左下
            [-180, -85], // 右下
          ]
        })
        clearTimeout(this.zoom0LayerTemp)
        this.zoom0LayerTemp = setTimeout(()=>{
          this.map.addLayer( {
            id: 'zoom0Layer',
            type: "raster",
            source: 'zoom0Layer',
            // maxzoom:18,
          },'layer')
        },5000)




        this.map.addSource('roadInfo', {
          type: 'raster',
          tiles: [
            'https://t0.tianditu.gov.cn/DataServer?T=cva_w&X={x}&Y={y}&L={z}&tk=f5e247a85a4e7b9a605370d0f769d080'
          ],
          tileSize: 256,
        });
        this.map.addLayer({
          id: 'roadInfo',
          type: 'raster',
          source: 'roadInfo'
        });


        //初始经纬度信息
        let gcj02LngLat = this.$utils.wgs84toGcj02(this.map.getCenter().lng,this.map.getCenter().lat)
        this.mapInfoLng = Math.abs(gcj02LngLat.lng).toFixed(3) + 'º' + ((gcj02LngLat.lng < 0) ?  'W' : 'E');
        this.mapInfoLat = Math.abs(gcj02LngLat.lat).toFixed(3) + 'º' + ((gcj02LngLat.lat < 0) ?  'S' : 'N');
        //监听鼠标移动，获取经纬度等信息
        this.map.on('mousemove', (e)=>{
          let gcj02LngLat = this.$utils.wgs84toGcj02(e.lngLat.lng,e.lngLat.lat)
          this.mapInfoLng = Math.abs(gcj02LngLat.lng).toFixed(3) + 'º' + ((gcj02LngLat.lng < 0) ?  'W' : 'E');
          this.mapInfoLat = Math.abs(gcj02LngLat.lat).toFixed(3) + 'º' + ((gcj02LngLat.lat < 0) ?  'S' : 'N');
        })
        this.map.on('mouseout', ()=>{
          let gcj02LngLat = this.$utils.wgs84toGcj02(this.map.getCenter().lng,this.map.getCenter().lat)
          this.mapInfoLng = Math.abs(gcj02LngLat.lng).toFixed(3) + 'º' + ((gcj02LngLat.lng < 0) ?  'W' : 'E');
          this.mapInfoLat = Math.abs(gcj02LngLat.lat).toFixed(3) + 'º' + ((gcj02LngLat.lat < 0) ?  'S' : 'N');
        })

        //初始视角高度
        this.mapInfoCameraElevation = ((2 * Math.PI * 6378137.0) / Math.pow(2, this.map.getZoom()) / 2 / Math.tan(this.map.transform._fov / 2)/1000).toFixed(2)

        //比例尺
        const scale = new mapboxgl.ScaleControl({
          maxWidth: 100,
          unit: 'metric',
        });
        this.map.addControl(scale, 'bottom-right');
        document.querySelector('.mapboxgl-ctrl-scale').style.marginRight = '280px'
        document.querySelector('.mapboxgl-ctrl-scale').style.marginBottom = '5px'
        document.querySelector('.mapboxgl-ctrl-scale').style.backgroundColor = 'transparent'
        document.querySelector('.mapboxgl-ctrl-scale').style.color = 'white'
        document.querySelector('.mapboxgl-ctrl-scale').style.borderColor = 'white'
        document.querySelector('.mapboxgl-ctrl-scale').style.zIndex = '1'
        document.querySelector('.mapboxgl-ctrl-scale').style.height = '6px'
        document.querySelector('.mapboxgl-ctrl-scale').style.lineHeight = '0px'
        document.querySelector('.mapboxgl-ctrl-scale').style.paddingBottom = '6px'
        document.querySelector('.mapboxgl-ctrl-scale').style.pointerEvents = 'none'

        this.map.on('move',()=>{

          this.mapInfoCameraElevation = ((2 * Math.PI * 6378137.0) / Math.pow(2, this.map.getZoom()) / 2 / Math.tan(this.map.transform._fov / 2)/1000).toFixed(2)

          // if(this.operationMapName !== "smallGlobeMap")(
          //     //不是因为小地球操作导致的变化
          //     this.mapCameraInfo = {
          //       center: this.map.getCenter(),
          //       zoom: this.map.getZoom(),
          //       pitch: this.map.getPitch(),
          //       bearing: this.map.getBearing(),
          //     },
          //     this.operationMapName = "map"
          // )

        })


        //地图上定位图标
        let _this = this;
        this.map.loadImage(
            positionIcon,
            function(error,image){
              if(error) throw error;
              _this.map.addImage("positionIcon",image);
            }
        )


        //地图初始化完成
        this.mapboxInit = true;

        //用户初始进入项目，引导弹窗
        this.firstGuideDialog();

        //初始化
        this.globeMarkerFun()
        this.globeMarkerFun_xzt()

       // this.globeMarkerFun1()

        //threebox初始化
        const tb = this.tb = new Threebox(
          this.map,
          this.map.getCanvas().getContext('webgl'),
          {
            defaultLights: true
          }
        );
        setWindowTb(tb);

      });


    },


    //初始化右下角小地球
    //最初初始化和浏览器缩放初始化的中心点不同，其他一致
    // initSmallGlobeMap(mapCenter){
    //   mapboxgl.accessToken = this.$utils.mapboxToken;
    //
    //   this.smallGlobeMap = new mapboxgl.Map({
    //     container: 'smallGlobeMap',
    //     zoom: 0,
    //     center:mapCenter,
    //     style: "https://earth.jl1.cn/symbolresource/cgwxOceanLand.json",
    //     maxZoom: 0,
    //     minZoom: 0,
    //     doubleClickZoom:false,
    //     scrollZoom:false,
    //     pitchWithRotate:false,
    //     projection: {name:'globe'},
    //     transformRequest: (url) => {
    //       if (url.indexOf('https://api.mapbox.com') > -1) { //resourceType != 'Tile' &&
    //         return {
    //           url: url.replace('https://api.mapbox.com','https://earth.jl1.cn/mapbox'),
    //         };
    //       }
    //     },
    //   });
    //
    //   document.getElementById("smallGlobeMap").querySelector(".mapboxgl-canvas").setAttribute("style","width:80px;height:80px;");
    //
    //   this.smallGlobeMap.on('load', ()=>{
    //
    //     console.log("小球加载完成")
    //
    //     this.smallGlobeMap.on('move',()=>{
    //       if(this.operationMapName !== "map"){
    //         //不是因为操作地图导致的变化
    //         this.mapCameraInfo = {
    //           center: this.smallGlobeMap.getCenter(),
    //           zoom: this.smallGlobeMap.getZoom(),
    //           pitch: this.smallGlobeMap.getPitch(),
    //           bearing: this.smallGlobeMap.getBearing(),
    //         },
    //         this.operationMapName = "smallGlobeMap"
    //       }
    //
    //     })
    //
    //     //地图初始化完成
    //     this.smallGlobeMapInit = true;
    //
    //   });
    //
    // },



    initSceneFullMap(){

      mapboxgl.accessToken = this.$utils.mapboxToken;
      this.sceneFullMap = new mapboxgl.Map({
        container: 'sceneFullMap',
        zoom: this.initZoom,
        center:this.initCenter,
        style: this.$utils.mapboxStyle,
        // //临时njh 使用没有water的样式 配合本地缓存瓦片exe
        // style:{
        //   "version": 8,
        //   "name": "blank",
        //   "metadata": {"maputnik:renderer": "mbgljs"},
        //   "center": [120.679882, 24.143171],
        //   "zoom": 4,
        //   "sources":{},
        //   "glyphs": "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
        //   "layers": [
        //     {
        //       "id": "background",
        //       "type": "background",
        //       "layout": {"visibility": "visible"},
        //       "paint": {"background-color": "#000000"}
        //     }
        //   ],
        //   "id": "blank_style"
        // },
        maxZoom: 17,
        minZoom: 1,
        preserveDrawingBuffer:true,
        localIdeographFontFamily: '',
        projection: {name:'globe'},
        transformRequest: (url) => {
          if (url.indexOf('https://api.mapbox.com') > -1) { //resourceType != 'Tile' &&
            return {
              url: url.replace('https://api.mapbox.com','https://earth.jl1.cn/mapbox'),
            };
          }
        },
      });
      this.sceneFullMap.on('load', ()=>{
        console.log("全屏地图加载完成")
        // this.map.setFog({
        //   "horizon-blend": 0.1,
        //   "space-color": 'rgba(0, 0, 0, 1)',
        //   "star-intensity": 0.15
        // })
        this.sceneFullMap.addSource('mapbox-dem', {
          type: 'raster-dem',
          url: 'mapbox://mapbox.mapbox-terrain-dem-v1',
          tileSize: 512,
          maxZoom: 14,
        });
        // this.map.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': 1 });

        //获取用户的地球设置，改变设置值后自动加载效果
        this.getGlobeSet();


        //图层列表
        for(let i=0;i<this.$utils.layerList.length;i++){
          this.sceneFullMap.addSource(this.$utils.layerList[i].layer, {
            type: 'raster',
            tiles: [
              this.$utils.layerList[i].tileUrl
            ],
            tileSize: 256,
            scheme: this.$utils.layerList[i].isTms ? 'tms' : 'xyz'
          });
        }
        this.sceneFullMap.addLayer({
          id: 'layer',
          type: 'raster',
          source: this.$utils.layerList[0].layer
        });


        this.sceneFullMap.addSource('roadInfo', {
          type: 'raster',
          tiles: [
            'https://t0.tianditu.gov.cn/DataServer?T=cva_w&X={x}&Y={y}&L={z}&tk=f5e247a85a4e7b9a605370d0f769d080'
          ],
          tileSize: 256,
        });
        this.sceneFullMap.addLayer({
          id: 'roadInfo',
          type: 'raster',
          source: 'roadInfo'
        });

        this.sceneFullMapboxInit = true;
      });


    },







    //打开地球设置
    openGlobeSet(){
      this.globeSetShow = true;
    },

    //保存地球设置
    globeSetSave(){
      this.$axios({
        method:"post",
        url:"/authorApi/z-geo-default-earth/updateEarthSet",
        params:{
          starSky:this.globeSet_star ? 1 : 0,
          air:this.globeSet_fog ? 1 : 0,
          land:this.globeSet_dem ? 1 : 0,
          exaggerateNumber:this.globeSet_demNum,
          centerBorder:this.globeSet_centerBorder ? 1 : 0,
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          console.log("保存成功")
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });

    },

    //获取地球设置
    getGlobeSet(){
      this.$axios({
        method:"post",
        url:"/authorApi/z-geo-default-earth/getById",
      }).then((resultData)=>{
        resultData = resultData.data;
        console.log(resultData.data)
        if(resultData.status === 200){
          this.globeSet_star = resultData.data.starSky === 1;
          this.globeSet_fog = resultData.data.air === 1;
          this.globeSet_demNum = resultData.data.exaggerateNumber;
          this.globeSet_dem = resultData.data.land === 1;
          this.globeSet_centerBorder = resultData.data.centerBorder === 1;
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });

    },




    //切换图层
    changeLayer(layerName){
      if(this.currLayerName !== layerName){

        //埋点
        this.$utils.eventTracking("工作台_地球工具_图层",layerName)

        if(this.map.getLayer('zoom0Layer')!==undefined){
          this.map.removeLayer('zoom0Layer')
        }

        if(this.map.getLayer('layer')!==undefined){
          this.map.removeLayer('layer')
        }

        this.map.addLayer({
          id: 'layer',
          type: 'raster',
          source: layerName
        },"roadInfo")

        this.currLayerName = layerName;

        for(let i=0;i<this.$utils.layerList.length;i++){
          if(this.$utils.layerList[i].layer === layerName){
            this.currLayerNumber = this.$utils.layerList[i].code
            break;
          }
        }

        if(this.sceneFullMap.getLayer('layer')!==undefined){
          this.sceneFullMap.removeLayer('layer')
        }
        this.sceneFullMap.addLayer({
          id: 'layer',
          type: 'raster',
          source: layerName
        },"roadInfo")



        //加载0级图层
        clearTimeout(this.zoom0LayerTemp)
        if(layerName !== 'tianditu'){
          this.zoom0LayerTemp = setTimeout(()=>{
            this.map.addLayer( {
              id: 'zoom0Layer',
              type: "raster",
              source: 'zoom0Layer',
            },'layer')
          },5000)
        }




      }

    },

    //定位
    getLocation(){
      if (this.$store.state.isDrawingCanvas) {
        this.$store.state.snackbarShow = true
        this.$store.state.snackbarText = "请先退出画笔绘制"
        this.$store.state.snackbarType = 'error'
        return
      }
      this.quitPreview();
      // 根据ip进行定位，配置局域网ip的电脑不支持，
      // this.getIP((ip) => {
      //   console.log(ip)
      //   this.$axios({
      //     method:"get",
      //     url:"/baidu/location/ip?ak=gmlAoxxoEHSd2yKyRqZ8GS0wkyL57Yp8&coor=bd09ll&ip="+ip
      //   }).then((resultData)=>{
      //     console.log(resultData)
      //     if(resultData.data.status === 0){
      //       this.map.flyTo({
      //         center:[parseFloat(resultData.data.content.point.x),parseFloat(resultData.data.content.point.y)],
      //         zoom: 10}
      //       )
      //     }
      //     else{
      //       console.log("非ip地址定位")
      //       // this.$axios({
      //       //   method:"get",
      //       //   url:"/baidu/location/ip?ak=gmlAoxxoEHSd2yKyRqZ8GS0wkyL57Yp8&coor=bd09ll"
      //       // }).then((resultData)=>{
      //       //   console.log(resultData)
      //       //   if(resultData.data.status === 0){
      //           this.map.flyTo({
      //             center:[parseFloat(resultData.data.content.point.x),parseFloat(resultData.data.content.point.y)],
      //             zoom: 10}
      //           )
      //       //   }
      //       //   else{
      //       //     alert("定位暂不可用")
      //       //   }
      //       // }).catch((err)=>{
      //       //   console.log(err);
      //       // });
      //
      //
      //     }
      //   }).catch((err)=>{
      //     console.log(err);
      //   });
      // });

      //使用h5自带的定位，只能在https或localhost使用，chrome浏览器不支持，edge可用，其他没实验
      // if("geolocation" in navigator) {
      //   console.log("支持定位")
      //   let _this = this
      //   navigator.geolocation.getCurrentPosition(function(position){
      //     console.log("获取定位成功")
      //     var lat = position.coords.latitude;
      //     var lng = position.coords.longitude;
      //     console.log( "您所在的位置： 经度" + lng + "，纬度" + lat)
      //
      //     _this.map.flyTo({
      //       center:[lng,lat],
      //       zoom: 10}
      //     )
      //   },function(){
      //     console.log("获取定位失败")
      //   },{timeout: 30000, enableHighAccuracy: true, maximumAge: 75000})
      // }
      // else {
      //   alert("无法进行定位，很遗憾您的浏览器不支持Geolocation API功能");
      // }

      //百度api定位
      getCurrentCityName.init().then(BMap=>{
        const geolocation=new BMap.Geolocation();
        var _this =this;
        geolocation.getCurrentPosition(function(position){
          console.log(position)
          _this.map.flyTo({
            center:[parseFloat(position.longitude),parseFloat(position.latitude)],
            zoom: 10}
          )
          //埋点
          _this.$utils.eventTracking("工作台_地球工具_定位")
        },function(){
          console.log("获取百度定位失败")
        })
      })

    },

    // //获取本机ip地址
    // getIP(callback){
    //   var ip_dups = {};
    //   var RTCPeerConnection = window.RTCPeerConnection
    //       || window.mozRTCPeerConnection
    //       || window.webkitRTCPeerConnection;
    //   // var useWebKit = !!window.webkitRTCPeerConnection;
    //   var mediaConstraints = {
    //     optional: [{ RtpDataChannels: true }]
    //   };
    //   // 这里就是需要的ICEServer了
    //   var servers = {
    //     iceServers: [
    //       { urls: "stun:stun.services.mozilla.com" },
    //       { urls: "stun:stun.l.google.com:19302" },
    //     ]
    //   };
    //   var pc = new RTCPeerConnection(servers, mediaConstraints);
    //   function handleCandidate(candidate) {
    //     console.log(candidate)
    //     var ip_regex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/
    //     var hasIp = ip_regex.exec(candidate)
    //     console.log(hasIp)
    //     if (hasIp) {
    //       var ip_addr = ip_regex.exec(candidate)[1];
    //       if (ip_dups[ip_addr] === undefined)
    //         callback(ip_addr);
    //       ip_dups[ip_addr] = true;
    //     }
    //   }
    //   // 网络协商的过程
    //   pc.onicecandidate = function (ice) {
    //
    //     if (ice.candidate) {
    //       console.log(ice.candidate)
    //       handleCandidate(ice.candidate.candidate);
    //     }
    //   };
    //   pc.createDataChannel("");
    //   //创建一个SDP(session description protocol)会话描述协议 是一个纯文本信息 包含了媒体和网络协商的信息
    //   pc.createOffer(function (result) {
    //     pc.setLocalDescription(result, function () { }, function () { });
    //   }, function () { });
    //   setTimeout(function () {
    //     var lines = pc.localDescription.sdp.split('\n');
    //     console.log(lines)
    //     lines.forEach(function (line) {
    //       if (line.indexOf('a=candidate:') === 0)
    //         handleCandidate(line);
    //     });
    //   }, 1000);
    //
    //
    //
    // },

    //回到初始视野
    goHome(){
      if (this.$store.state.isDrawingCanvas) {
        this.$store.state.snackbarShow = true
        this.$store.state.snackbarText = "请先退出画笔绘制"
        this.$store.state.snackbarType = 'error'
        return
      }
      this.quitPreview();
      this.map.flyTo({
        center:this.initCenter,
        zoom:this.initZoom,
        bearing:0,
        pitch:0
      })
      //埋点
      this.$utils.eventTracking("工作台_地球工具_复位")
    },

    //指北
    resetBearing(){
      if (this.$store.state.isDrawingCanvas) {
        this.$store.state.snackbarShow = true
        this.$store.state.snackbarText = "请先退出画笔绘制"
        this.$store.state.snackbarType = 'error'
        return
      }
      this.map.setBearing(0)
      //埋点
      this.$utils.eventTracking("工作台_地球工具_指北")
    },


    /******************************************************************************************************************/
    /*影像集相关*/


    //展示地图上folderMarker
    showFolderMarker(param){
      if(this.imageMarkerShow){
        this.imageMarkerList = [];
        this.imageMarkerShow = false;
      }
      this.folderMarkerList = JSON.parse(param).folderMarkerList;
      this.folderMarkerSize = JSON.parse(param).folderMarkerSize;
      this.folderMarkerShow = true;
    },
    //展示地图上的imageMarker
    showImageMarker(param){
      if(this.folderMarkerShow){
        this.folderMarkerList = [];
        this.folderMarkerShow = false;
      }

      this.imageMarkerShow = false;
      setTimeout(()=>{
        this.imageMarkerList = param;
        this.imageMarkerShow = true;
      },50)

    },
    //向地图上增加新的imageMarker
    addImageMarker(param){
      this.imageMarkerList = this.imageMarkerList.concat(param);
      this.imageMarkerShow = true;
    },

    //点击地图上的folderMarker
    clickFolderMarker(markerInfo){
      //侧边栏有效果，直接调用侧边栏子组件中的方法
      if(markerInfo.labelName === "国内影像" && markerInfo.parentName === "-1"){
        //进入第二层 国内列表
        this.$refs.mainImageLib.intoStep2();
      }
      else{
        //进入第三层事件层 国内的省份  或者 其他国家
        this.$refs.mainImageLib.intoStep3(markerInfo);
      }
    },
    //点击地图上的imageMarker
    clickImageMarker(markerInfo){
      //侧边栏无效果，直接调用父组件方法即可
      if(markerInfo.status === 5){
        //停用
        this.showFolderStopDialog(markerInfo.mainId)
      }
      else{
        //正常
        this.showImagePreview(markerInfo.mainId);
      }
    },

    //展示地图上的影像集预览
    showImagePreview(imageId){
      //当前是预览界面，先取消预览
      // if(this.imagePreviewShow){
      //   this.quitPreview();
      // }

      this.preview_imageId = imageId;

      this.$axios({
        method:"get",
        url:"/authorApi/z-image-collection/getById",
        params:{
          mainId:imageId,
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.preview_title = resultData.data.imageCollection.title;
          //类别序号转对应文字
          this.$utils.imageTypeToString(resultData.data.imageCollection.type,(typeName)=>{
            this.preview_type = typeName;
          })
          this.preview_introduce = resultData.data.imageCollection.context;
          this.preview_contentNum = resultData.data.imageCollection.materialNumber;
          this.preview_price = resultData.data.imageCollection.price;
          this.preview_likeStatus = resultData.data.collectStatus;
          this.preview_buyStatus = resultData.data.buyStatus;

          //当前不是预览界面，记录地球当前状态，隐藏事件集marker
          if(!this.$store.state.imagePreviewShow){
            this.preview_globeOldStatus = {
              center:this.map.getCenter(),
              zoom:this.map.getZoom()
            }
          }

          //隐藏事件集marker
          this.imageMarkerShow = false;
          this.$store.state.imagePreviewShow = true;

          //地球飞到区域，限制最大视野，展示图层
          //左下 左上 右上 右下
          let geo = resultData.data.imageCollection.geo

          //左边界
          var leftLine = turf.lineString([
            JSON.parse(geo).coordinates[0][0],
            JSON.parse(geo).coordinates[0][1]
          ]);
          var leftLineOffset = turf.lineOffset(leftLine, 20, {units: 'miles'});
          //右边界
          var rightLine = turf.lineString([
            JSON.parse(geo).coordinates[0][2],
            JSON.parse(geo).coordinates[0][3]
          ]);
          var rightLineOffset = turf.lineOffset(rightLine, 20, {units: 'miles'});
          //上边界
          var topLine = turf.lineString([
            JSON.parse(geo).coordinates[0][1],
            JSON.parse(geo).coordinates[0][2]
          ]);
          var topLineOffset = turf.lineOffset(topLine, -5, {units: 'miles'});
          //下边界
          var bottomLine = turf.lineString([
            JSON.parse(geo).coordinates[0][3],
            JSON.parse(geo).coordinates[0][0]
          ]);
          var bottomLineOffset = turf.lineOffset(bottomLine, -5, {units: 'miles'});
          //四个边界的包围矩形
          let lineOffsetList = {
            'type': 'FeatureCollection',
            'features': [leftLineOffset,rightLineOffset,topLineOffset,bottomLineOffset]
          };
          var bboxResult = turf.bbox(lineOffsetList);
          var bboxResultPolygon = turf.bboxPolygon(bboxResult);


          // this.map.addSource('bboxResultPolygon', {
          //   type: 'geojson',
          //   data: bboxResultPolygon
          // });
          // this.map.addLayer({
          //   id: 'bboxResultPolygon',
          //   type: 'line',
          //   source: 'bboxResultPolygon',
          //   paint: {
          //     'line-color': '#00ffff',
          //     'line-width': 2,
          //     'line-opacity': 1
          //   }
          // });

          this.map.setMaxBounds([bboxResultPolygon.geometry.coordinates[0][0],bboxResultPolygon.geometry.coordinates[0][2]]);
          this.map.fitBounds([JSON.parse(geo).coordinates[0][0],JSON.parse(geo).coordinates[0][2]], {
            padding: {top: 200, bottom:200}
          });

          //mapbox展示图层（未修改图层前后缀，前端无入口）
          if(this.map.getLayer("imagePreviewLayer") !== undefined){
            this.map.removeLayer("imagePreviewLayer");
            this.map.removeSource("imagePreviewLayer");
          }
          this.map.addSource("imagePreviewLayer", {
            type: "raster",
            tiles: [
              this.$utils.charmingglobeLayerUrl+ resultData.data.imageCollection.cite +'/{z}/{x}/{y}?token=Bearer%20a84a40c81f784490a4c5689187054abf'
            ],
            tileSize: 256,
            scheme: 'tms',
          });
          this.map.addLayer({
            'id': 'imagePreviewLayer',
            'type': 'raster',
            'source': 'imagePreviewLayer'
          });


        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });


    },
    //退出预览 从球上退出预览按钮进行操作
    quitPreview(){
      if(this.$store.state.imagePreviewShow){
        this.$store.state.imagePreviewShow = false;

        // //隐藏预览区域，清除图层，清除最大视野范围
        // if(this.map.getLayer("imagePreviewLayer") !== undefined){
        //   this.map.removeLayer("imagePreviewLayer");
        //   this.map.removeSource("imagePreviewLayer");
        // }
        //
        // this.map.setMaxBounds(null);
        //
        // this.preview_imageId = "";

        //展示事件集marker
        this.imageMarkerShow = true;
        //地球飞到初始区域
        this.map.flyTo({
          center: this.preview_globeOldStatus.center,
          zoom: this.preview_globeOldStatus.zoom,
        })
        // this.preview_globeOldStatus = {}
      }
    },
    //退出预览 从左侧栏进行操作，不包括球上marker的展示和球飞到区域的实现
    quitPreviewLeftBar(){
      if(this.$store.state.imagePreviewShow){
        this.$store.state.imagePreviewShow = false;

        // //隐藏预览区域，清除图层，清除最大视野范围
        // if(this.map.getLayer("imagePreviewLayer") !== undefined){
        //   this.map.removeLayer("imagePreviewLayer");
        //   this.map.removeSource("imagePreviewLayer");
        // }
        //
        // this.map.setMaxBounds(null);
        //
        // this.preview_imageId = "";
        // this.preview_globeOldStatus = {}
      }

    },

    //查看影像集详情页
    intoImageDetailPage(){
      let routeData = this.$router.resolve({
        path: '/productDetails', query: { mainId: this.preview_imageId }
      });
      window.open(routeData.href, '_blank');
    },
    //下载影像集
    downloadImage(){
      this.downloadMainId = this.preview_imageId
      this.$store.state.showDownloadProductsDialog = true;
    },
    //收藏影像集
    likeImage(){
      let type;
      if(this.preview_likeStatus === 1){
        type = 0;
      }
      else{
        type = 1;
      }

      this.$utils.likeOrCancelLikeImageLib(this.preview_imageId,type,()=>{
        this.preview_likeStatus = type;
        if(this.preview_likeStatus === 1){
          //toast
          this.$store.state.snackbarType = 'success';
          this.$store.state.snackbarText = '收藏成功'
          this.$store.state.snackbarShow = true;
        }
        else{
          //toast
          this.$store.state.snackbarType = 'success';
          this.$store.state.snackbarText = '取消收藏成功'
          this.$store.state.snackbarShow = true;
        }

      })
    },
    //分享影像集
    shareImage(){
      this.$utils.shareImageLib(this.preview_imageId,this.preview_title,()=>{
        //toast
        this.$store.state.snackbarType = 'success';
        this.$store.state.snackbarText = '分享链接复制成功'
        this.$store.state.snackbarShow = true;
      })

    },

    //已下架的影像集，显示提示弹窗
    showFolderStopDialog(param){
      this.stopFolderId = param;

      this.$axios({
        method:"get",
        url:"/authorApi/z-image-collection/getById",
        params:{
          mainId:param,
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.stopFolderBuyStatus = resultData.data.buyStatus;
          this.folderStopDialogShow = true;
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });


    },

    //查看已停用影像集详情
    intoStopImageDetailPage(){
      let routeData = this.$router.resolve({
        path: '/productDetails', query: { mainId: this.stopFolderId }
      });
      window.open(routeData.href, '_blank');
    },

    //再次下载已下架的影像集
    downloadStopImage(){
      if(this.stopFolderBuyStatus === 1){
        //购买过下载
        this.downloadMainId = this.stopFolderId
        this.$store.state.showDownloadProductsDialog = true;
      }
      else{
        this.folderNotBuyToastShow = true;
        setTimeout(()=>{
          this.folderNotBuyToastShow = false;
        },2000)
      }
    },


    /******************************************************************************************************************/
    /*球操作 录屏*/
    /*更多标记和场景相关功能在混入文件中*/

    //地球飞到搜索结果位置
    flyToPosition(param){
      this.map.flyTo({
        center: [JSON.parse(param).lng,JSON.parse(param).lat],
        zoom: 13
      })

      // if(this.map.getLayer("positionMapIcon") !== undefined){
      //   this.map.removeLayer("positionMapIcon");
      //   this.map.removeSource("positionMapIcon");
      // }
      // this.map.addSource('positionMapIcon', {
      //   type: 'geojson',
      //   data: {
      //     'type': 'FeatureCollection',
      //     'features': [{
      //       type: 'Feature',
      //       geometry: {
      //         type: 'Point',
      //         coordinates: [JSON.parse(param).lng, JSON.parse(param).lat]
      //       },
      //       //使用图片做point
      //       properties: {
      //         icon: "positionIcon",
      //       },
      //     }]
      //   }
      // });
      // this.map.addLayer({
      //   id: 'positionMapIcon',
      //   type: 'symbol',
      //   source: 'positionMapIcon',
      //   layout: {
      //     "icon-image": ["get", "icon"],
      //     // "icon-size": 0.25
      //   }
      // });

    },

    // //清除地图上的定位icon
    // clearPositionMapIcon(){
    //   if(this.map.getLayer("positionMapIcon") !== undefined){
    //     this.map.removeLayer("positionMapIcon");
    //     this.map.removeSource("positionMapIcon");
    //   }
    // },


    /******************************************************************************************************************/

    //播放新手引导视频  更换视频njh
    playFirstGuideVideo(){
      this.fullScreenVideoSrc = "https://market.obs.cn-north-4.myhuaweicloud.com/webGuide/web/shouye.mp4";
      this.fullScreenVideoOrigin = "bottom left"
      this.fullScreenVideoShow = true;
      this.fullScreenVideoVIf = true;
    },


    firstGuideDialog(){
      //第一次进入展示添加视野说明
      if(window.localStorage.getItem('authorFirstOpen') === null){
        this.firstGuideDialogShow = true;
        window.localStorage.setItem('authorFirstOpen',"1")
      }
    },


    /******************************************************************************************************************/

    //左侧栏销毁时，地图相应操作
    leftBarDestroy(leftBarName){
      switch(leftBarName){
        case "imageLib":{
          //影像库栏，隐藏地图上全部marker，地图回到初始视野，退出预览
          if(this.imageMarkerShow){
            this.imageMarkerList = [];
            this.imageMarkerShow = false;
          }
          if(this.folderMarkerShow){
            this.folderMarkerList = [];
            this.folderMarkerShow = false;
          }
          this.map.flyTo({
            center:this.initCenter,
            zoom:this.initZoom,
            bearing:0,
            pitch:0
          })

          if(this.$store.state.imagePreviewShow){
            this.$store.state.imagePreviewShow = false;


            // //隐藏预览区域，清除图层，清除最大视野范围
            // if(this.map.getLayer("imagePreviewLayer") !== undefined){
            //   this.map.removeLayer("imagePreviewLayer");
            //   this.map.removeSource("imagePreviewLayer");
            // }
            //
            // this.map.setMaxBounds(null);
            //
            // this.preview_imageId = "";
            // this.preview_globeOldStatus = {}
          }


          break;
        }
        case "globeOperation":{
          //地球操作栏，隐藏地球上icon，地球回到详情页
          if(this.map.getLayer("positionMapIcon") !== undefined){
            this.map.removeLayer("positionMapIcon");
            this.map.removeSource("positionMapIcon");
          }
          this.map.flyTo({
            center:this.initCenter,
            zoom:this.initZoom,
            bearing:0,
            pitch:0
          })
          //隐藏方法
         this.changeLeftBarToOthers()
          break;
        }
        case "like":case "download":{
          //收藏栏，隐藏地图上全部marker，地图回到初始视野，退出预览
          if(this.imageMarkerShow){
            this.imageMarkerList = [];
            this.imageMarkerShow = false;
          }
          this.map.flyTo({
            center:this.initCenter,
            zoom:this.initZoom,
            bearing:0,
            pitch:0
          })

          if(this.$store.state.imagePreviewShow){
            this.$store.state.imagePreviewShow = false;

            // //隐藏预览区域，清除图层，清除最大视野范围
            // if(this.map.getLayer("imagePreviewLayer") !== undefined){
            //   this.map.removeLayer("imagePreviewLayer");
            //   this.map.removeSource("imagePreviewLayer");
            // }
            //
            // this.map.setMaxBounds(null);
            //
            // this.preview_imageId = "";
            // this.preview_globeOldStatus = {}
          }


          break;
        }
        case "globeScene":{
          //地球录制栏，隐藏地图上全部icon等，地图回到初始视野等
          //注意：录制文件不清空

          //如果当前在预览状态，停止地球预览效果
          this.destroyedStopPreviewFun();

          //隐藏视野点icon
          this.$store.state.sceneViewMarkerShow = false;

          //隐藏弹窗
          this.$store.state.sceneViewPointAreaShow = false;

          this.isMaterialShow(()=>{
            this.$store.state.currChooseSceneItemId = "";
            this.$store.state.currChooseSceneItemIndex = "";
            this.$store.state.sceneList = [];
            this.$store.state.tempMaterialInfo = {
              materialList:[],
              materialMarkerData:this.$store.state.defaultMaterialMarkerData
            };
            //隐藏素材相关icon
            this.clearMaterialMarkerLayer()
          })


          this.$store.state.currChooseViewItemId = "";
          this.$store.state.currChooseViewItemIndex = "";
          //清空点位添加过程
          this.$store.state.scenePointEditing = false;
          this.$store.state.sceneOperationState_addViewPointGuideState = "";
          this.$store.state.sceneOperationState_addViewPointRecommendedAnimationShow = false;
          this.$store.state.sceneOperationLayerState = ""
          this.$store.state.sceneViewMarkerSelectingShow = false;
          //视野点栏折叠，自动打开
          if(!this.viewPointerListOpen){
            this.changeViewPointerListOpenState()
          }

          this.$store.state.sceneItemDragging = false;
          this.$store.state.tempSceneList = [];
          this.$store.state.sceneItemMultipleChoosing = false;
          this.$store.state.sceneItemMultipleChoosingList = [];

          this.$store.state.tempViewPointList = [];
          this.$store.state.tempSceneZoomBasis = "";

          this.map.flyTo({
            center:this.initCenter,
            zoom:this.initZoom,
            bearing:0,
            pitch:0
          })

          break;
        }
        case "myFolder":{
          //我的文件，地图回到初始视野，其他各种销毁操作````````````
          // todo: 需要判断当前是不是按了编辑按钮，如果按了编辑按钮则不flyTo初始位置，否则flyTo初始位置
          // this.map.flyTo({
          //   center:this.initCenter,
          //   zoom:this.initZoom,
          //   bearing:0,
          //   pitch:0
          // })
          this.hideXztLayers()

          break;
        }
        case "myAiTripFolder":{
          //我的文件，地图回到初始视野，其他各种销毁操作````````````
          // todo: 需要判断当前是不是按了编辑按钮，如果按了编辑按钮则不flyTo初始位置，否则flyTo初始位置
          // this.map.flyTo({
          //   center:this.initCenter,
          //   zoom:this.initZoom,
          //   bearing:0,
          //   pitch:0
          // })
          this.hideXztLayers()

          break;
        }

      }





    },
    hideXztLayers() {
      let sourcesXzt = ['markerLayer_xzt','polygonPointLayer_xzt','polygonNameLayer_xzt','polygonLayer_xzt','polygonLenLayer_xzt','polygonLenLayer_xzt','polygonNameLayer_xzt','polygonLayer_xzt','polygonNameLayer_xzt','circleRadiusPoint_xzt','polygonLayer_xzt','roadPointLayer_xzt','roadNamePoint_xzt','roadLayer_xzt','linePointLayer_xzt','lineNamePoint_xzt','lineLayer_xzt','polygonLayer_xzt','polygonNameLayer_xzt']
      let layersXzt = ['markerList2_xzt','lineNamePoint_xzt','linePointLayer_xzt','linePointSymbol_xzt','lineLayer_xzt','roadNamePoint_xzt','roadPointLayer_xzt','roadPointSymbol_xzt','roadLayer_xzt','circleRadiusPoint_xzt','polygonNameLayer_xzt','polygonPointLayer_xzt','polygonPointSymbol_xzt','polygonLenLayer_xzt','polygonLineLayer_xzt','polygonLayer_xzt','measurePoints_xzt','measureLine_xzt','measureLineName_xzt','measureAreaLayer_xzt','measureAreaLineLayer_xzt','measureAreaPointLayer_xzt','measureAreaNameLayer_xzt']
      layersXzt.forEach((layerName) => {
        this.map.setLayoutProperty(layerName, 'visibility','none')
      })
    },


    //浏览器缩放方法
    windowResize(){
      // this.smallGlobeMap.remove();
      // this.initSmallGlobeMap(this.map.getCenter());
    },
    flyToMyFolderFirstMarker(geo, type) {
      this.flyToFolderFirstMarker(geo, type)
    },
    showMyFolderEditIcon(fileInfo) {
      this.editCurrFileInfo = fileInfo // 用到的属性包括 文件属性 团队权限 文件id等
      this.editFileIconShow = true
      this.clearPrevData()
      this.openFolderById_xzt(this.editCurrFileInfo['fileId'])
    },
    hideMyFolderEditIcon() {
      this.editFileIconShow = false
    },
    editFileInfo() {
      this.mainArea = 'globeOperation'
      this.mainAreaBottomType = 'globeOperation'
      // 这里操作展示对应的标记创作
      nextTick(() => {
        this.$refs.mainGlobeOperation.openFolderById(this.editCurrFileInfo['fileId'])
        this.hideMyFolderEditIcon()
      })
    },
    editAiTripInfo() {
      this.mainArea = 'globeOperation'
      this.mainAreaBottomType = 'globeOperation'
      const formData = new FormData()
      formData.append('fileId', this.editCurrFileInfo['fileId'])
      this.$axios({
        method: 'post',
        url: '/authorApi/z-geo-file/editTripFile',
        data: formData
      }).then((resp) => {
        resp = resp.data
        if (resp.status === 200) {
          this.$refs.mainGlobeOperation.openFolderById(resp.data)
          this.hideMyFolderEditIcon()
        }
      })
    },
    openAiTripWebsite() {
      const baseUrl = new URL(window.location.href).origin
      window.open(`${baseUrl}/plugin/travelPlanSharePage?planningId=${this.editCurrFileInfo['tripId']}`)
      // window.open(`${window.location.protocol} + '//' + ${window.location.host}/plugin/travelPlanSharePage?planningId=${this.editCurrFileInfo['tripId']}`)
      // console.log(baseUrl)
      // console.log(`${window.location.protocol}//${window.location.host}`)
    },
    setOriginalPositionAndClearLayers() {
      this.flyToOriginalPositionAndClearLayers()
      // this.clearExistingData('')
      this.clearPrevData()
      console.log('hide icon')
      this.hideMyFolderEditIcon()
    },
    goToMyFolder() {
      this.mainArea = 'myFolder'
    },
    deleteTokenFromUrl(){
      delete this.$route.query.userToken
      let url = window.location.origin + window.location.pathname
      let paramNum = 0;
      for (let key in this.$route.query) {
        if(paramNum === 0){
          //第一个其他参数
          url = url + '?' + key + '=' + this.$route.query[key]
        }
        else{
          url = url + '&' + key + '=' + this.$route.query[key]
        }
        paramNum ++;
      }
      window.history.replaceState('', '', url)
    }
  },
  mounted(){
    console.log('globe mounted')
    //球页面不需要浏览器滚动条
    document.getElementsByTagName("html")[0].setAttribute("style","overflow:hidden");

    let temp = setInterval(()=>{
      if(this.$store.state.mapboxTokenIndex && this.$store.state.getLayerListInit){
        this.initMapbox();
        // this.initSmallGlobeMap(this.initCenter);
        this.initSceneFullMap();
        clearInterval(temp)
      }
    })

    this.deleteTokenFromUrl()
    //监听浏览器缩放，重新加载小地球，避免小地球放大后移位
    // window.addEventListener("resize", this.windowResize);

    //判断页面访问来源，影响页面效果
    if(this.$route.query.source){
      switch(this.$route.query.source){
        case "windowsMark":{
          this.$store.state.openSource = "windows";
          break;
        }
        case "windowsScene":{
          this.mainArea = "globeScene";
          this.$store.state.openSource = "windows";
          break;
        }

      }
    }


  },
  destroyed() {
    //退出球页面，需要浏览器滚动条
    document.getElementsByTagName("html")[0].setAttribute("style","overflow:auto");

    // window.removeEventListener("resize", this.windowResize);

    //离开了球页面，再次进入时标记等需要重新加载
    this.$store.state.initGlobeOperationMarker = false;
  }

}
</script>

<style scoped>

.leftBarTabItem{
  line-height:60px;
  text-align:center;
  font-size:22px;
  color:#ffffff;
  cursor:pointer;
}
.leftBarTabItem:hover{
  background:#333333 !important;
}


.leftBarTabItem_new{
  line-height:50px;
  text-align:center;
  font-size:18px;
  color:#ffffff;
  cursor:pointer;
}
.leftBarTabItem_bottomType{
  position:relative;
  width:100%;
  height:60px;
  display:flex;
  align-items:center;
  justify-content:center;
  cursor: pointer;
}



.mapboxInfo{
  position:absolute;
  z-index:1;
  bottom:0;
  left:0;
  width:100%;
  height:25px;
  background:rgba(0,0,0,0.5);
  display:flex;
  color:#ffffff;
  font-size:12px;
}


.toolbar-item{
  position:absolute;
  width:40px;
  height:40px;
  background:#383838;
  border-radius:50%;
  cursor:pointer;
  text-align:center;
}
.toolbar-item:hover{
  background:#595959;
}


/*全屏按钮*/
.globeFullScreenBtn{
  position:absolute;
  top:25px;
  right:25px;
  width:40px;
  height:40px;
  background:#383838;
  border-radius:50%;
  cursor:pointer;
  text-align:center;
}
.globeFullScreenBtn:hover{
  background:#595959;
}



.changeLayerItem{
  position:relative;
  width:100%;
  height:75px;
  /*border:2px solid #315D8E;*/
  border-radius:4px;
  /*margin-bottom:10px;*/
  background-size:cover;
  background-position: center;
  font-size:13px;
  color:#ffffff;
  cursor:pointer;
}
.changeLayerItem-layerText{
  position:absolute;
  bottom:0;
  right:0;
  /*height:20px;*/
  border-radius:4px 0 4px 0;
  padding:0 4px;
  text-align:center;
}
.changeLayerItem-layerText p{
  line-height:18px;
}
.changeLayerItem-roadBtn{
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:20px;
  background:rgba(0, 0, 0, 0.6);
}




/*!*场景列表*!*/
/*.globeOperationSceneItem{*/
/*  width:calc(100% - 20px);*/
/*  margin:0 auto;*/
/*  border-radius:8px;*/
/*  padding:12px 14px 12px 14px;*/
/*  font-size:14px;*/
/*}*/
/*.globeOperationSceneItem:hover{*/
/*  !*background:#2E2D2D !important;*!*/
/*  border:1px solid #2A82E4;*/
/*}*/
/*.globeOperationSceneItem-baseInfo{*/
/*  display:flex;*/
/*  align-items:center;*/
/*}*/
/*.globeOperationSceneItem-deleteBtn{*/
/*  margin-right:3px;*/
/*  display:none;*/
/*  cursor:pointer;*/
/*}*/
/*.globeOperationSceneItem:hover .globeOperationSceneItem-deleteBtn{*/
/*  display:block;*/
/*}*/

.globeOperationSceneItem-baseInfo-panelBtn{
  height:24px;
  padding:0 5px;
  border-radius:4px;
  text-align:center;
  cursor:pointer;
}
.globeOperationSceneItem-baseInfo-panelBtn:hover{
  background:#383838!important;
}


/*编辑场景名称*/
.editSceneNameTextField{
  padding-top:0;
  margin-top:0;
  font-size:14px;
}




/* 录屏 切换动画蒙层 */

.animationAllScreenMantle {
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;
  opacity:1;
  /*z-index:999;*/
  /*animation-name: blackToTransparent;*/
  /*animation-duration: 1s;*/
  background-position:center;
  background-size:cover;
}

.animationAllScreenMantleCenter{
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  width:100%;
  height:100%;
  opacity:1;
  /*z-index:999;*/
  /*animation-name: blackToTransparent;*/
  /*animation-duration: 1s;*/
  background-position:center;
  background-size:cover;
}


.animationWindowMantle{
  position:absolute;
  left:0;
  width:100%;
  /*height:calc((100% - 25px) * 0.1);*/
  height:10%;
  /*background:rgba(0,0,0,1);*/
  /*background-size:cover;*/
  background-repeat:no-repeat;
  background-attachment: fixed;
  animation-name: windowClose;
  /*animation-duration: 2s;*/
  background:#ffffff;
}

.propertiesEditCard::-webkit-scrollbar{
  width: 3px;
  height: 3px;
}
.propertiesEditCard::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
  border-radius: 5px;
  /*-webkit-box-shadow: inset 0 0 5px #fafafa;*/
  background: rgba(128, 128, 128, 1);
}

.propertiesEditCard::-webkit-scrollbar-track { /*滚动条里面轨道*/
  /*-webkit-box-shadow: inset 0 0 5px #fafafa;*/
  border-radius: 0;
  background: rgba(56, 56, 56, 1);
}


/**录制*********************************************************************************/
.viewItem{
  width:calc(100% - 20px);
  height:100%;
  border-radius:5px;
  margin-left:8px;
  padding:0 11px 0 9px;
  display:flex;
  align-items: center;
  cursor:pointer;
}
.viewItem:hover{
  border:1px solid #00B3FF!important;
}

.viewItem-btn{
  margin-left:4px;
  display:none;
  cursor:pointer;
}
.viewItem:hover .viewItem-btn{
  display:block;
}

.addViewPointBtn{
  width:calc(100% - 20px);
  height:100%;
  margin:0 auto;
  border:1px dashed rgba(128, 128, 128, 1);
  border-radius:5px;
  text-align:center;
  color:#a6a6a6;
  cursor:pointer;
}
.addViewPointBtn:hover{
  color:#ffffff;
  border:1px dashed #ffffff;
}


/*编辑视野点名称*/
.editViewItemNameTextField{
  padding-top:0;
  margin-top:-1px;
  font-size:16px;
}


/*素材*/
.materialItem{
  width:100%;
  height:100%;
  padding:0 22px 0 24px;
  margin-bottom:1px;
  border-top:1px solid transparent;
  border-bottom:1px solid transparent;
  display:flex;
  align-items: center;
  cursor:pointer;
}
.materialItem:hover{
  border-top:1px solid #00B3FF;
  border-bottom:1px solid #00B3FF;
}
.materialItem-btn{
  margin-left:14px;
  line-height:35px;
  font-size:16px;
  display:none;
  cursor:pointer;
}
.materialItem:hover .materialItem-btn{
  display:block;
}

.addMaterialBtn{
  width:calc(100% - 20px);
  height:100%;
  margin:0 auto;
  border:1px dashed rgba(128, 128, 128, 1);
  border-radius:5px;
  text-align:center;
  cursor:pointer;
}
.addMaterialBtn:hover{
  color:#ffffff;
  border:1px dashed #ffffff;
}

/*编辑视野点名称*/
.editMaterialItemNameTextField{
  padding-top:0;
  margin-top:-1px;
  font-size:14px;
}


/*素材显示设置 时间尺*/
.setMaterialRangeSlider{
  position:absolute;
  top:0;
  left:13px;
  width:calc(100% - 26px);
}

</style>

<style>
/*图层选择*/
.changeLayerItem-roadBtn .v-input--selection-controls__input{
  width:10px;
  height:10px;
  margin-left:8px;
  margin-right:6px;
}
.changeLayerItem-roadBtn .v-input--selection-controls__ripple{
  width:0 !important;
  height:0 !important;
}
.changeLayerItem-roadBtn .v-label{
  font-size:13px;
  color:#ffffff;
}
/*编辑场景名称*/
.editSceneNameTextField .v-input__slot:before{
  border:none !important;
}
.editSceneNameTextField .v-input__slot:after{
  border:none !important;
}
/* 录屏 切换动画代码 */   /*写在scoped中不能动态绑定*/
@keyframes blackToTransparent {
  from {height:100%;opacity:1;}
  to {height:100%;opacity:0;}
}
@keyframes height100To0 {
  from {height:100%; opacity:1;}
  to {height:0;opacity:0;}
}
@keyframes allScreenToCenter {
  from {width:100%;height:100%; opacity:1;}
  to {width:0;height:0;opacity:0;}
}
@keyframes windowClose {
  from {height:9%;}
  to {height:0;}
}


@keyframes mapOpacityChange {
  0% {opacity:1;}
  45% {opacity:0.02;}
  55% {opacity:0.02;}
  100% {opacity:1;}
}
@keyframes mapTopChange {
  0% {top:0;opacity:1;}
  45% {top:-100%;opacity:0.02;}
  55% {top:-100%;opacity:0.02;}
  100% {top:0;opacity:1;}
}
@keyframes mapSizeChange {
  0% {width:100%;height:100%;opacity:1;top:50%;left:50%;transform:translate(-50%,-50%);}
  45% {width:0;height:0;opacity:0.02;top:50%;left:50%;transform:translate(-50%,-50%);}
  55% {width:0;height:0;opacity:0.02;top:50%;left:50%;transform:translate(-50%,-50%);}
  100% {width:100%;height:100%;opacity:1;top:50%;left:50%;transform:translate(-50%,-50%);}
}



/*属性编辑中的文本输入框*/
.jumpTextField .v-input__slot{
  min-height: 20px !important;
  padding: 0 !important;
  margin: 0 !important;
}
.v-text-field{
  margin-top: 0 !important;
}
.circleRadiusText .v-input__slot{
  min-height: 20px !important;
  padding: 0 5px !important;
  margin: 0 !important;
}
.circleRadiusText .v-text-field__details{
  margin-bottom: 0 !important;
}
/*属性编辑中的点位信息编辑的扩展面板*/
.expansionPanels .v-expansion-panel-header{
  padding: 0 5px 0 10px !important;
  min-height: 30px !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
.expansionPanels .v-expansion-panel-content__wrap{
  padding: 0 0 !important;
}
.globeSetItem{
  width:100%;
  height:43px;
  padding: 0 19px 0 12px;
  border:1px solid #515152;
  border-radius:4px;
  background:#3D3D3E;
  display:flex;
  align-items: center;
}
.globeSetItem .v-input--switch__thumb{
  background:#ffffff
}
.globeSetItem .v-input--switch__track{
  opacity:1;
}
.globeSetItem-sliderInput .v-input__slot{
  min-height:0 !important;
}
.globeSetItem-slider .v-slider__thumb:before{
  width:0;
  height:0;
}
/*elemeng UI 的select组件样式修改*/
.select_btn .el-input__inner{
    color:white !important;
  font-size: 14px !important;
    padding: 0 20px 0 2px !important;
    background-color: rgba(56, 56, 56, 1) !important;
    /*height: 30px !important;*/
}
  .select_btn .el-select-dropdown{
    background-color:  rgba(56, 56, 56, 1) !important;
    width: 86px !important;
    margin-top: 5px !important;
  }

  .select_btn .el-select-dropdown__item{
    color: white !important;
    text-align: center !important;
  }
  .select_btn .el-select-dropdown__item.hover,.el-select-dropdown__item:hover{
    background-color: rgba(32, 81, 138, 1) !important;
  }
  .select_btn .el-select-dropdown__list{
    padding: 5px 0 !important;
  }
  .select_btn .el-popper .popper__arrow{

  }


/**消息滚动动画*********************************************************************************/

@keyframes messageQueue_center {
  from {bottom:0;opacity: 1}
  to {bottom:59px;opacity: 0.5}
}
@keyframes messageQueue_top {
  from {bottom:59px;opacity: 0.5}
  to {bottom:108px;opacity: 0}
}


  /**录制*********************************************************************************/
  @keyframes sceneOperationGuide_top {
    from {top:29px;}
    to {top:20px;}
  }
  @keyframes sceneOperationGuide_bottom {
    from {bottom:17px;}
    to {bottom:8px;}
  }

  /*编辑视野点名称*/
  .editViewNameTextField .v-input__slot:before{
    border:none !important;
  }
  .editViewNameTextField .v-input__slot:after{
    border:none !important;
  }

  /*素材显示设置 显示时间尺*/
  /*轨道*/
  .setMaterialRangeSlider .v-slider__track-container{
    height:35px;
    background:linear-gradient(0deg,rgba(11, 120, 227, 0.1) 0%, rgba(11, 120, 227, 0.35) 100%);
    border-top:2px solid rgba(255, 255, 255, 0.15);
  }
  .setMaterialRangeSlider .v-slider__track-fill{
    background:linear-gradient(180deg, rgba(233, 44, 129, 0.1) 0%, rgba(233, 44, 129, 0.35) 100%)!important;
    border-left:2px solid #FF2366!important;
    border-right:2px solid #FF2366!important;
    border-bottom:2px solid #FF2366!important;
    margin-left: -2px;
  }
  .setMaterialRangeSlider .v-slider__track-background{
    background:transparent!important;
  }
  /*滑块*/
  .setMaterialRangeSlider .v-slider__thumb-container{
    top:100%;
  }
  .setMaterialRangeSlider .v-slider .v-slider__thumb-container:nth-last-child(2) .v-slider__thumb{
    width:18px;
    height:25px;
    left:-18px;
    border-radius:4px;
    clip-path: polygon(0 100%, 100% 100%, 100% 0);
  }
  .setMaterialRangeSlider .v-slider .v-slider__thumb-container:nth-last-child(1) .v-slider__thumb{
    width:18px;
    height:25px;
    left:-2px;
    border-radius:4px;
    clip-path: polygon(0 0, 0 100%, 100% 100%);
  }
  .setMaterialRangeSlider .v-slider__thumb::before{
    display:none;
  }


  /*刻度线*/
  .setMaterialRangeSlider .v-slider .v-slider__ticks-container{
    height:100%;
  }
  .setMaterialRangeSlider .v-slider .v-slider__ticks-container .v-slider__tick{
    width:1px !important;
    height:100% !important;
    top:0 !important;
    background:rgba(255,255,255,0.15);
  }
  .setMaterialRangeSlider .v-slider .v-slider__ticks-container .v-slider__tick::before{
    content: "";
    width: 4px;
    height: 6px;
    background: #ffffff;
    border-radius: 50%;
    position: absolute;
    top: -3px;
    left: -2px;
  }
  .setMaterialRangeSlider .v-slider .v-slider__ticks-container .v-slider__tick:first-child::before{
    left: -2px;
  }


  /*多选框*/
  .setMaterialCheckbox .v-input--selection-controls__ripple{
    display:none;
  }
  .setMaterialCheckbox .v-icon{
    font-size:18px;
  }


</style>
